
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const ChatGptListingStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED'
} as const

export type ChatGptListingStatus = (typeof ChatGptListingStatus)[keyof typeof ChatGptListingStatus]


export const ChatGptMediaType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  MODEL_3D: 'MODEL_3D'
} as const

export type ChatGptMediaType = (typeof ChatGptMediaType)[keyof typeof ChatGptMediaType]


export const ChatGptProductFieldType = {
  title: 'title',
  description: 'description',
  link: 'link',
  product_category: 'product_category',
  condition: 'condition',
  brand: 'brand',
  material: 'material',
  length: 'length',
  width: 'width',
  height: 'height',
  weight: 'weight',
  age_group: 'age_group'
} as const

export type ChatGptProductFieldType = (typeof ChatGptProductFieldType)[keyof typeof ChatGptProductFieldType]


export const ChatGptVariantFieldType = {
  sku: 'sku',
  price: 'price',
  sale_price: 'sale_price',
  sale_price_effective_date: 'sale_price_effective_date',
  unit_pricing_measure: 'unit_pricing_measure',
  base_measure: 'base_measure',
  pricing_trend: 'pricing_trend',
  color: 'color',
  size: 'size',
  size_system: 'size_system',
  gender: 'gender',
  offer_id: 'offer_id',
  custom_variant1_category: 'custom_variant1_category',
  custom_variant1_value: 'custom_variant1_value',
  custom_variant2_category: 'custom_variant2_category',
  custom_variant2_value: 'custom_variant2_value',
  custom_variant3_category: 'custom_variant3_category',
  custom_variant3_value: 'custom_variant3_value'
} as const

export type ChatGptVariantFieldType = (typeof ChatGptVariantFieldType)[keyof typeof ChatGptVariantFieldType]


export const BillingAutomation = {
  Auto: 'Auto',
  Manual: 'Manual'
} as const

export type BillingAutomation = (typeof BillingAutomation)[keyof typeof BillingAutomation]


export const BillingFailureMode = {
  Allow: 'Allow',
  Restrict: 'Restrict'
} as const

export type BillingFailureMode = (typeof BillingFailureMode)[keyof typeof BillingFailureMode]


export const BalanceTransactionType = {
  MarketplacePayout: 'MarketplacePayout',
  AcpPayment: 'AcpPayment'
} as const

export type BalanceTransactionType = (typeof BalanceTransactionType)[keyof typeof BalanceTransactionType]


export const BillType = {
  Shipping: 'Shipping',
  ReturnShipping: 'ReturnShipping',
  Software: 'Software'
} as const

export type BillType = (typeof BillType)[keyof typeof BillType]


export const BillStatus = {
  Open: 'Open',
  Closed: 'Closed',
  Paid: 'Paid',
  Void: 'Void',
  Refunded: 'Refunded',
  PartiallyRefunded: 'PartiallyRefunded'
} as const

export type BillStatus = (typeof BillStatus)[keyof typeof BillStatus]


export const BillingChargeType = {
  Coverage: 'Coverage',
  Return: 'Return',
  ShippingLabel: 'ShippingLabel',
  Subscription: 'Subscription',
  Campaign: 'Campaign',
  OrderTracking: 'OrderTracking',
  CheckoutOptimization: 'CheckoutOptimization',
  Recover: 'Recover',
  Credit: 'Credit'
} as const

export type BillingChargeType = (typeof BillingChargeType)[keyof typeof BillingChargeType]


export const BillingChargeSubtype = {
  ReturnCoverage: 'ReturnCoverage',
  PackageProtectionPlus: 'PackageProtectionPlus',
  FinalSaleReturnCoverage: 'FinalSaleReturnCoverage',
  ExtendedWarranty: 'ExtendedWarranty',
  UpsellRevenue: 'UpsellRevenue',
  UpsellRevenueRefunded: 'UpsellRevenueRefunded',
  ManagedClaimCredit: 'ManagedClaimCredit',
  RedoManagedReturnsCoverage: 'RedoManagedReturnsCoverage',
  InstantExchangeRecovery: 'InstantExchangeRecovery',
  InstantRefund: 'InstantRefund',
  RepairFeeCredit: 'RepairFeeCredit',
  CoverageRefundForCancelledOrder: 'CoverageRefundForCancelledOrder',
  CancelledOrderPackageProtectionPlusRefund: 'CancelledOrderPackageProtectionPlusRefund',
  DeniedClaimPackageProtectionPlusRefund: 'DeniedClaimPackageProtectionPlusRefund',
  CancelledOrderFinalSaleReturnCoverageRefund: 'CancelledOrderFinalSaleReturnCoverageRefund',
  CancelledOrderExtendedWarrantyRefund: 'CancelledOrderExtendedWarrantyRefund',
  CancelledOrderInstantExchangeRecovery: 'CancelledOrderInstantExchangeRecovery',
  FinalSaleCredit: 'FinalSaleCredit',
  CarrierClaimRefund: 'CarrierClaimRefund',
  ExchangeShippingCredit: 'ExchangeShippingCredit',
  PerOrder: 'PerOrder',
  PerSms: 'PerSms',
  PerEmail: 'PerEmail',
  OrderTracking: 'OrderTracking',
  MerchantCoveredLabel: 'MerchantCoveredLabel',
  Damaged: 'Damaged',
  WrongProduct: 'WrongProduct',
  MerchantCarrierLabelCredit: 'MerchantCarrierLabelCredit',
  ShippingCostShare: 'ShippingCostShare',
  CustomerPaidLabel: 'CustomerPaidLabel',
  PerReturnFee: 'PerReturnFee',
  ReturnsProcessingFee: 'ReturnsProcessingFee',
  ReturnFraudPrevention: 'ReturnFraudPrevention',
  PointOfSale: 'PointOfSale',
  PerRecycleRequestFee: 'PerRecycleRequestFee',
  ReFulfillmentRevenueShare: 'ReFulfillmentRevenueShare',
  PerExchangePayoutFee: 'PerExchangePayoutFee',
  MerchantCreatedReturnLabel: 'MerchantCreatedReturnLabel',
  PackagePickup: 'PackagePickup',
  CarrierPickup: 'CarrierPickup',
  CanceledReturnLabelRefund: 'CanceledReturnLabelRefund',
  CanceledPickupRefund: 'CanceledPickupRefund',
  OutboundLabel: 'OutboundLabel',
  ReturnLabelAdjustment: 'ReturnLabelAdjustment',
  ImplementationFee: 'ImplementationFee',
  CardProcessingFee: 'CardProcessingFee',
  ManualAdjustment: 'ManualAdjustment',
  ManualRefund: 'ManualRefund',
  VoidLabel: 'VoidLabel',
  VoidUsedLabel: 'VoidUsedLabel',
  ChargeLabel: 'ChargeLabel',
  Refund: 'Refund',
  Miscellaneous: 'Miscellaneous',
  Surcharge: 'Surcharge',
  ReturnLabel: 'ReturnLabel',
  MerchantCarrierFee: 'MerchantCarrierFee',
  SubscriptionFee: 'SubscriptionFee',
  RedeemPoints: 'RedeemPoints',
  Insurance: 'Insurance',
  VoidInsurance: 'VoidInsurance',
  TransactionFailureClawback: 'TransactionFailureClawback',
  WmsFee: 'WmsFee',
  RedoSupply: 'RedoSupply',
  LandedCostDuties: 'LandedCostDuties',
  LandedCostTaxes: 'LandedCostTaxes',
  LandedCostFees: 'LandedCostFees',
  VoidLandedCostDuties: 'VoidLandedCostDuties',
  VoidLandedCostTaxes: 'VoidLandedCostTaxes',
  VoidLandedCostFees: 'VoidLandedCostFees',
  FreightPurchase: 'FreightPurchase',
  VoidFreightPurchase: 'VoidFreightPurchase'
} as const

export type BillingChargeSubtype = (typeof BillingChargeSubtype)[keyof typeof BillingChargeSubtype]


export const SubscriptionProduct = {
  MarketingSms: 'MarketingSms',
  MarketingEmail: 'MarketingEmail',
  OrderTracking: 'OrderTracking',
  ReturnAiExchange: 'ReturnAiExchange',
  Returns: 'Returns',
  CheckoutOptimization: 'CheckoutOptimization',
  Aeo: 'Aeo',
  Ims: 'Ims',
  ImsForecasting: 'ImsForecasting',
  Recover: 'Recover',
  SupportBase: 'SupportBase',
  SupportAi: 'SupportAi',
  SupportSms: 'SupportSms',
  SupportVoice: 'SupportVoice',
  Oms: 'Oms',
  Wms: 'Wms'
} as const

export type SubscriptionProduct = (typeof SubscriptionProduct)[keyof typeof SubscriptionProduct]


export const CampaignChannel = {
  Sms: 'Sms',
  Mms: 'Mms',
  Email: 'Email'
} as const

export type CampaignChannel = (typeof CampaignChannel)[keyof typeof CampaignChannel]


export const TransactionStatus = {
  Pending: 'Pending',
  Success: 'Success',
  Failed: 'Failed'
} as const

export type TransactionStatus = (typeof TransactionStatus)[keyof typeof TransactionStatus]


export const BillingPeriod = {
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  Bimonthly: 'Bimonthly',
  Weekly: 'Weekly'
} as const

export type BillingPeriod = (typeof BillingPeriod)[keyof typeof BillingPeriod]


export const PaymentProvider = {
  Stripe: 'Stripe',
  Shopify: 'Shopify'
} as const

export type PaymentProvider = (typeof PaymentProvider)[keyof typeof PaymentProvider]


export const PaymentMethodType = {
  Card: 'Card',
  UsBankAccount: 'UsBankAccount',
  ShopifyAppSubscription: 'ShopifyAppSubscription'
} as const

export type PaymentMethodType = (typeof PaymentMethodType)[keyof typeof PaymentMethodType]


export const PaymentMethodPriority = {
  Primary: 'Primary',
  Secondary: 'Secondary',
  ShopifySubscription: 'ShopifySubscription',
  Deactivated: 'Deactivated'
} as const

export type PaymentMethodPriority = (typeof PaymentMethodPriority)[keyof typeof PaymentMethodPriority]


export const StripeAccountStatus = {
  Active: 'Active',
  Created: 'Created',
  Inactive: 'Inactive'
} as const

export type StripeAccountStatus = (typeof StripeAccountStatus)[keyof typeof StripeAccountStatus]


export const account_identifier_type = {
  email: 'email',
  phone: 'phone'
} as const

export type account_identifier_type = (typeof account_identifier_type)[keyof typeof account_identifier_type]


export const accounting_account_mapping_type_enum = {
  inventory_asset: 'inventory_asset',
  cogs: 'cogs',
  income: 'income',
  freight_expense: 'freight_expense',
  duty_expense: 'duty_expense',
  shrinkage: 'shrinkage',
  accounts_payable: 'accounts_payable',
  expense: 'expense',
  payment_account: 'payment_account'
} as const

export type accounting_account_mapping_type_enum = (typeof accounting_account_mapping_type_enum)[keyof typeof accounting_account_mapping_type_enum]


export const accounting_cost_method_enum = {
  fifo: 'fifo',
  weighted_average: 'weighted_average'
} as const

export type accounting_cost_method_enum = (typeof accounting_cost_method_enum)[keyof typeof accounting_cost_method_enum]


export const accounting_entity_type_enum = {
  purchase_order: 'purchase_order',
  supplier: 'supplier',
  adjustment_session: 'adjustment_session',
  shipment_receipt: 'shipment_receipt',
  fulfillment: 'fulfillment',
  return: 'return',
  product: 'product',
  transfer: 'transfer',
  transfer_order: 'transfer_order'
} as const

export type accounting_entity_type_enum = (typeof accounting_entity_type_enum)[keyof typeof accounting_entity_type_enum]


export const accounting_external_entity_type_enum = {
  bill: 'bill',
  vendor: 'vendor',
  journal_entry: 'journal_entry',
  purchase_order: 'purchase_order',
  item: 'item'
} as const

export type accounting_external_entity_type_enum = (typeof accounting_external_entity_type_enum)[keyof typeof accounting_external_entity_type_enum]


export const accounting_platform_enum = {
  quickbooks_online: 'quickbooks_online',
  xero: 'xero'
} as const

export type accounting_platform_enum = (typeof accounting_platform_enum)[keyof typeof accounting_platform_enum]


export const address_types = {
  commentsold: 'commentsold',
  shopify: 'shopify',
  commerce_cloud: 'commerce_cloud',
  bigcommerce: 'bigcommerce',
  netsuite: 'netsuite',
  manual: 'manual',
  tiktok: 'tiktok',
  amazon: 'amazon',
  walmart: 'walmart',
  ebay: 'ebay',
  apparel_magic: 'apparel_magic',
  redo_marketplace: 'redo_marketplace',
  sfom: 'sfom',
  aims360: 'aims360',
  cin7_omni: 'cin7_omni',
  cin7_core: 'cin7_core',
  redo_api: 'redo_api',
  custom_return_integration: 'custom_return_integration',
  redo: 'redo',
  faire: 'faire',
  wayfair: 'wayfair',
  custom: 'custom'
} as const

export type address_types = (typeof address_types)[keyof typeof address_types]


export const adjustment_type = {
  chooseItemsFlow: 'chooseItemsFlow',
  finalizeFlow: 'finalizeFlow',
  dynamicBundleAdjustment: 'dynamicBundleAdjustment',
  merchantManual: 'merchantManual',
  customerLabelUpchargeFee: 'customerLabelUpchargeFee',
  useItOrLoseIt: 'useItOrLoseIt'
} as const

export type adjustment_type = (typeof adjustment_type)[keyof typeof adjustment_type]


export const admin_return_workflow_status = {
  resolved: 'resolved',
  blocked: 'blocked',
  looking: 'looking'
} as const

export type admin_return_workflow_status = (typeof admin_return_workflow_status)[keyof typeof admin_return_workflow_status]


export const adyen_environment = {
  test: 'test',
  live: 'live'
} as const

export type adyen_environment = (typeof adyen_environment)[keyof typeof adyen_environment]


export const AeoMerchantOverrideType = {
  brand_alias: 'brand_alias',
  competitor_alias: 'competitor_alias',
  exclude: 'exclude'
} as const

export type AeoMerchantOverrideType = (typeof AeoMerchantOverrideType)[keyof typeof AeoMerchantOverrideType]


export const aeo_onboarding_run_status = {
  running: 'running',
  completed: 'completed',
  failed: 'failed'
} as const

export type aeo_onboarding_run_status = (typeof aeo_onboarding_run_status)[keyof typeof aeo_onboarding_run_status]


export const aeo_onboarding_step_key = {
  generate_brand_identity_guide: 'generate_brand_identity_guide',
  generate_prompts: 'generate_prompts',
  submit_brightdata: 'submit_brightdata',
  ingest_brightdata: 'ingest_brightdata',
  discover_competitors: 'discover_competitors',
  extract_mentions: 'extract_mentions'
} as const

export type aeo_onboarding_step_key = (typeof aeo_onboarding_step_key)[keyof typeof aeo_onboarding_step_key]


export const aeo_onboarding_step_status = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  completed: 'completed',
  failed: 'failed'
} as const

export type aeo_onboarding_step_status = (typeof aeo_onboarding_step_status)[keyof typeof aeo_onboarding_step_status]


export const AeoRecommendationCategory = {
  competitor_insight: 'competitor_insight',
  content_opportunity: 'content_opportunity',
  earned_media_action: 'earned_media_action',
  product_improvement: 'product_improvement',
  winning_strategy: 'winning_strategy'
} as const

export type AeoRecommendationCategory = (typeof AeoRecommendationCategory)[keyof typeof AeoRecommendationCategory]


export const AeoRecommendationFeedbackKind = {
  positive: 'positive',
  negative: 'negative'
} as const

export type AeoRecommendationFeedbackKind = (typeof AeoRecommendationFeedbackKind)[keyof typeof AeoRecommendationFeedbackKind]


export const AeoRecommendationPriority = {
  high: 'high',
  medium: 'medium',
  low: 'low'
} as const

export type AeoRecommendationPriority = (typeof AeoRecommendationPriority)[keyof typeof AeoRecommendationPriority]


export const agent_change_kind = {
  create: 'create',
  update: 'update',
  delete: 'delete'
} as const

export type agent_change_kind = (typeof agent_change_kind)[keyof typeof agent_change_kind]


export const agent_entity_type = {
  product: 'product',
  supplier: 'supplier',
  bom: 'bom'
} as const

export type agent_entity_type = (typeof agent_entity_type)[keyof typeof agent_entity_type]


export const agent_operation_type = {
  create_product: 'create_product',
  update_product: 'update_product',
  create_supplier: 'create_supplier',
  update_supplier: 'update_supplier',
  create_bom: 'create_bom',
  update_bom: 'update_bom'
} as const

export type agent_operation_type = (typeof agent_operation_type)[keyof typeof agent_operation_type]


export const agent_output_cache_kind = {
  customer_product_preference_insights: 'customer_product_preference_insights',
  customer_history_for_exchange_recommendations: 'customer_history_for_exchange_recommendations',
  personalized_exchange_recommendations: 'personalized_exchange_recommendations',
  personalized_exchange_recommendations_v2: 'personalized_exchange_recommendations_v2',
  product_image_context: 'product_image_context',
  prompt_activity_summary: 'prompt_activity_summary'
} as const

export type agent_output_cache_kind = (typeof agent_output_cache_kind)[keyof typeof agent_output_cache_kind]


export const agent_task_assignee_kind = {
  user: 'user'
} as const

export type agent_task_assignee_kind = (typeof agent_task_assignee_kind)[keyof typeof agent_task_assignee_kind]


export const agent_task_event_actor_kind = {
  user: 'user',
  system: 'system'
} as const

export type agent_task_event_actor_kind = (typeof agent_task_event_actor_kind)[keyof typeof agent_task_event_actor_kind]


export const agent_task_event_kind = {
  update_task: 'update_task',
  add_comment: 'add_comment'
} as const

export type agent_task_event_kind = (typeof agent_task_event_kind)[keyof typeof agent_task_event_kind]


export const agent_task_relationship_kind = {
  blocked_by: 'blocked_by'
} as const

export type agent_task_relationship_kind = (typeof agent_task_relationship_kind)[keyof typeof agent_task_relationship_kind]


export const agent_task_status = {
  todo: 'todo',
  in_progress: 'in_progress',
  blocked: 'blocked',
  complete: 'complete',
  canceled: 'canceled'
} as const

export type agent_task_status = (typeof agent_task_status)[keyof typeof agent_task_status]


export const ai_analytics_summary_page_type = {
  intent: 'intent',
  checkout_overview: 'checkout_overview',
  widgets: 'widgets',
  post_purchase: 'post_purchase',
  shipping_ai: 'shipping_ai'
} as const

export type ai_analytics_summary_page_type = (typeof ai_analytics_summary_page_type)[keyof typeof ai_analytics_summary_page_type]


export const ai_analyzed_file_source = {
  upload: 'upload',
  forward: 'forward'
} as const

export type ai_analyzed_file_source = (typeof ai_analyzed_file_source)[keyof typeof ai_analyzed_file_source]


export const ai_context_data_source = {
  hubspot: 'hubspot',
  slack: 'slack',
  askelephant: 'askelephant'
} as const

export type ai_context_data_source = (typeof ai_context_data_source)[keyof typeof ai_context_data_source]


export const ai_context_library_type = {
  MARKETING: 'MARKETING',
  SCENARIO: 'SCENARIO',
  VANGUARD: 'VANGUARD'
} as const

export type ai_context_library_type = (typeof ai_context_library_type)[keyof typeof ai_context_library_type]


export const ai_slack_channel_type = {
  channel: 'channel',
  im: 'im',
  mpim: 'mpim',
  private_channel: 'private_channel'
} as const

export type ai_slack_channel_type = (typeof ai_slack_channel_type)[keyof typeof ai_slack_channel_type]


export const ai_slack_direction = {
  inbound: 'inbound',
  outbound: 'outbound'
} as const

export type ai_slack_direction = (typeof ai_slack_direction)[keyof typeof ai_slack_direction]


export const ai_slack_event_type = {
  message: 'message',
  app_mention: 'app_mention',
  reaction_added: 'reaction_added',
  reaction_removed: 'reaction_removed',
  file_shared: 'file_shared',
  file_deleted: 'file_deleted',
  channel_joined: 'channel_joined',
  channel_left: 'channel_left',
  slash_command: 'slash_command',
  interactive: 'interactive',
  workflow_step: 'workflow_step',
  other: 'other'
} as const

export type ai_slack_event_type = (typeof ai_slack_event_type)[keyof typeof ai_slack_event_type]


export const ai_source_agent = {
  iris: 'iris',
  ask_redo: 'ask_redo'
} as const

export type ai_source_agent = (typeof ai_source_agent)[keyof typeof ai_source_agent]


export const alert_status = {
  alerted: 'alerted',
  unalerted: 'unalerted'
} as const

export type alert_status = (typeof alert_status)[keyof typeof alert_status]


export const align_items = {
  Left: 'Left',
  Center: 'Center',
  Right: 'Right'
} as const

export type align_items = (typeof align_items)[keyof typeof align_items]


export const alignment = {
  left: 'left',
  center: 'center',
  right: 'right'
} as const

export type alignment = (typeof alignment)[keyof typeof alignment]


export const alignment_horizontal = {
  left: 'left',
  center: 'center',
  right: 'right'
} as const

export type alignment_horizontal = (typeof alignment_horizontal)[keyof typeof alignment_horizontal]


export const alignment_vertical = {
  top: 'top',
  center: 'center',
  bottom: 'bottom'
} as const

export type alignment_vertical = (typeof alignment_vertical)[keyof typeof alignment_vertical]


export const all_content_types = {
  hubspot_contact: 'hubspot_contact',
  hubspot_company: 'hubspot_company',
  hubspot_deal: 'hubspot_deal',
  hubspot_email: 'hubspot_email',
  askelephant_engagement: 'askelephant_engagement'
} as const

export type all_content_types = (typeof all_content_types)[keyof typeof all_content_types]


export const all_sentinel_tags = {
  optimal_timing: 'optimal_timing',
  strong_purchase_intent: 'strong_purchase_intent',
  session_ended_without_purchase: 'session_ended_without_purchase',
  win_back_opportunity: 'win_back_opportunity',
  within_contact_limits: 'within_contact_limits',
  post_purchase_follow_up: 'post_purchase_follow_up',
  capture_interest_now: 'capture_interest_now',
  conversion_opportunity: 'conversion_opportunity',
  other: 'other',
  low_purchase_intent: 'low_purchase_intent',
  would_harm_experience: 'would_harm_experience',
  let_them_convert_naturally: 'let_them_convert_naturally',
  active_session: 'active_session',
  recently_purchased: 'recently_purchased',
  too_early_to_reengage: 'too_early_to_reengage',
  intent_still_forming: 'intent_still_forming',
  session_in_progress: 'session_in_progress',
  contacted_recently: 'contacted_recently',
  unclear_intent: 'unclear_intent',
  may_convert_soon: 'may_convert_soon',
  post_purchase_cooldown: 'post_purchase_cooldown',
  timing_not_optimal: 'timing_not_optimal',
  waiting_for_trigger: 'waiting_for_trigger',
  bypassed_event: 'bypassed_event'
} as const

export type all_sentinel_tags = (typeof all_sentinel_tags)[keyof typeof all_sentinel_tags]


export const amp_client = {
  gmail: 'gmail',
  yahoo: 'yahoo',
  mail_ru: 'mail_ru'
} as const

export type amp_client = (typeof amp_client)[keyof typeof amp_client]


export const amp_registration_status = {
  email_sent: 'email_sent',
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected'
} as const

export type amp_registration_status = (typeof amp_registration_status)[keyof typeof amp_registration_status]


export const analytics_snapshot_kind = {
  CHECKOUT_SPLIT: 'CHECKOUT_SPLIT'
} as const

export type analytics_snapshot_kind = (typeof analytics_snapshot_kind)[keyof typeof analytics_snapshot_kind]


export const ask_redo_knowledge_source_type = {
  notion_doc: 'notion_doc',
  slack_conversation: 'slack_conversation',
  correction: 'correction',
  cached_answer: 'cached_answer',
  hubspot_email: 'hubspot_email',
  intercom_conversation: 'intercom_conversation',
  system_conversation: 'system_conversation'
} as const

export type ask_redo_knowledge_source_type = (typeof ask_redo_knowledge_source_type)[keyof typeof ask_redo_knowledge_source_type]


export const assessment_kind = {
  claim: 'claim',
  return: 'return',
  warranty: 'warranty',
  recycle: 'recycle'
} as const

export type assessment_kind = (typeof assessment_kind)[keyof typeof assessment_kind]


export const attachment_type = {
  inline: 'inline',
  attachment: 'attachment'
} as const

export type attachment_type = (typeof attachment_type)[keyof typeof attachment_type]


export const attachment_visibility = {
  public: 'public',
  private: 'private'
} as const

export type attachment_visibility = (typeof attachment_visibility)[keyof typeof attachment_visibility]


export const attentive_event_type = {
  Order_Tracking_Update: 'Order_Tracking_Update'
} as const

export type attentive_event_type = (typeof attentive_event_type)[keyof typeof attentive_event_type]


export const attentive_integration_purpose = {
  support: 'support',
  marketing: 'marketing',
  recover: 'recover'
} as const

export type attentive_integration_purpose = (typeof attentive_integration_purpose)[keyof typeof attentive_integration_purpose]


export const audience_type = {
  all_visitors: 'all_visitors',
  based_on_campaign: 'based_on_campaign'
} as const

export type audience_type = (typeof audience_type)[keyof typeof audience_type]


export const automated_return_initiator_type = {
  netsuite: 'netsuite',
  trackstar: 'trackstar',
  inmar: 'inmar',
  pos: 'pos',
  blue_yonder: 'blue_yonder',
  redo_shipments: 'redo_shipments',
  redo_shipping_claims: 'redo_shipping_claims',
  redo_claims: 'redo_claims',
  redo_expiration: 'redo_expiration',
  redo_bulk: 'redo_bulk',
  redo_manual_trigger: 'redo_manual_trigger',
  redo_agent_review: 'redo_agent_review',
  ryder: 'ryder',
  shipbob: 'shipbob',
  shopify: 'shopify',
  loop: 'loop',
  happy_returns: 'happy_returns',
  shiphero: 'shiphero',
  bright_pearl: 'bright_pearl',
  cloudx: 'cloudx',
  sfom: 'sfom',
  aims360: 'aims360',
  returnbear: 'returnbear',
  public_api: 'public_api',
  shipedge: 'shipedge',
  extensiv: 'extensiv',
  shipmonk: 'shipmonk',
  processing_flow: 'processing_flow'
} as const

export type automated_return_initiator_type = (typeof automated_return_initiator_type)[keyof typeof automated_return_initiator_type]


export const automation_result = {
  approve: 'approve',
  reject: 'reject',
  manual_review: 'manual_review'
} as const

export type automation_result = (typeof automation_result)[keyof typeof automation_result]


export const banner_status = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  critical: 'critical'
} as const

export type banner_status = (typeof banner_status)[keyof typeof banner_status]


export const batch_job_status = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed'
} as const

export type batch_job_status = (typeof batch_job_status)[keyof typeof batch_job_status]


export const bigcommerce_refund_method = {
  default: 'default',
  noop: 'noop'
} as const

export type bigcommerce_refund_method = (typeof bigcommerce_refund_method)[keyof typeof bigcommerce_refund_method]


export const bigcommerce_store_credit_type = {
  gift_card: 'gift_card',
  store_credit: 'store_credit'
} as const

export type bigcommerce_store_credit_type = (typeof bigcommerce_store_credit_type)[keyof typeof bigcommerce_store_credit_type]


export const bill_of_materials_product_kind = {
  input: 'input',
  output: 'output'
} as const

export type bill_of_materials_product_kind = (typeof bill_of_materials_product_kind)[keyof typeof bill_of_materials_product_kind]


export const bill_of_materials_status = {
  active: 'active',
  inactive: 'inactive'
} as const

export type bill_of_materials_status = (typeof bill_of_materials_status)[keyof typeof bill_of_materials_status]


export const billing_method = {
  shopify_collective: 'shopify_collective',
  standard: 'standard'
} as const

export type billing_method = (typeof billing_method)[keyof typeof billing_method]


export const billing_type = {
  marketing_sms: 'marketing_sms',
  marketing_email: 'marketing_email',
  order_tracking: 'order_tracking',
  return_ai_exchange: 'return_ai_exchange',
  returns: 'returns',
  checkout_optimization: 'checkout_optimization',
  aeo: 'aeo',
  ims: 'ims',
  ims_forecasting: 'ims_forecasting',
  recover: 'recover',
  disputes: 'disputes'
} as const

export type billing_type = (typeof billing_type)[keyof typeof billing_type]


export const bulk_pick_session_status = {
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled'
} as const

export type bulk_pick_session_status = (typeof bulk_pick_session_status)[keyof typeof bulk_pick_session_status]


export const button_action = {
  submit_and_advance: 'submit_and_advance',
  submit_and_go_to_url: 'submit_and_go_to_url',
  close: 'close'
} as const

export type button_action = (typeof button_action)[keyof typeof button_action]


export const button_hierarchy = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary'
} as const

export type button_hierarchy = (typeof button_hierarchy)[keyof typeof button_hierarchy]


export const call_direction = {
  inbound: 'inbound',
  outbound: 'outbound'
} as const

export type call_direction = (typeof call_direction)[keyof typeof call_direction]


export const campaign_error_code = {
  internal_error: 'internal_error',
  daily_usage_limit_exceeded: 'daily_usage_limit_exceeded',
  not_enabled: 'not_enabled'
} as const

export type campaign_error_code = (typeof campaign_error_code)[keyof typeof campaign_error_code]


export const campaign_recipient_reference_type = {
  DISCOUNT: 'DISCOUNT'
} as const

export type campaign_recipient_reference_type = (typeof campaign_recipient_reference_type)[keyof typeof campaign_recipient_reference_type]


export const campaign_recipient_status = {
  pending: 'pending',
  processing: 'processing',
  processed: 'processed',
  failed: 'failed'
} as const

export type campaign_recipient_status = (typeof campaign_recipient_status)[keyof typeof campaign_recipient_status]


export const carrier_pickup_status = {
  Scheduled: 'Scheduled',
  Cancelled: 'Cancelled'
} as const

export type carrier_pickup_status = (typeof carrier_pickup_status)[keyof typeof carrier_pickup_status]


export const carriers = {
  FedEx: 'FedEx',
  UPS: 'UPS',
  UPSSurePost: 'UPSSurePost',
  USPS: 'USPS',
  USPSReturns: 'USPSReturns',
  UspsShip: 'UspsShip',
  FedExSmartPost: 'FedExSmartPost',
  AmazonShipping: 'AmazonShipping',
  DHLExpress: 'DHLExpress',
  DhlEcs: 'DhlEcs',
  Veho: 'Veho',
  APC: 'APC',
  FirstMile: 'FirstMile',
  AustraliaPost: 'AustraliaPost',
  CanadaPost: 'CanadaPost',
  GSO: 'GSO',
  AsendiaUsa: 'AsendiaUsa',
  RoyalMailV3: 'RoyalMailV3',
  SpeeDee: 'SpeeDee',
  PassportGlobal: 'PassportGlobal',
  ePostGlobal: 'ePostGlobal',
  LandmarkGlobal: 'LandmarkGlobal',
  ETA_Express: 'ETA_Express',
  OnTracV3: 'OnTracV3',
  GlobalE: 'GlobalE',
  UPSMailInnovations: 'UPSMailInnovations',
  Purolator: 'Purolator',
  UniUni: 'UniUni'
} as const

export type carriers = (typeof carriers)[keyof typeof carriers]


export const cart_layout_type = {
  rows: 'rows',
  columns: 'columns'
} as const

export type cart_layout_type = (typeof cart_layout_type)[keyof typeof cart_layout_type]


export const cart_product_type = {
  return: 'return',
  package_protection: 'package_protection',
  return_package_protection: 'return_package_protection',
  extended_warranty: 'extended_warranty'
} as const

export type cart_product_type = (typeof cart_product_type)[keyof typeof cart_product_type]


export const category = {
  Order_tracking: 'Order_tracking',
  Return_tracking: 'Return_tracking',
  Return_processing: 'Return_processing',
  Try_first: 'Try_first',
  Marketing: 'Marketing',
  Reviews: 'Reviews',
  Upsell: 'Upsell',
  Oms: 'Oms',
  Checkout_personalization: 'Checkout_personalization',
  Checkout_package: 'Checkout_package',
  Post_purchase: 'Post_purchase',
  Tracking_page: 'Tracking_page',
  Extended_warranty: 'Extended_warranty',
  Integration: 'Integration',
  Recover: 'Recover',
  Rules: 'Rules',
  Custom_Event: 'Custom_Event'
} as const

export type category = (typeof category)[keyof typeof category]


export const channel = {
  shopApp: 'shopApp',
  pointOfSale: 'pointOfSale',
  web: 'web',
  ai: 'ai',
  api: 'api'
} as const

export type channel = (typeof channel)[keyof typeof channel]


export const channels = {
  chat: 'chat',
  email: 'email',
  slack: 'slack'
} as const

export type channels = (typeof channels)[keyof typeof channels]


export const charge_types = {
  package_pickup: 'package_pickup',
  shipping_cost_share: 'shipping_cost_share',
  canceled_return_label_refund: 'canceled_return_label_refund',
  instant_exchange_recovery: 'instant_exchange_recovery',
  cancelled_order_instant_exchange_recovery: 'cancelled_order_instant_exchange_recovery',
  customer_paid_label: 'customer_paid_label',
  coverage_refund_for_cancelled_order: 'coverage_refund_for_cancelled_order',
  cancelled_order_package_protection_plus_refund: 'cancelled_order_package_protection_plus_refund',
  denied_claim_package_protection_plus_refund: 'denied_claim_package_protection_plus_refund',
  cancelled_order_final_sale_return_coverage_refund: 'cancelled_order_final_sale_return_coverage_refund',
  cancelled_order_extended_warranty_refund: 'cancelled_order_extended_warranty_refund',
  instant_refund: 'instant_refund',
  canceled_pickup_refund: 'canceled_pickup_refund',
  outbound_label: 'outbound_label',
  upsell_revenue: 'upsell_revenue',
  upsell_revenue_refunded: 'upsell_revenue_refunded',
  final_sale_credit: 'final_sale_credit',
  free_trial_credit: 'free_trial_credit',
  final_sale_return_coverage: 'final_sale_return_coverage',
  package_protection_plus: 'package_protection_plus',
  order_tracking: 'order_tracking',
  managed_claim_credit: 'managed_claim_credit',
  repair_fee_credit: 'repair_fee_credit',
  extended_warranty: 'extended_warranty',
  return_coverage: 'return_coverage',
  redo_managed_returns_coverage: 'redo_managed_returns_coverage',
  returns_processing_fee: 'returns_processing_fee',
  damaged: 'damaged',
  wrong_product: 'wrong_product',
  merchant_covered_label: 'merchant_covered_label',
  merchant_carrier_label_credit: 'merchant_carrier_label_credit',
  merchant_created_return_label: 'merchant_created_return_label',
  return_fraud_prevention: 'return_fraud_prevention',
  point_of_sale: 'point_of_sale',
  carrier_claim_refund: 'carrier_claim_refund',
  exchange_shipping_credit: 'exchange_shipping_credit',
  per_return_fee: 'per_return_fee',
  implementation_fee: 'implementation_fee',
  manual_adjustment: 'manual_adjustment',
  per_recycle_request_fee: 'per_recycle_request_fee',
  card_processing_fee: 'card_processing_fee',
  return_label_adjustment: 'return_label_adjustment',
  manual_refund: 'manual_refund',
  re_fulfillment_revenue_share: 're_fulfillment_revenue_share',
  per_exchange_payout_fee: 'per_exchange_payout_fee'
} as const

export type charge_types = (typeof charge_types)[keyof typeof charge_types]


export const chat_flow_input_step_type = {
  default: 'default',
  collect_email: 'collect_email',
  code_verification: 'code_verification',
  offering_convert_to_email: 'offering_convert_to_email'
} as const

export type chat_flow_input_step_type = (typeof chat_flow_input_step_type)[keyof typeof chat_flow_input_step_type]


export const checkout_ab_test_metric_to_optimize = {
  CHECKOUT_CONVERSION_RATE: 'CHECKOUT_CONVERSION_RATE'
} as const

export type checkout_ab_test_metric_to_optimize = (typeof checkout_ab_test_metric_to_optimize)[keyof typeof checkout_ab_test_metric_to_optimize]


export const checkout_analytics_version = {
  basic: 'basic',
  advanced_v08_13_2025: 'advanced_v08_13_2025',
  advanced_v09_16_2025: 'advanced_v09_16_2025'
} as const

export type checkout_analytics_version = (typeof checkout_analytics_version)[keyof typeof checkout_analytics_version]


export const checkout_image_block_justification = {
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  RIGHT: 'RIGHT'
} as const

export type checkout_image_block_justification = (typeof checkout_image_block_justification)[keyof typeof checkout_image_block_justification]


export const checkout_optimization_widget_type = {
  FULFILLMENT_CUTOFF: 'FULFILLMENT_CUTOFF',
  THRESHOLD_UPSELL: 'THRESHOLD_UPSELL',
  LOW_PROFILE_PRODUCT_UPSELL: 'LOW_PROFILE_PRODUCT_UPSELL',
  CONTENT_BLOCK: 'CONTENT_BLOCK',
  IMAGE_BLOCK: 'IMAGE_BLOCK',
  SHIPPING_OPTION_CONTENT: 'SHIPPING_OPTION_CONTENT',
  SHIPPING_OPTION_IMAGE: 'SHIPPING_OPTION_IMAGE'
} as const

export type checkout_optimization_widget_type = (typeof checkout_optimization_widget_type)[keyof typeof checkout_optimization_widget_type]


export const churn_category = {
  Implementation_Launch_Delays: 'Implementation_Launch_Delays',
  Pricing___Value_Concerns: 'Pricing___Value_Concerns',
  Contract_Commercial_Issues: 'Contract_Commercial_Issues',
  Coverage_Product_Concerns: 'Coverage_Product_Concerns',
  Technical_Integration_Issues: 'Technical_Integration_Issues',
  Stakeholder_Business_Changes: 'Stakeholder_Business_Changes',
  N_A__Did_Not_Churn: 'N_A__Did_Not_Churn'
} as const

export type churn_category = (typeof churn_category)[keyof typeof churn_category]


export const churn_event_type = {
  Churned: 'Churned',
  Price_Dollar_Churn: 'Price_Dollar_Churn',
  Monetization_Dollar_Churn: 'Monetization_Dollar_Churn'
} as const

export type churn_event_type = (typeof churn_event_type)[keyof typeof churn_event_type]


export const churn_excerpt_platform = {
  hubspot: 'hubspot',
  intercom: 'intercom',
  slack: 'slack'
} as const

export type churn_excerpt_platform = (typeof churn_excerpt_platform)[keyof typeof churn_excerpt_platform]


export const churn_excerpt_speaker = {
  merchant: 'merchant',
  redo: 'redo',
  internal: 'internal',
  unknown: 'unknown'
} as const

export type churn_excerpt_speaker = (typeof churn_excerpt_speaker)[keyof typeof churn_excerpt_speaker]


export const churn_product = {
  Returns: 'Returns',
  FSR: 'FSR',
  PP_: 'PP_',
  Extended_Warranties: 'Extended_Warranties',
  OMS: 'OMS',
  WMS: 'WMS',
  IMS: 'IMS',
  Checkout_Optimization: 'Checkout_Optimization',
  ShopperAI: 'ShopperAI',
  Email: 'Email',
  SMS: 'SMS',
  Order_Tracking: 'Order_Tracking',
  Recover: 'Recover',
  Support: 'Support',
  All_Products: 'All_Products'
} as const

export type churn_product = (typeof churn_product)[keyof typeof churn_product]


export const commentsold_listing_status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const

export type commentsold_listing_status = (typeof commentsold_listing_status)[keyof typeof commentsold_listing_status]


export const comparison_operator = {
  greater_than: 'greater_than',
  at_least: 'at_least',
  equals: 'equals',
  at_most: 'at_most',
  less_than: 'less_than'
} as const

export type comparison_operator = (typeof comparison_operator)[keyof typeof comparison_operator]


export const compensation_method = {
  refund: 'refund',
  store_credit: 'store_credit',
  exchange: 'exchange'
} as const

export type compensation_method = (typeof compensation_method)[keyof typeof compensation_method]


export const compensation_method_type = {
  exchange: 'exchange',
  storeCredit: 'storeCredit',
  refund: 'refund',
  repair: 'repair'
} as const

export type compensation_method_type = (typeof compensation_method_type)[keyof typeof compensation_method_type]


export const conjunction_mode = {
  AND: 'AND',
  OR: 'OR'
} as const

export type conjunction_mode = (typeof conjunction_mode)[keyof typeof conjunction_mode]


export const content_generation_context_tool_type = {
  customer_agent: 'customer_agent',
  get_pdp_product_description: 'get_pdp_product_description',
  product_reviews: 'product_reviews',
  generate_discount_code: 'generate_discount_code'
} as const

export type content_generation_context_tool_type = (typeof content_generation_context_tool_type)[keyof typeof content_generation_context_tool_type]


export const content_generation_target = {
  sms_content: 'sms_content'
} as const

export type content_generation_target = (typeof content_generation_target)[keyof typeof content_generation_target]


export const contents_type = {
  merchandise: 'merchandise',
  returned_goods: 'returned_goods',
  documents: 'documents',
  gift: 'gift',
  sample: 'sample'
} as const

export type contents_type = (typeof contents_type)[keyof typeof contents_type]


export const conversation_activity_type = {
  viewing: 'viewing',
  typing: 'typing'
} as const

export type conversation_activity_type = (typeof conversation_activity_type)[keyof typeof conversation_activity_type]


export const conversation_assignee_type = {
  USER: 'USER',
  AI: 'AI',
  CHAT_FLOW: 'CHAT_FLOW'
} as const

export type conversation_assignee_type = (typeof conversation_assignee_type)[keyof typeof conversation_assignee_type]


export const conversation_closure_reason = {
  EXPIRED: 'EXPIRED',
  RESOLVED: 'RESOLVED',
  MANUAL: 'MANUAL',
  SPAM: 'SPAM',
  DUPLICATE: 'DUPLICATE'
} as const

export type conversation_closure_reason = (typeof conversation_closure_reason)[keyof typeof conversation_closure_reason]


export const conversation_platform = {
  email: 'email',
  redoChat: 'redoChat',
  facebook: 'facebook',
  facebookComments: 'facebookComments',
  instagram: 'instagram',
  instagramComments: 'instagramComments',
  sms: 'sms',
  voice: 'voice',
  attentive: 'attentive',
  postscript: 'postscript',
  tiktok: 'tiktok',
  mobileMessage: 'mobileMessage'
} as const

export type conversation_platform = (typeof conversation_platform)[keyof typeof conversation_platform]


export const conversation_tag_source = {
  outlook: 'outlook',
  gmail: 'gmail',
  redo_system: 'redo_system',
  merchant_defined: 'merchant_defined',
  imported_by_zendesk_macro: 'imported_by_zendesk_macro'
} as const

export type conversation_tag_source = (typeof conversation_tag_source)[keyof typeof conversation_tag_source]


export const counter_types = {
  warranty_registration: 'warranty_registration',
  support_conversation: 'support_conversation',
  retail_order: 'retail_order',
  marketplace_order: 'marketplace_order',
  recycle_request: 'recycle_request',
  redo_order: 'redo_order'
} as const

export type counter_types = (typeof counter_types)[keyof typeof counter_types]


export const coverage_product_source = {
  supplier: 'supplier',
  store: 'store'
} as const

export type coverage_product_source = (typeof coverage_product_source)[keyof typeof coverage_product_source]


export const create_rma_results_name = {
  aims360: 'aims360',
  apparelmagic: 'apparelmagic',
  brightpearl: 'brightpearl',
  cloudx: 'cloudx',
  extensiv: 'extensiv',
  flexport: 'flexport',
  netsuite: 'netsuite',
  sfom: 'sfom',
  ryder: 'ryder',
  shipbob: 'shipbob',
  shipedge: 'shipedge',
  shiphero: 'shiphero',
  shipmonk: 'shipmonk',
  trackstar: 'trackstar',
  deposco: 'deposco',
  shipstream: 'shipstream',
  bluebox: 'bluebox',
  nimble: 'nimble',
  whiplash: 'whiplash',
  cirro: 'cirro'
} as const

export type create_rma_results_name = (typeof create_rma_results_name)[keyof typeof create_rma_results_name]


export const currency = {
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BOV: 'BOV',
  BRL: 'BRL',
  BSD: 'BSD',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUC: 'CUC',
  CUP: 'CUP',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  GBP: 'GBP',
  GEL: 'GEL',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KMF: 'KMF',
  KPW: 'KPW',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LYD: 'LYD',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRU: 'MRU',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLE: 'SLE',
  SOS: 'SOS',
  SRD: 'SRD',
  SSP: 'SSP',
  STN: 'STN',
  SVC: 'SVC',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UYW: 'UYW',
  UZS: 'UZS',
  VED: 'VED',
  VES: 'VES',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XAG: 'XAG',
  XAU: 'XAU',
  XBA: 'XBA',
  XBB: 'XBB',
  XBC: 'XBC',
  XBD: 'XBD',
  XCD: 'XCD',
  XDR: 'XDR',
  XOF: 'XOF',
  XPD: 'XPD',
  XPF: 'XPF',
  XPT: 'XPT',
  XSU: 'XSU',
  XTS: 'XTS',
  XUA: 'XUA',
  XXX: 'XXX',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW',
  ZWG: 'ZWG',
  ZWL: 'ZWL',
  BYR: 'BYR',
  HRK: 'HRK',
  JEP: 'JEP',
  KID: 'KID',
  LTL: 'LTL',
  LVL: 'LVL',
  SLL: 'SLL',
  STD: 'STD',
  USDC: 'USDC',
  VEF: 'VEF'
} as const

export type currency = (typeof currency)[keyof typeof currency]


export const custom_field_type = {
  date: 'date',
  dropdown: 'dropdown',
  number: 'number',
  text_long: 'text_long',
  text_short: 'text_short',
  yes_no_question: 'yes_no_question'
} as const

export type custom_field_type = (typeof custom_field_type)[keyof typeof custom_field_type]


export const custom_parcel_type = {
  box: 'box',
  envelope: 'envelope',
  soft_pack: 'soft_pack'
} as const

export type custom_parcel_type = (typeof custom_parcel_type)[keyof typeof custom_parcel_type]


export const customer_custom_field_data_type = {
  string: 'string',
  number: 'number',
  boolean: 'boolean',
  date: 'date'
} as const

export type customer_custom_field_data_type = (typeof customer_custom_field_data_type)[keyof typeof customer_custom_field_data_type]


export const customer_group_membership_cache_status = {
  clean: 'clean',
  dirty: 'dirty',
  cleaning: 'cleaning'
} as const

export type customer_group_membership_cache_status = (typeof customer_group_membership_cache_status)[keyof typeof customer_group_membership_cache_status]


export const customer_group_type = {
  static: 'static',
  dynamic: 'dynamic',
  persona: 'persona'
} as const

export type customer_group_type = (typeof customer_group_type)[keyof typeof customer_group_type]


export const customer_origin = {
  email: 'email',
  redoChat: 'redoChat',
  shopify: 'shopify',
  instagram: 'instagram',
  facebook: 'facebook',
  instagramComments: 'instagramComments',
  facebookComments: 'facebookComments',
  redo: 'redo',
  attentive: 'attentive',
  postscript: 'postscript',
  warranty: 'warranty',
  klaviyo: 'klaviyo',
  tiktok: 'tiktok',
  import: 'import',
  unknown: 'unknown'
} as const

export type customer_origin = (typeof customer_origin)[keyof typeof customer_origin]


export const customer_portal_version = {
  v3_5: 'v3_5',
  v4_0: 'v4_0'
} as const

export type customer_portal_version = (typeof customer_portal_version)[keyof typeof customer_portal_version]


export const customer_product_event = {
  BACK_IN_STOCK: 'BACK_IN_STOCK',
  LOW_INVENTORY: 'LOW_INVENTORY'
} as const

export type customer_product_event = (typeof customer_product_event)[keyof typeof customer_product_event]


export const customer_segment_operation_values = {
  add: 'add',
  remove: 'remove'
} as const

export type customer_segment_operation_values = (typeof customer_segment_operation_values)[keyof typeof customer_segment_operation_values]


export const customer_sentiment = {
  positive: 'positive',
  negative: 'negative',
  neutral: 'neutral'
} as const

export type customer_sentiment = (typeof customer_sentiment)[keyof typeof customer_sentiment]


export const customer_tag_provider = {
  redo: 'redo',
  commentsold: 'commentsold',
  shopify: 'shopify'
} as const

export type customer_tag_provider = (typeof customer_tag_provider)[keyof typeof customer_tag_provider]


export const customer_tag_source = {
  redo_support: 'redo_support',
  shopify: 'shopify',
  redo_marketing: 'redo_marketing'
} as const

export type customer_tag_source = (typeof customer_tag_source)[keyof typeof customer_tag_source]


export const data_access_request_status = {
  pending: 'pending',
  finished: 'finished',
  failed: 'failed'
} as const

export type data_access_request_status = (typeof data_access_request_status)[keyof typeof data_access_request_status]


export const data_source = {
  pixel: 'pixel',
  order: 'order',
  carrier_service: 'carrier_service',
  storefront_extension: 'storefront_extension'
} as const

export type data_source = (typeof data_source)[keyof typeof data_source]


export const day_of_week = {
  sunday: 'sunday',
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday'
} as const

export type day_of_week = (typeof day_of_week)[keyof typeof day_of_week]


export const deal_assessment_status = {
  on_track: 'on_track',
  at_risk: 'at_risk',
  needs_attention: 'needs_attention',
  stalled: 'stalled',
  unknown: 'unknown'
} as const

export type deal_assessment_status = (typeof deal_assessment_status)[keyof typeof deal_assessment_status]


export const deal_pipeline = {
  new_business: 'new_business',
  xsell: 'xsell'
} as const

export type deal_pipeline = (typeof deal_pipeline)[keyof typeof deal_pipeline]


export const delivery_option_filter_field = {
  TITLE: 'TITLE',
  SERVICE_CODE: 'SERVICE_CODE'
} as const

export type delivery_option_filter_field = (typeof delivery_option_filter_field)[keyof typeof delivery_option_filter_field]


export const delivery_option_filter_operator = {
  IS: 'IS',
  IS_NOT: 'IS_NOT',
  CONTAINS: 'CONTAINS'
} as const

export type delivery_option_filter_operator = (typeof delivery_option_filter_operator)[keyof typeof delivery_option_filter_operator]


export const delivery_option_target_type = {
  ALL: 'ALL',
  SPECIFIC: 'SPECIFIC'
} as const

export type delivery_option_target_type = (typeof delivery_option_target_type)[keyof typeof delivery_option_target_type]


export const device_option = {
  desktop: 'desktop',
  mobile: 'mobile',
  desktop___mobile: 'desktop___mobile'
} as const

export type device_option = (typeof device_option)[keyof typeof device_option]


export const dhl_ecs_distribution_center = {
  USATL1: 'USATL1',
  USBOS1: 'USBOS1',
  USBWI1: 'USBWI1',
  USCAK1: 'USCAK1',
  USCVG1: 'USCVG1',
  USDEN1: 'USDEN1',
  USDFW1: 'USDFW1',
  USEWR1: 'USEWR1',
  USIAH1: 'USIAH1',
  USLAX1: 'USLAX1',
  USMCI1: 'USMCI1',
  USMCO1: 'USMCO1',
  USORD1: 'USORD1',
  USPHX1: 'USPHX1',
  USRDU1: 'USRDU1',
  USSEA1: 'USSEA1',
  USSFO1: 'USSFO1',
  USSLC1: 'USSLC1',
  CNYYZ1: 'CNYYZ1'
} as const

export type dhl_ecs_distribution_center = (typeof dhl_ecs_distribution_center)[keyof typeof dhl_ecs_distribution_center]


export const DimensionUnit = {
  mm: 'mm',
  cm: 'cm',
  m: 'm',
  in: 'in',
  ft: 'ft',
  yd: 'yd'
} as const

export type DimensionUnit = (typeof DimensionUnit)[keyof typeof DimensionUnit]


export const discount_category = {
  RECOVER: 'RECOVER',
  SHOPPER_AI: 'SHOPPER_AI',
  MARKETING: 'MARKETING'
} as const

export type discount_category = (typeof discount_category)[keyof typeof discount_category]


export const discount_group_type = {
  static: 'static',
  dynamic: 'dynamic'
} as const

export type discount_group_type = (typeof discount_group_type)[keyof typeof discount_group_type]


export const discount_min_requirement_type = {
  minimumQuantity: 'minimumQuantity',
  minimumSubtotal: 'minimumSubtotal'
} as const

export type discount_min_requirement_type = (typeof discount_min_requirement_type)[keyof typeof discount_min_requirement_type]


export const discount_provider = {
  shopifyDiscount: 'shopifyDiscount',
  commentsold: 'commentsold',
  other: 'other'
} as const

export type discount_provider = (typeof discount_provider)[keyof typeof discount_provider]


export const discount_rule_type = {
  SHIPPING: 'SHIPPING'
} as const

export type discount_rule_type = (typeof discount_rule_type)[keyof typeof discount_rule_type]


export const discount_rule_value_type = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_AMOUNT: 'FIXED_AMOUNT'
} as const

export type discount_rule_value_type = (typeof discount_rule_value_type)[keyof typeof discount_rule_value_type]


export const discount_value_type = {
  percentage: 'percentage',
  amount: 'amount'
} as const

export type discount_value_type = (typeof discount_value_type)[keyof typeof discount_value_type]


export const dispute_source = {
  shopify: 'shopify',
  paypal: 'paypal'
} as const

export type dispute_source = (typeof dispute_source)[keyof typeof dispute_source]


export const dispute_status = {
  needs_response: 'needs_response',
  under_review: 'under_review',
  charge_refunded: 'charge_refunded',
  accepted: 'accepted',
  won: 'won',
  lost: 'lost'
} as const

export type dispute_status = (typeof dispute_status)[keyof typeof dispute_status]


export const dispute_type = {
  chargeback: 'chargeback',
  inquiry: 'inquiry'
} as const

export type dispute_type = (typeof dispute_type)[keyof typeof dispute_type]


export const draft_return_source = {
  from_order: 'from_order',
  from_warranty_registration: 'from_warranty_registration',
  from_draft_registration: 'from_draft_registration',
  from_products: 'from_products'
} as const

export type draft_return_source = (typeof draft_return_source)[keyof typeof draft_return_source]


export const dynamic_range_expiration_units = {
  weeks: 'weeks',
  days: 'days',
  hours: 'hours',
  minutes: 'minutes'
} as const

export type dynamic_range_expiration_units = (typeof dynamic_range_expiration_units)[keyof typeof dynamic_range_expiration_units]


export const ecommerce_platform = {
  shopify: 'shopify',
  commerceCloud: 'commerceCloud',
  commentsold: 'commentsold',
  bigcommerce: 'bigcommerce'
} as const

export type ecommerce_platform = (typeof ecommerce_platform)[keyof typeof ecommerce_platform]


export const ecommerce_provider = {
  shopify: 'shopify',
  bigcommerce: 'bigcommerce',
  commerce_cloud: 'commerce_cloud'
} as const

export type ecommerce_provider = (typeof ecommerce_provider)[keyof typeof ecommerce_provider]


export const email_header_type = {
  image: 'image',
  logo: 'logo',
  text: 'text'
} as const

export type email_header_type = (typeof email_header_type)[keyof typeof email_header_type]


export const error_handling_strategy = {
  fail_fast: 'fail_fast',
  continue_on_error: 'continue_on_error'
} as const

export type error_handling_strategy = (typeof error_handling_strategy)[keyof typeof error_handling_strategy]


export const error_tag = {
  label: 'label',
  boxless_return: 'boxless_return',
  instant_refund: 'instant_refund',
  pickup: 'pickup',
  in_store_return: 'in_store_return',
  claim_report: 'claim_report',
  repair_invoice: 'repair_invoice'
} as const

export type error_tag = (typeof error_tag)[keyof typeof error_tag]


export const expiration_type = {
  delivery: 'delivery',
  expiration: 'expiration',
  date: 'date',
  never: 'never'
} as const

export type expiration_type = (typeof expiration_type)[keyof typeof expiration_type]


export const extended_warranty_blurb_type = {
  regular: 'regular',
  compact: 'compact'
} as const

export type extended_warranty_blurb_type = (typeof extended_warranty_blurb_type)[keyof typeof extended_warranty_blurb_type]


export const extended_warranty_cart_toggle_experience = {
  toggle: 'toggle',
  modal: 'modal',
  remove_only: 'remove_only',
  checkbox: 'checkbox',
  disabled: 'disabled'
} as const

export type extended_warranty_cart_toggle_experience = (typeof extended_warranty_cart_toggle_experience)[keyof typeof extended_warranty_cart_toggle_experience]


export const extended_warranty_default_selection = {
  cheapest: 'cheapest',
  no_coverage: 'no_coverage'
} as const

export type extended_warranty_default_selection = (typeof extended_warranty_default_selection)[keyof typeof extended_warranty_default_selection]


export const extended_warranty_pdp_experience = {
  tiles_modal: 'tiles_modal',
  radio_modal: 'radio_modal',
  upsell_modal: 'upsell_modal',
  checkbox: 'checkbox'
} as const

export type extended_warranty_pdp_experience = (typeof extended_warranty_pdp_experience)[keyof typeof extended_warranty_pdp_experience]


export const extended_warranty_pdp_no_coverage_type = {
  detailed: 'detailed',
  basic: 'basic'
} as const

export type extended_warranty_pdp_no_coverage_type = (typeof extended_warranty_pdp_no_coverage_type)[keyof typeof extended_warranty_pdp_no_coverage_type]


export const extended_warranty_pdp_render_method = {
  app_block: 'app_block',
  script_tag: 'script_tag'
} as const

export type extended_warranty_pdp_render_method = (typeof extended_warranty_pdp_render_method)[keyof typeof extended_warranty_pdp_render_method]


export const extended_warranty_popup_experience = {
  embedded: 'embedded',
  disabled: 'disabled'
} as const

export type extended_warranty_popup_experience = (typeof extended_warranty_popup_experience)[keyof typeof extended_warranty_popup_experience]


export const extended_warranty_radio_option_type = {
  regular: 'regular',
  expanded: 'expanded'
} as const

export type extended_warranty_radio_option_type = (typeof extended_warranty_radio_option_type)[keyof typeof extended_warranty_radio_option_type]


export const extended_warranty_tiles_size = {
  regular: 'regular',
  compact: 'compact'
} as const

export type extended_warranty_tiles_size = (typeof extended_warranty_tiles_size)[keyof typeof extended_warranty_tiles_size]


export const external_claim_status = {
  new: 'new',
  closed: 'closed',
  under_review: 'under_review',
  pending_docs: 'pending_docs',
  paid: 'paid',
  cancelled: 'cancelled',
  expired: 'expired'
} as const

export type external_claim_status = (typeof external_claim_status)[keyof typeof external_claim_status]


export const external_integration_id_providers = {
  aims360: 'aims360',
  apparelmagic: 'apparelmagic',
  brightpearl: 'brightpearl',
  cloudx: 'cloudx',
  extensiv: 'extensiv',
  flexport: 'flexport',
  netsuite: 'netsuite',
  sfom: 'sfom',
  shipbob: 'shipbob',
  shipedge: 'shipedge',
  shiphero: 'shiphero',
  shipmonk: 'shipmonk',
  trackstar: 'trackstar',
  ryder: 'ryder',
  returnbear: 'returnbear',
  blueyonder: 'blueyonder',
  inmar: 'inmar',
  deposco: 'deposco'
} as const

export type external_integration_id_providers = (typeof external_integration_id_providers)[keyof typeof external_integration_id_providers]


export const external_integration_id_types = {
  rma: 'rma',
  support_case: 'support_case',
  cash_refund: 'cash_refund',
  credit_memo: 'credit_memo',
  refund: 'refund',
  sales_credit: 'sales_credit',
  receipt: 'receipt',
  sales_order: 'sales_order',
  box: 'box'
} as const

export type external_integration_id_types = (typeof external_integration_id_types)[keyof typeof external_integration_id_types]


export const external_return_hub_type = {
  returnbear: 'returnbear',
  blueyonder: 'blueyonder',
  shipmonk: 'shipmonk',
  ryder: 'ryder',
  deposco: 'deposco',
  netsuite: 'netsuite'
} as const

export type external_return_hub_type = (typeof external_return_hub_type)[keyof typeof external_return_hub_type]


export const external_return_shipping_charge_type = {
  fedex_easy_returns: 'fedex_easy_returns',
  returnbear: 'returnbear'
} as const

export type external_return_shipping_charge_type = (typeof external_return_shipping_charge_type)[keyof typeof external_return_shipping_charge_type]


export const faq_forge_element_type = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  rich_text: 'rich_text',
  image: 'image',
  video: 'video',
  divider: 'divider',
  toggle: 'toggle',
  attachment: 'attachment'
} as const

export type faq_forge_element_type = (typeof faq_forge_element_type)[keyof typeof faq_forge_element_type]


export const faq_justify = {
  left: 'left',
  center: 'center',
  right: 'right'
} as const

export type faq_justify = (typeof faq_justify)[keyof typeof faq_justify]


export const feature_onboarding_type = {
  package_protection_plus: 'package_protection_plus',
  extended_warranty: 'extended_warranty',
  conversion: 'conversion',
  managed_returns: 'managed_returns',
  intercom_moved: 'intercom_moved',
  disabled: 'disabled',
  support_to_ai_upsell: 'support_to_ai_upsell',
  commentsold_redo: 'commentsold_redo',
  shopper_ai_wrapped: 'shopper_ai_wrapped',
  help_icon_moving: 'help_icon_moving',
  agentic_catalog: 'agentic_catalog',
  billing_settings_consolidated: 'billing_settings_consolidated',
  outbound_labels_upsell_ups: 'outbound_labels_upsell_ups',
  outbound_labels_upsell_amazon: 'outbound_labels_upsell_amazon',
  outbound_labels_upsell_dhl: 'outbound_labels_upsell_dhl',
  disputes_welcome: 'disputes_welcome',
  cross_border_onboarding: 'cross_border_onboarding',
  reclaim_announcement: 'reclaim_announcement',
  outbound_views_moved: 'outbound_views_moved',
  ai_exchange_agent_upsell: 'ai_exchange_agent_upsell',
  international_returns: 'international_returns',
  roles_permissions_update: 'roles_permissions_update',
  marketing_texas_sms_protection: 'marketing_texas_sms_protection',
  black_friday_tips: 'black_friday_tips',
  permissions_roles: 'permissions_roles',
  outbound_labels: 'outbound_labels'
} as const

export type feature_onboarding_type = (typeof feature_onboarding_type)[keyof typeof feature_onboarding_type]


export const field_type = {
  short_text: 'short_text',
  long_text: 'long_text',
  select: 'select',
  number: 'number',
  boolean: 'boolean',
  file_upload: 'file_upload',
  date: 'date'
} as const

export type field_type = (typeof field_type)[keyof typeof field_type]


export const filter_operator = {
  and: 'and',
  or: 'or'
} as const

export type filter_operator = (typeof filter_operator)[keyof typeof filter_operator]


export const font_family = {
  Arial: 'Arial',
  Courier_New: 'Courier_New',
  Georgia: 'Georgia',
  Lucida_Sans_Unicode: 'Lucida_Sans_Unicode',
  Tahoma: 'Tahoma',
  Times_New_Roman: 'Times_New_Roman',
  Trebuchet_MS: 'Trebuchet_MS',
  Verdana: 'Verdana'
} as const

export type font_family = (typeof font_family)[keyof typeof font_family]


export const font_weight = {
  regular: 'regular',
  semibold: 'semibold',
  bold: 'bold'
} as const

export type font_weight = (typeof font_weight)[keyof typeof font_weight]


export const form_builder_type = {
  REVIEW: 'REVIEW'
} as const

export type form_builder_type = (typeof form_builder_type)[keyof typeof form_builder_type]


export const fulfilled_by = {
  Redo: 'Redo',
  External: 'External'
} as const

export type fulfilled_by = (typeof fulfilled_by)[keyof typeof fulfilled_by]


export const fulfillment_batch_status = {
  pending: 'pending',
  labels_created: 'labels_created',
  labels_printed: 'labels_printed',
  pending_manual_fulfillment: 'pending_manual_fulfillment',
  manually_fulfilled: 'manually_fulfilled',
  failed: 'failed',
  picked_up: 'picked_up',
  ready_for_pickup: 'ready_for_pickup',
  partially_picked_up: 'partially_picked_up'
} as const

export type fulfillment_batch_status = (typeof fulfillment_batch_status)[keyof typeof fulfillment_batch_status]


export const fulfillment_group_pick_status = {
  PICKED: 'PICKED',
  PROBLEM: 'PROBLEM',
  IN_PROGRESS: 'IN_PROGRESS'
} as const

export type fulfillment_group_pick_status = (typeof fulfillment_group_pick_status)[keyof typeof fulfillment_group_pick_status]


export const fulfillment_group_status = {
  CANCELLED: 'CANCELLED',
  CLOSED: 'CLOSED',
  INCOMPLETE: 'INCOMPLETE',
  OPEN: 'OPEN',
  ON_HOLD: 'ON_HOLD',
  SCHEDULED: 'SCHEDULED',
  PENDING: 'PENDING',
  VOIDED: 'VOIDED',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  MERGED: 'MERGED',
  UNMERGED: 'UNMERGED',
  INVALID: 'INVALID',
  DELETED: 'DELETED',
  READY_FOR_PICKUP: 'READY_FOR_PICKUP',
  THIRD_PARTY_IN_PROGRESS: 'THIRD_PARTY_IN_PROGRESS',
  OPEN_NOT_RECEIVED: 'OPEN_NOT_RECEIVED'
} as const

export type fulfillment_group_status = (typeof fulfillment_group_status)[keyof typeof fulfillment_group_status]


export const generation_type = {
  MANUAL: 'MANUAL',
  AI: 'AI'
} as const

export type generation_type = (typeof generation_type)[keyof typeof generation_type]


export const geo_jsontype = {
  Point: 'Point'
} as const

export type geo_jsontype = (typeof geo_jsontype)[keyof typeof geo_jsontype]


export const geographic_unit_type = {
  country: 'country',
  state: 'state',
  city: 'city'
} as const

export type geographic_unit_type = (typeof geographic_unit_type)[keyof typeof geographic_unit_type]


export const gift_card_source = {
  client: 'client',
  exchange: 'exchange',
  exchange_stock: 'exchange_stock'
} as const

export type gift_card_source = (typeof gift_card_source)[keyof typeof gift_card_source]


export const gmail_promotion_tab_whitelist_status = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  indeterminate: 'indeterminate'
} as const

export type gmail_promotion_tab_whitelist_status = (typeof gmail_promotion_tab_whitelist_status)[keyof typeof gmail_promotion_tab_whitelist_status]


export const golden_dome_app_origin = {
  SHOPIFY: 'SHOPIFY'
} as const

export type golden_dome_app_origin = (typeof golden_dome_app_origin)[keyof typeof golden_dome_app_origin]


export const golden_dome_notification_type = {
  SLACK: 'SLACK'
} as const

export type golden_dome_notification_type = (typeof golden_dome_notification_type)[keyof typeof golden_dome_notification_type]


export const guidance_sheet_kind = {
  support: 'support'
} as const

export type guidance_sheet_kind = (typeof guidance_sheet_kind)[keyof typeof guidance_sheet_kind]


export const hazmat = {
  PRIMARY_CONTAINED: 'PRIMARY_CONTAINED',
  PRIMARY_PACKED: 'PRIMARY_PACKED',
  PRIMARY: 'PRIMARY',
  SECONDARY_CONTAINED: 'SECONDARY_CONTAINED',
  SECONDARY_PACKED: 'SECONDARY_PACKED',
  SECONDARY: 'SECONDARY',
  ORMD: 'ORMD',
  LITHIUM: 'LITHIUM',
  LIMITED_QUANTITY: 'LIMITED_QUANTITY',
  AIR_ELIGIBLE_ETHANOL: 'AIR_ELIGIBLE_ETHANOL',
  CLASS_1: 'CLASS_1',
  CLASS_3: 'CLASS_3',
  CLASS_7: 'CLASS_7',
  CLASS_8_CORROSIVE: 'CLASS_8_CORROSIVE',
  CLASS_8_WET_BATTERY: 'CLASS_8_WET_BATTERY',
  CLASS_9_NEW_LITHIUM_INDIVIDUAL: 'CLASS_9_NEW_LITHIUM_INDIVIDUAL',
  CLASS_9_USED_LITHIUM: 'CLASS_9_USED_LITHIUM',
  CLASS_9_NEW_LITHIUM_DEVICE: 'CLASS_9_NEW_LITHIUM_DEVICE',
  CLASS_9_DRY_ICE: 'CLASS_9_DRY_ICE',
  CLASS_9_UNMARKED_LITHIUM: 'CLASS_9_UNMARKED_LITHIUM',
  CLASS_9_MAGNETIZED: 'CLASS_9_MAGNETIZED',
  DIVISION_4_1: 'DIVISION_4_1',
  DIVISION_5_1: 'DIVISION_5_1',
  DIVISION_5_2: 'DIVISION_5_2',
  DIVISION_6_1: 'DIVISION_6_1',
  DIVISION_6_2: 'DIVISION_6_2',
  EXCEPTED_QUANTITY_PROVISION: 'EXCEPTED_QUANTITY_PROVISION',
  GROUND_ONLY: 'GROUND_ONLY',
  ID8000: 'ID8000',
  LIGHTERS: 'LIGHTERS',
  SMALL_QUANTITY_PROVISION: 'SMALL_QUANTITY_PROVISION'
} as const

export type hazmat = (typeof hazmat)[keyof typeof hazmat]


export const hotkey = {
  A: 'A',
  B: 'B',
  D: 'D',
  E: 'E',
  F: 'F',
  G: 'G',
  H: 'H',
  I: 'I',
  J: 'J',
  K: 'K',
  M: 'M',
  O: 'O',
  S: 'S',
  U: 'U',
  X: 'X',
  Y: 'Y',
  Z: 'Z'
} as const

export type hotkey = (typeof hotkey)[keyof typeof hotkey]


export const hubspot_sync_status = {
  pending: 'pending',
  synced: 'synced',
  failed: 'failed',
  skipped: 'skipped'
} as const

export type hubspot_sync_status = (typeof hubspot_sync_status)[keyof typeof hubspot_sync_status]


export const ib_webhook_type = {
  refund_approved: 'refund_approved',
  refund_pending: 'refund_pending',
  adjustment_approved: 'adjustment_approved'
} as const

export type ib_webhook_type = (typeof ib_webhook_type)[keyof typeof ib_webhook_type]


export const idfshipping_mode = {
  test: 'test',
  production: 'production'
} as const

export type idfshipping_mode = (typeof idfshipping_mode)[keyof typeof idfshipping_mode]


export const image_direction = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
  no: 'no',
  background: 'background'
} as const

export type image_direction = (typeof image_direction)[keyof typeof image_direction]


export const incident_product = {
  oms: 'oms',
  all: 'all',
  marketing: 'marketing',
  returns: 'returns',
  conversion: 'conversion',
  recommerce: 'recommerce',
  support: 'support'
} as const

export type incident_product = (typeof incident_product)[keyof typeof incident_product]


export const incident_severity = {
  info: 'info',
  warning: 'warning',
  error: 'error'
} as const

export type incident_severity = (typeof incident_severity)[keyof typeof incident_severity]


export const incident_status = {
  active: 'active',
  resolved: 'resolved'
} as const

export type incident_status = (typeof incident_status)[keyof typeof incident_status]


export const inmar_blind_return_status = {
  unresolved: 'unresolved',
  resolved: 'resolved',
  deleted: 'deleted'
} as const

export type inmar_blind_return_status = (typeof inmar_blind_return_status)[keyof typeof inmar_blind_return_status]


export const input_type = {
  email: 'email',
  phone: 'phone',
  birthday: 'birthday',
  custom: 'custom'
} as const

export type input_type = (typeof input_type)[keyof typeof input_type]


export const insertion_position = {
  after: 'after',
  before: 'before',
  prepend: 'prepend',
  append: 'append'
} as const

export type insertion_position = (typeof insertion_position)[keyof typeof insertion_position]


export const integration_kind = {
  test: 'test',
  klaviyo: 'klaviyo',
  dsco: 'dsco',
  judgeme: 'judgeme',
  loyalty_lion: 'loyalty_lion',
  attentive: 'attentive',
  postscript: 'postscript',
  loop: 'loop',
  yotpo: 'yotpo',
  quickbooks_online: 'quickbooks_online',
  stripe: 'stripe'
} as const

export type integration_kind = (typeof integration_kind)[keyof typeof integration_kind]


export const integration_source = {
  redo: 'redo',
  malomo: 'malomo'
} as const

export type integration_source = (typeof integration_source)[keyof typeof integration_source]


export const integration_type = {
  hubspot: 'hubspot',
  slack: 'slack',
  admin_dashboard: 'admin_dashboard'
} as const

export type integration_type = (typeof integration_type)[keyof typeof integration_type]


export const integration_workflow_type = {
  generate_cross_sales_suggestions: 'generate_cross_sales_suggestions',
  generate_cross_sale_emails: 'generate_cross_sale_emails'
} as const

export type integration_workflow_type = (typeof integration_workflow_type)[keyof typeof integration_workflow_type]


export const interaction_source = {
  hubspot: 'hubspot',
  intercom: 'intercom',
  askelephant: 'askelephant'
} as const

export type interaction_source = (typeof interaction_source)[keyof typeof interaction_source]


export const interaction_type = {
  email: 'email',
  conversation: 'conversation',
  message: 'message'
} as const

export type interaction_type = (typeof interaction_type)[keyof typeof interaction_type]


export const intercom_ai_generation_status = {
  generating: 'generating',
  completed: 'completed',
  error: 'error'
} as const

export type intercom_ai_generation_status = (typeof intercom_ai_generation_status)[keyof typeof intercom_ai_generation_status]


export const inventory_level_adjustment_kind = {
  manual: 'manual',
  pick: 'pick',
  putaway: 'putaway',
  receiving: 'receiving',
  transfer: 'transfer',
  replenish: 'replenish',
  bin_count: 'bin_count',
  return_restock: 'return_restock',
  fulfillment_created: 'fulfillment_created',
  fulfillment_cancelled: 'fulfillment_cancelled',
  purchase_order_received: 'purchase_order_received',
  fulfillment_order_created: 'fulfillment_order_created',
  fulfillment_order_cancelled: 'fulfillment_order_cancelled',
  fulfillment_order_edited: 'fulfillment_order_edited',
  sot_initialization: 'sot_initialization',
  unknown: 'unknown',
  manual_pick: 'manual_pick',
  void_label: 'void_label',
  work_order: 'work_order'
} as const

export type inventory_level_adjustment_kind = (typeof inventory_level_adjustment_kind)[keyof typeof inventory_level_adjustment_kind]


export const inventory_policy = {
  continue: 'continue',
  deny: 'deny'
} as const

export type inventory_policy = (typeof inventory_policy)[keyof typeof inventory_policy]


export const invoice_status = {
  complete: 'complete',
  pending: 'pending'
} as const

export type invoice_status = (typeof invoice_status)[keyof typeof invoice_status]


export const klaviyo_event_type = {
  Return_Tracking: 'Return_Tracking',
  Return_Created: 'Return_Created',
  Return_Created_Item: 'Return_Created_Item',
  Order_Tracking_Update: 'Order_Tracking_Update',
  Order_Tracking_Update_Item: 'Order_Tracking_Update_Item',
  Product_Saved_to_Wishlist: 'Product_Saved_to_Wishlist',
  Customer_Account_Created: 'Customer_Account_Created',
  Coverage_Incentive_Credit: 'Coverage_Incentive_Credit'
} as const

export type klaviyo_event_type = (typeof klaviyo_event_type)[keyof typeof klaviyo_event_type]


export const layout_type = {
  popup: 'popup',
  fullscreen: 'fullscreen',
  embedded: 'embedded'
} as const

export type layout_type = (typeof layout_type)[keyof typeof layout_type]


export const learned_preset_kind = {
  carrier_service_level: 'carrier_service_level',
  parcel: 'parcel',
  weight: 'weight'
} as const

export type learned_preset_kind = (typeof learned_preset_kind)[keyof typeof learned_preset_kind]


export const length_unit = {
  in: 'in',
  cm: 'cm'
} as const

export type length_unit = (typeof length_unit)[keyof typeof length_unit]


export const line_item_diff_change_type = {
  added: 'added',
  removed: 'removed',
  quantity_added: 'quantity_added',
  quantity_removed: 'quantity_removed'
} as const

export type line_item_diff_change_type = (typeof line_item_diff_change_type)[keyof typeof line_item_diff_change_type]


export const ListingOptimizationJobStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  ERROR: 'ERROR',
  COMPLETE: 'COMPLETE'
} as const

export type ListingOptimizationJobStatus = (typeof ListingOptimizationJobStatus)[keyof typeof ListingOptimizationJobStatus]


export const ListingType = {
  general: 'general',
  shopify: 'shopify',
  chatgpt: 'chatgpt',
  amazon: 'amazon',
  walmart: 'walmart',
  perplexity: 'perplexity',
  redo_marketplace: 'redo_marketplace',
  ebay: 'ebay',
  google_shopping: 'google_shopping'
} as const

export type ListingType = (typeof ListingType)[keyof typeof ListingType]


export const llm_thread_mode = {
  prod: 'prod',
  eval: 'eval'
} as const

export type llm_thread_mode = (typeof llm_thread_mode)[keyof typeof llm_thread_mode]


export const location_source = {
  warranty_registration: 'warranty_registration',
  billing_address: 'billing_address',
  ip_address: 'ip_address',
  api: 'api'
} as const

export type location_source = (typeof location_source)[keyof typeof location_source]


export const loyalty_earning_rule_type = {
  purchase: 'purchase',
  accountCreation: 'accountCreation',
  instagram: 'instagram',
  facebook: 'facebook',
  tiktok: 'tiktok',
  birthday: 'birthday',
  review: 'review'
} as const

export type loyalty_earning_rule_type = (typeof loyalty_earning_rule_type)[keyof typeof loyalty_earning_rule_type]


export const loyalty_lion_insights_segment = {
  At_Risk: 'At_Risk',
  Win_Back: 'Win_Back',
  Loyal: 'Loyal'
} as const

export type loyalty_lion_insights_segment = (typeof loyalty_lion_insights_segment)[keyof typeof loyalty_lion_insights_segment]


export const loyalty_point_adjustment_type = {
  multiplier: 'multiplier',
  bonus: 'bonus'
} as const

export type loyalty_point_adjustment_type = (typeof loyalty_point_adjustment_type)[keyof typeof loyalty_point_adjustment_type]


export const loyalty_promotion_condition_type = {
  all_purchases: 'all_purchases',
  minimum_order_amount: 'minimum_order_amount',
  first_purchase_only: 'first_purchase_only'
} as const

export type loyalty_promotion_condition_type = (typeof loyalty_promotion_condition_type)[keyof typeof loyalty_promotion_condition_type]


export const loyalty_promotion_recurring_pattern = {
  none: 'none',
  always: 'always',
  weekly: 'weekly',
  monthly: 'monthly'
} as const

export type loyalty_promotion_recurring_pattern = (typeof loyalty_promotion_recurring_pattern)[keyof typeof loyalty_promotion_recurring_pattern]


export const macro_status_to_set = {
  open: 'open',
  snoozed: 'snoozed',
  closed: 'closed'
} as const

export type macro_status_to_set = (typeof macro_status_to_set)[keyof typeof macro_status_to_set]


export const manage_customer_tags_operation = {
  add: 'add',
  remove: 'remove'
} as const

export type manage_customer_tags_operation = (typeof manage_customer_tags_operation)[keyof typeof manage_customer_tags_operation]


export const managed_user_roles = {
  admin: 'admin',
  user: 'user',
  reply_only: 'reply_only',
  view_only: 'view_only',
  warehouse_user: 'warehouse_user',
  warehouse_packer: 'warehouse_packer',
  warehouse_picker: 'warehouse_picker',
  ims_finance: 'ims_finance',
  ims_operations: 'ims_operations'
} as const

export type managed_user_roles = (typeof managed_user_roles)[keyof typeof managed_user_roles]


export const manifest_type = {
  synchronous: 'synchronous',
  asynchronous: 'asynchronous'
} as const

export type manifest_type = (typeof manifest_type)[keyof typeof manifest_type]


export const marketing_agent = {
  contentGeneratorAgent: 'contentGeneratorAgent'
} as const

export type marketing_agent = (typeof marketing_agent)[keyof typeof marketing_agent]


export const marketing_agent_decision_type = {
  sentinel: 'sentinel',
  vanguard: 'vanguard',
  writer: 'writer'
} as const

export type marketing_agent_decision_type = (typeof marketing_agent_decision_type)[keyof typeof marketing_agent_decision_type]


export const marketing_channel = {
  email: 'email',
  sms: 'sms'
} as const

export type marketing_channel = (typeof marketing_channel)[keyof typeof marketing_channel]


export const marketing_consent_status = {
  not_subscribed: 'not_subscribed',
  subscribed: 'subscribed',
  confirmed: 'confirmed',
  unsubscribed: 'unsubscribed'
} as const

export type marketing_consent_status = (typeof marketing_consent_status)[keyof typeof marketing_consent_status]


export const marketing_conversation_status = {
  ready_to_send_reply_message: 'ready_to_send_reply_message',
  reply_message_flagged: 'reply_message_flagged',
  ready_to_send_initial_message: 'ready_to_send_initial_message',
  initial_message_flagged: 'initial_message_flagged',
  waiting_for_reply_message_generation: 'waiting_for_reply_message_generation',
  waiting_for_customer_reply: 'waiting_for_customer_reply',
  initial_message_rescheduled: 'initial_message_rescheduled',
  reply_message_rescheduled: 'reply_message_rescheduled',
  sending_message: 'sending_message',
  failed_to_send_message: 'failed_to_send_message',
  draft_message_skipped: 'draft_message_skipped',
  empty: 'empty',
  conversation_ended: 'conversation_ended',
  dev_ready_to_send_reply_message: 'dev_ready_to_send_reply_message',
  dev_reply_message_flagged: 'dev_reply_message_flagged',
  dev_ready_to_send_initial_message: 'dev_ready_to_send_initial_message',
  dev_initial_message_flagged: 'dev_initial_message_flagged'
} as const

export type marketing_conversation_status = (typeof marketing_conversation_status)[keyof typeof marketing_conversation_status]


export const marketing_conversation_topic = {
  recover: 'recover',
  returns: 'returns',
  mobileMessage: 'mobileMessage'
} as const

export type marketing_conversation_topic = (typeof marketing_conversation_topic)[keyof typeof marketing_conversation_topic]


export const marketing_conversation_type = {
  RECOVER: 'RECOVER',
  MARKETING: 'MARKETING',
  CONCIERGE: 'CONCIERGE'
} as const

export type marketing_conversation_type = (typeof marketing_conversation_type)[keyof typeof marketing_conversation_type]


export const marketing_entry_point = {
  form: 'form',
  shopify: 'shopify',
  backfill: 'backfill',
  commentsold: 'commentsold',
  save_for_later: 'save_for_later',
  login: 'login',
  order_tracking: 'order_tracking',
  import: 'import',
  unknown: 'unknown',
  merchant: 'merchant',
  warranty_registration: 'warranty_registration',
  meta_lead_ads: 'meta_lead_ads',
  postscript: 'postscript',
  order_tracking_page: 'order_tracking_page',
  text_to_subscribe: 'text_to_subscribe',
  text_keyword_to_subscribe: 'text_keyword_to_subscribe',
  public_api: 'public_api',
  alia: 'alia',
  klaviyo_sync: 'klaviyo_sync'
} as const

export type marketing_entry_point = (typeof marketing_entry_point)[keyof typeof marketing_entry_point]


export const marketing_forge_element_type = {
  rich_text: 'rich_text',
  button: 'button',
  input: 'input',
  image: 'image',
  product: 'product',
  column: 'column',
  container: 'container',
  discount: 'discount',
  text_to_subscribe_button: 'text_to_subscribe_button',
  text_to_subscribe_description: 'text_to_subscribe_description'
} as const

export type marketing_forge_element_type = (typeof marketing_forge_element_type)[keyof typeof marketing_forge_element_type]


export const marketing_message_type = {
  INITIAL: 'INITIAL',
  REPLY: 'REPLY'
} as const

export type marketing_message_type = (typeof marketing_message_type)[keyof typeof marketing_message_type]


export const marketing_subscribe_keyword_status = {
  active: 'active',
  inactive: 'inactive'
} as const

export type marketing_subscribe_keyword_status = (typeof marketing_subscribe_keyword_status)[keyof typeof marketing_subscribe_keyword_status]


export const marketing_suppression_reason = {
  permanent_error: 'permanent_error',
  temporary_error: 'temporary_error',
  invalid_channel_id: 'invalid_channel_id',
  merchant: 'merchant',
  spam_complaint: 'spam_complaint'
} as const

export type marketing_suppression_reason = (typeof marketing_suppression_reason)[keyof typeof marketing_suppression_reason]


export const merchant_agent_feedback_source = {
  intercom_email_draft: 'intercom_email_draft',
  intercom_inbox_app: 'intercom_inbox_app',
  slack_messaging: 'slack_messaging'
} as const

export type merchant_agent_feedback_source = (typeof merchant_agent_feedback_source)[keyof typeof merchant_agent_feedback_source]


export const merchant_chat_escalation_status = {
  waiting: 'waiting',
  human_active: 'human_active',
  closed: 'closed'
} as const

export type merchant_chat_escalation_status = (typeof merchant_chat_escalation_status)[keyof typeof merchant_chat_escalation_status]


export const merchant_recommended_exchange_grouping_type = {
  collection: 'collection',
  tag: 'tag'
} as const

export type merchant_recommended_exchange_grouping_type = (typeof merchant_recommended_exchange_grouping_type)[keyof typeof merchant_recommended_exchange_grouping_type]


export const merchant_sentiment_value = {
  positive: 'positive',
  negative: 'negative',
  neutral: 'neutral',
  none: 'none'
} as const

export type merchant_sentiment_value = (typeof merchant_sentiment_value)[keyof typeof merchant_sentiment_value]


export const mercury_model_mode = {
  ENABLED: 'ENABLED',
  LITE_ENABLED: 'LITE_ENABLED',
  SHADOW: 'SHADOW',
  DISABLED: 'DISABLED'
} as const

export type mercury_model_mode = (typeof mercury_model_mode)[keyof typeof mercury_model_mode]


export const message_content_type = {
  text: 'text',
  toolConfirmationPrompt: 'toolConfirmationPrompt'
} as const

export type message_content_type = (typeof message_content_type)[keyof typeof message_content_type]


export const message_direction = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND'
} as const

export type message_direction = (typeof message_direction)[keyof typeof message_direction]


export const message_processing_status = {
  pending: 'pending',
  processing: 'processing',
  processed: 'processed',
  failed: 'failed'
} as const

export type message_processing_status = (typeof message_processing_status)[keyof typeof message_processing_status]


export const message_sender_type = {
  merchant: 'merchant',
  customer: 'customer',
  system: 'system'
} as const

export type message_sender_type = (typeof message_sender_type)[keyof typeof message_sender_type]


export const metric_name = {
  page_viewed: 'page_viewed',
  product_added_to_cart: 'product_added_to_cart',
  cart_viewed: 'cart_viewed',
  checkout_started: 'checkout_started',
  checkout_completed: 'checkout_completed',
  total_spent: 'total_spent',
  total_merchant_items_purchased: 'total_merchant_items_purchased',
  return_purchased: 'return_purchased',
  package_protection_purchased: 'package_protection_purchased',
  return_package_protection_purchased: 'return_package_protection_purchased',
  ew_eligible_product_purchased: 'ew_eligible_product_purchased',
  ew_purchased: 'ew_purchased',
  shipping_revenue: 'shipping_revenue',
  signup_form_viewed: 'signup_form_viewed',
  signup_form_submitted: 'signup_form_submitted',
  rescue_panel_triggered: 'rescue_panel_triggered',
  rescue_panel_cta_clicked: 'rescue_panel_cta_clicked',
  support_conversation_started: 'support_conversation_started',
  support_conversation_resolved: 'support_conversation_resolved',
  support_conversation_escalated: 'support_conversation_escalated',
  support_customer_responded: 'support_customer_responded',
  support_resolution_revenue_generated: 'support_resolution_revenue_generated',
  support_conversation_message_count: 'support_conversation_message_count',
  support_customer_message_count: 'support_customer_message_count',
  support_products_added_to_cart_count: 'support_products_added_to_cart_count',
  support_cart_value_added_cents: 'support_cart_value_added_cents',
  support_orders_produced_count: 'support_orders_produced_count',
  support_total_cost: 'support_total_cost'
} as const

export type metric_name = (typeof metric_name)[keyof typeof metric_name]


export const metric_type = {
  outreach: 'outreach',
  checkout_visit: 'checkout_visit',
  marketing_usage: 'marketing_usage',
  recover_conversation: 'recover_conversation'
} as const

export type metric_type = (typeof metric_type)[keyof typeof metric_type]


export const mobile_message_flow_status = {
  active: 'active',
  completed: 'completed',
  abandoned: 'abandoned',
  escalated: 'escalated'
} as const

export type mobile_message_flow_status = (typeof mobile_message_flow_status)[keyof typeof mobile_message_flow_status]


export const mobile_message_flow_type = {
  order_tracking: 'order_tracking',
  bracketing: 'bracketing',
  return_initiation: 'return_initiation'
} as const

export type mobile_message_flow_type = (typeof mobile_message_flow_type)[keyof typeof mobile_message_flow_type]


export const netsuite_auth_method = {
  tba: 'tba',
  oauth2: 'oauth2'
} as const

export type netsuite_auth_method = (typeof netsuite_auth_method)[keyof typeof netsuite_auth_method]


export const netsuite_item_value_type = {
  credit: 'credit',
  refund: 'refund',
  total: 'total',
  total_pre_discount: 'total_pre_discount'
} as const

export type netsuite_item_value_type = (typeof netsuite_item_value_type)[keyof typeof netsuite_item_value_type]


export const netsuite_tax_mode = {
  celigo: 'celigo',
  override: 'override'
} as const

export type netsuite_tax_mode = (typeof netsuite_tax_mode)[keyof typeof netsuite_tax_mode]


export const netsuite_transaction_type = {
  cash_sale: 'cash_sale',
  sales_order: 'sales_order',
  both: 'both'
} as const

export type netsuite_transaction_type = (typeof netsuite_transaction_type)[keyof typeof netsuite_transaction_type]


export const non_delivery_option = {
  return: 'return',
  abandon: 'abandon'
} as const

export type non_delivery_option = (typeof non_delivery_option)[keyof typeof non_delivery_option]


export const notification_channel = {
  browser: 'browser'
} as const

export type notification_channel = (typeof notification_channel)[keyof typeof notification_channel]


export const notification_kind = {
  assignment: 'assignment',
  rollup: 'rollup'
} as const

export type notification_kind = (typeof notification_kind)[keyof typeof notification_kind]


export const notification_status = {
  sent: 'sent'
} as const

export type notification_status = (typeof notification_status)[keyof typeof notification_status]


export const oms_insurance_provider = {
  easypost: 'easypost',
  shipsurance: 'shipsurance'
} as const

export type oms_insurance_provider = (typeof oms_insurance_provider)[keyof typeof oms_insurance_provider]


export const onboarding_conversation_gap_status = {
  open: 'open',
  converted: 'converted',
  dismissed: 'dismissed'
} as const

export type onboarding_conversation_gap_status = (typeof onboarding_conversation_gap_status)[keyof typeof onboarding_conversation_gap_status]


export const onboarding_knowledge_entry_category = {
  industry_playbook: 'industry_playbook',
  edge_case: 'edge_case',
  objection_handling: 'objection_handling',
  integration_guide: 'integration_guide',
  product_category: 'product_category',
  regional_compliance: 'regional_compliance',
  conversation_pattern: 'conversation_pattern',
  seasonal_playbook: 'seasonal_playbook',
  stakeholder_navigation: 'stakeholder_navigation'
} as const

export type onboarding_knowledge_entry_category = (typeof onboarding_knowledge_entry_category)[keyof typeof onboarding_knowledge_entry_category]


export const onboarding_knowledge_entry_source = {
  pipeline: 'pipeline',
  static_pack: 'static_pack',
  manual: 'manual',
  live_gap: 'live_gap',
  gap_conversion: 'gap_conversion'
} as const

export type onboarding_knowledge_entry_source = (typeof onboarding_knowledge_entry_source)[keyof typeof onboarding_knowledge_entry_source]


export const onboarding_knowledge_entry_status = {
  draft: 'draft',
  active: 'active',
  deprecated: 'deprecated'
} as const

export type onboarding_knowledge_entry_status = (typeof onboarding_knowledge_entry_status)[keyof typeof onboarding_knowledge_entry_status]


export const onboarding_master_type = {
  Self_Serve: 'Self_Serve',
  Custom: 'Custom'
} as const

export type onboarding_master_type = (typeof onboarding_master_type)[keyof typeof onboarding_master_type]


export const onboarding_product = {
  returns: 'returns',
  package_protection: 'package_protection',
  warranties: 'warranties',
  oms: 'oms',
  email_sms: 'email_sms',
  conversion: 'conversion',
  support_ai: 'support_ai',
  ims: 'ims',
  aeo: 'aeo',
  catalog: 'catalog',
  order_tracking: 'order_tracking',
  order_editing: 'order_editing',
  recover: 'recover'
} as const

export type onboarding_product = (typeof onboarding_product)[keyof typeof onboarding_product]


export const onboarding_product_type = {
  returns: 'returns',
  order_editing: 'order_editing',
  oms: 'oms',
  email_sms: 'email_sms',
  conversion: 'conversion',
  support_ai: 'support_ai'
} as const

export type onboarding_product_type = (typeof onboarding_product_type)[keyof typeof onboarding_product_type]


export const onboarding_type = {
  default: 'default',
  custom: 'custom'
} as const

export type onboarding_type = (typeof onboarding_type)[keyof typeof onboarding_type]


export const onboarding_v2_status = {
  partial_completion: 'partial_completion',
  completed: 'completed',
  help_requested: 'help_requested'
} as const

export type onboarding_v2_status = (typeof onboarding_v2_status)[keyof typeof onboarding_v2_status]


export const optty_environment = {
  sandbox: 'sandbox',
  production: 'production'
} as const

export type optty_environment = (typeof optty_environment)[keyof typeof optty_environment]


export const order_edit_kind = {
  address: 'address',
  cancel: 'cancel',
  variant_change: 'variant_change',
  add_product: 'add_product',
  remove_product: 'remove_product',
  discount: 'discount',
  add_quantity: 'add_quantity',
  remove_quantity: 'remove_quantity',
  contact_info: 'contact_info'
} as const

export type order_edit_kind = (typeof order_edit_kind)[keyof typeof order_edit_kind]


export const order_edit_source = {
  support_ai: 'support_ai',
  support_self_service: 'support_self_service',
  customer_portal_self_service: 'customer_portal_self_service',
  email_one_click_upsell: 'email_one_click_upsell'
} as const

export type order_edit_source = (typeof order_edit_source)[keyof typeof order_edit_source]


export const order_item_sort = {
  order_number: 'order_number',
  sku: 'sku',
  upc: 'upc',
  bin: 'bin',
  itemDescription: 'itemDescription',
  quantity: 'quantity',
  customField: 'customField'
} as const

export type order_item_sort = (typeof order_item_sort)[keyof typeof order_item_sort]


export const order_refund_event_type = {
  shipping: 'shipping'
} as const

export type order_refund_event_type = (typeof order_refund_event_type)[keyof typeof order_refund_event_type]


export const orientation = {
  horizontal: 'horizontal',
  vertical: 'vertical'
} as const

export type orientation = (typeof orientation)[keyof typeof orientation]


export const outbound_labels_transaction_type = {
  VOID_LABEL: 'VOID_LABEL',
  VOID_USED_LABEL: 'VOID_USED_LABEL',
  CHARGE_LABEL: 'CHARGE_LABEL',
  ADD_FUNDS: 'ADD_FUNDS',
  REFUND: 'REFUND',
  MISCELLANEOUS: 'MISCELLANEOUS',
  SURCHARGE: 'SURCHARGE',
  RETURN_LABEL: 'RETURN_LABEL',
  MERCHANT_CARRIER_FEE: 'MERCHANT_CARRIER_FEE',
  SUBSCRIPTION_FEE: 'SUBSCRIPTION_FEE',
  REDEEM_POINTS: 'REDEEM_POINTS',
  INSURANCE: 'INSURANCE',
  VOID_INSURANCE: 'VOID_INSURANCE',
  TRANSACTION_FAILURE_CLAWBACK: 'TRANSACTION_FAILURE_CLAWBACK',
  WMS_FEE: 'WMS_FEE',
  REDO_SUPPLY: 'REDO_SUPPLY',
  LANDED_COST_DUTIES: 'LANDED_COST_DUTIES',
  LANDED_COST_TAXES: 'LANDED_COST_TAXES',
  LANDED_COST_FEES: 'LANDED_COST_FEES',
  VOID_LANDED_COST_DUTIES: 'VOID_LANDED_COST_DUTIES',
  VOID_LANDED_COST_TAXES: 'VOID_LANDED_COST_TAXES',
  VOID_LANDED_COST_FEES: 'VOID_LANDED_COST_FEES',
  FREIGHT_PURCHASE: 'FREIGHT_PURCHASE',
  VOID_FREIGHT_PURCHASE: 'VOID_FREIGHT_PURCHASE',
  CARRIER_PICKUP: 'CARRIER_PICKUP'
} as const

export type outbound_labels_transaction_type = (typeof outbound_labels_transaction_type)[keyof typeof outbound_labels_transaction_type]


export const outbound_shipment_purchase_status = {
  purchased: 'purchased',
  failed: 'failed'
} as const

export type outbound_shipment_purchase_status = (typeof outbound_shipment_purchase_status)[keyof typeof outbound_shipment_purchase_status]


export const packing_mode = {
  individual: 'individual',
  case_pack: 'case_pack',
  pallet: 'pallet',
  weight: 'weight'
} as const

export type packing_mode = (typeof packing_mode)[keyof typeof packing_mode]


export const packing_slip_font_weight = {
  normal: 'normal',
  bold: 'bold'
} as const

export type packing_slip_font_weight = (typeof packing_slip_font_weight)[keyof typeof packing_slip_font_weight]


export const packing_slip_sort_direction = {
  Ascending: 'Ascending',
  Descending: 'Descending'
} as const

export type packing_slip_sort_direction = (typeof packing_slip_sort_direction)[keyof typeof packing_slip_sort_direction]


export const packing_template_type = {
  case_pack: 'case_pack',
  pallet: 'pallet'
} as const

export type packing_template_type = (typeof packing_template_type)[keyof typeof packing_template_type]


export const page_orientation = {
  portrait: 'portrait',
  landscape: 'landscape'
} as const

export type page_orientation = (typeof page_orientation)[keyof typeof page_orientation]


export const page_size = {
  full_size: 'full_size',
  half_size: 'half_size',
  label: 'label'
} as const

export type page_size = (typeof page_size)[keyof typeof page_size]


export const payer = {
  customer: 'customer',
  merchant: 'merchant',
  redo: 'redo'
} as const

export type payer = (typeof payer)[keyof typeof payer]


export const payment_responsibility = {
  TRANSPORTATION: 'TRANSPORTATION',
  DUTIES_AND_TAXES: 'DUTIES_AND_TAXES',
  VAT: 'VAT'
} as const

export type payment_responsibility = (typeof payment_responsibility)[keyof typeof payment_responsibility]


export const payment_schedule = {
  prepay: 'prepay',
  postpay: 'postpay'
} as const

export type payment_schedule = (typeof payment_schedule)[keyof typeof payment_schedule]


export const payout_status = {
  new: 'new',
  succeeded: 'succeeded',
  card_declined: 'card_declined',
  resource_missing: 'resource_missing',
  failed: 'failed',
  pending: 'pending'
} as const

export type payout_status = (typeof payout_status)[keyof typeof payout_status]


export const paypal_environment = {
  sandbox: 'sandbox',
  live: 'live'
} as const

export type paypal_environment = (typeof paypal_environment)[keyof typeof paypal_environment]


export const pending_lock_status = {
  pending: 'pending',
  complete: 'complete',
  deleted: 'deleted'
} as const

export type pending_lock_status = (typeof pending_lock_status)[keyof typeof pending_lock_status]


export const phone_number_provider = {
  telnyx: 'telnyx',
  bandwidth: 'bandwidth',
  redo_imessage: 'redo_imessage'
} as const

export type phone_number_provider = (typeof phone_number_provider)[keyof typeof phone_number_provider]


export const phone_number_use_case = {
  marketing: 'marketing',
  transactional: 'transactional',
  support: 'support',
  recover: 'recover'
} as const

export type phone_number_use_case = (typeof phone_number_use_case)[keyof typeof phone_number_use_case]


export const pick_session_status = {
  active: 'active',
  picked: 'picked',
  cancelled: 'cancelled',
  completed: 'completed',
  printed: 'printed',
  problem: 'problem'
} as const

export type pick_session_status = (typeof pick_session_status)[keyof typeof pick_session_status]


export const pill_theme = {
  NORMAL: 'NORMAL',
  PRIMARY_LIGHT: 'PRIMARY_LIGHT',
  LIGHT_PINK: 'LIGHT_PINK',
  DANGER: 'DANGER',
  NEUTRAL_YELLOW: 'NEUTRAL_YELLOW',
  SUCCESS: 'SUCCESS',
  NEUTRAL_BLUE: 'NEUTRAL_BLUE',
  PRIMARY: 'PRIMARY',
  SOLID_WHITE: 'SOLID_WHITE',
  SOLID_PINK: 'SOLID_PINK',
  SOLID_RED: 'SOLID_RED',
  SOLID_ORANGE: 'SOLID_ORANGE',
  SOLID_YELLOW: 'SOLID_YELLOW',
  SOLID_GREEN: 'SOLID_GREEN',
  SOLID_LIGHT_BLUE: 'SOLID_LIGHT_BLUE',
  SOLID_NAVY: 'SOLID_NAVY',
  SOLID_BLACK: 'SOLID_BLACK',
  BRAND: 'BRAND',
  GRAY_BLUE: 'GRAY_BLUE',
  WHITE_SUCCESS: 'WHITE_SUCCESS',
  GRAY_ALTERNATE: 'GRAY_ALTERNATE',
  BRAND_ALTERNATE: 'BRAND_ALTERNATE',
  ERROR_ALTERNATE: 'ERROR_ALTERNATE',
  WARNING_ALTERNATE: 'WARNING_ALTERNATE',
  SUCCESS_ALTERNATE: 'SUCCESS_ALTERNATE',
  GRAY_BLUE_ALTERNATE: 'GRAY_BLUE_ALTERNATE',
  BLUE_LIGHT_ALTERNATE: 'BLUE_LIGHT_ALTERNATE',
  BLUE_ALTERNATE: 'BLUE_ALTERNATE',
  INDIGO_ALTERNATE: 'INDIGO_ALTERNATE',
  PURPLE_ALTERNATE: 'PURPLE_ALTERNATE',
  PINK_ALTERNATE: 'PINK_ALTERNATE',
  ORANGE_ALTERNATE: 'ORANGE_ALTERNATE',
  BLACK_ALTERNATE: 'BLACK_ALTERNATE',
  WHITE_ALTERNATE: 'WHITE_ALTERNATE',
  WHITE_SUCCESS_ALTERNATE: 'WHITE_SUCCESS_ALTERNATE'
} as const

export type pill_theme = (typeof pill_theme)[keyof typeof pill_theme]


export const po_email_frequency = {
  daily: 'daily',
  weekly: 'weekly',
  bi_weekly: 'bi_weekly',
  monthly: 'monthly'
} as const

export type po_email_frequency = (typeof po_email_frequency)[keyof typeof po_email_frequency]


export const po_upload_job_file_status = {
  PENDING: 'PENDING',
  EXTRACTING: 'EXTRACTING',
  MATCHING: 'MATCHING',
  CREATING_PO: 'CREATING_PO',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type po_upload_job_file_status = (typeof po_upload_job_file_status)[keyof typeof po_upload_job_file_status]


export const po_upload_job_status = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type po_upload_job_status = (typeof po_upload_job_status)[keyof typeof po_upload_job_status]


export const postscript_event_type = {
  Order_Tracking_Update: 'Order_Tracking_Update'
} as const

export type postscript_event_type = (typeof postscript_event_type)[keyof typeof postscript_event_type]


export const price_book_status = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED'
} as const

export type price_book_status = (typeof price_book_status)[keyof typeof price_book_status]


export const print_job_status = {
  created: 'created',
  purchased: 'purchased',
  generating: 'generating',
  generated: 'generated',
  initializingPrinting: 'initializingPrinting',
  sentToPrintNode: 'sentToPrintNode',
  printNodeConfirmed: 'printNodeConfirmed',
  sentToPrinter: 'sentToPrinter',
  completed: 'completed',
  batchCompleted: 'batchCompleted',
  failed: 'failed',
  cancelling: 'cancelling',
  cancelled: 'cancelled'
} as const

export type print_job_status = (typeof print_job_status)[keyof typeof print_job_status]


export const printable_document = {
  pickList: 'pickList',
  packingSlip: 'packingSlip',
  label: 'label',
  commercialInvoice: 'commercialInvoice',
  personalizedSlip: 'personalizedSlip',
  returnLabel: 'returnLabel',
  localPickUpLabel: 'localPickUpLabel',
  billOfLading: 'billOfLading',
  parcelPackingSlip: 'parcelPackingSlip'
} as const

export type printable_document = (typeof printable_document)[keyof typeof printable_document]


export const procedure_execution_status = {
  pending: 'pending',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
  stopped: 'stopped'
} as const

export type procedure_execution_status = (typeof procedure_execution_status)[keyof typeof procedure_execution_status]


export const process_return_item_initiator_type = {
  manual: 'manual',
  automated: 'automated'
} as const

export type process_return_item_initiator_type = (typeof process_return_item_initiator_type)[keyof typeof process_return_item_initiator_type]


export const product_criteria_type = {
  collections: 'collections',
  tags: 'tags'
} as const

export type product_criteria_type = (typeof product_criteria_type)[keyof typeof product_criteria_type]


export const ProductFamilyKind = {
  SELLABLE: 'SELLABLE',
  NON_SELLABLE: 'NON_SELLABLE'
} as const

export type ProductFamilyKind = (typeof ProductFamilyKind)[keyof typeof ProductFamilyKind]


export const ProductInventoryPolicy = {
  CONTINUE: 'CONTINUE',
  DENY: 'DENY'
} as const

export type ProductInventoryPolicy = (typeof ProductInventoryPolicy)[keyof typeof ProductInventoryPolicy]


export const product_metric_type = {
  sold_30: 'sold_30',
  sold_60: 'sold_60',
  sold_90: 'sold_90',
  sold_180: 'sold_180',
  sold_365: 'sold_365',
  forecast_30: 'forecast_30',
  forecast_60: 'forecast_60',
  forecast_90: 'forecast_90',
  forecast_180: 'forecast_180',
  forecast_365: 'forecast_365'
} as const

export type product_metric_type = (typeof product_metric_type)[keyof typeof product_metric_type]


export const product_processing_spec_kind = {
  evaluation: 'evaluation',
  validation: 'validation'
} as const

export type product_processing_spec_kind = (typeof product_processing_spec_kind)[keyof typeof product_processing_spec_kind]


export const product_processing_spec_rule = {
  item_like_new: 'item_like_new',
  factory_sealed: 'factory_sealed',
  new_condition: 'new_condition',
  item_wear: 'item_wear',
  new_condition_after_cleaning: 'new_condition_after_cleaning',
  view: 'view',
  restock: 'restock',
  donate: 'donate',
  recycle: 'recycle',
  refurbish: 'refurbish',
  resell: 'resell'
} as const

export type product_processing_spec_rule = (typeof product_processing_spec_rule)[keyof typeof product_processing_spec_rule]


export const product_recommendation_type = {
  shopify_recommendations: 'shopify_recommendations',
  collection: 'collection',
  collections: 'collections',
  metafield: 'metafield',
  tag: 'tag',
  best_sellers: 'best_sellers',
  most_viewed: 'most_viewed',
  newest_products: 'newest_products',
  random_products: 'random_products',
  viewed_products: 'viewed_products',
  products_added_to_cart: 'products_added_to_cart'
} as const

export type product_recommendation_type = (typeof product_recommendation_type)[keyof typeof product_recommendation_type]


export const product_selection_type = {
  dynamic: 'dynamic',
  static: 'static'
} as const

export type product_selection_type = (typeof product_selection_type)[keyof typeof product_selection_type]


export const product_sort_type = {
  random: 'random',
  created_at: 'created_at',
  price_asc: 'price_asc',
  price_desc: 'price_desc',
  title: 'title'
} as const

export type product_sort_type = (typeof product_sort_type)[keyof typeof product_sort_type]


export const prompt_category = {
  strategy: 'strategy',
  trigger: 'trigger',
  goal: 'goal',
  method: 'method',
  scenario: 'scenario',
  context_tools: 'context_tools'
} as const

export type prompt_category = (typeof prompt_category)[keyof typeof prompt_category]


export const prompt_kind = {
  return_review_system: 'return_review_system',
  return_review_store_policy: 'return_review_store_policy',
  return_chat_system: 'return_chat_system',
  return_settings_context: 'return_settings_context',
  return_totals_context: 'return_totals_context',
  return_flow_context: 'return_flow_context',
  oms_address_correction: 'oms_address_correction',
  oms_address_comparison: 'oms_address_comparison',
  oms_ups_ghost_account_address: 'oms_ups_ghost_account_address',
  slack_message_categorization_system: 'slack_message_categorization_system',
  return_chat_v2_system: 'return_chat_v2_system',
  oms_merchant_agent_system: 'oms_merchant_agent_system',
  marketing_merchant_agent_system: 'marketing_merchant_agent_system',
  checkout_experience_validation_system: 'checkout_experience_validation_system'
} as const

export type prompt_kind = (typeof prompt_kind)[keyof typeof prompt_kind]


export const prompt_scope = {
  user: 'user',
  team: 'team',
  default: 'default'
} as const

export type prompt_scope = (typeof prompt_scope)[keyof typeof prompt_scope]


export const provider = {
  commentsold: 'commentsold',
  shopify: 'shopify',
  commerce_cloud: 'commerce_cloud',
  bigcommerce: 'bigcommerce',
  netsuite: 'netsuite',
  manual: 'manual',
  tiktok: 'tiktok',
  amazon: 'amazon',
  walmart: 'walmart',
  ebay: 'ebay',
  apparel_magic: 'apparel_magic',
  redo_marketplace: 'redo_marketplace',
  sfom: 'sfom',
  aims360: 'aims360',
  cin7_omni: 'cin7_omni',
  cin7_core: 'cin7_core',
  redo_api: 'redo_api',
  custom_return_integration: 'custom_return_integration',
  redo: 'redo',
  faire: 'faire',
  wayfair: 'wayfair'
} as const

export type provider = (typeof provider)[keyof typeof provider]


export const provider_type = {
  exchange: 'exchange',
  storeCredit: 'storeCredit',
  refund: 'refund',
  shipping: 'shipping',
  orders: 'orders',
  products: 'products'
} as const

export type provider_type = (typeof provider_type)[keyof typeof provider_type]


export const provision_type = {
  instant: 'instant',
  processed: 'processed'
} as const

export type provision_type = (typeof provision_type)[keyof typeof provision_type]


export const purchase_channel = {
  retail: 'retail',
  online: 'online'
} as const

export type purchase_channel = (typeof purchase_channel)[keyof typeof purchase_channel]


export const qr_code_link_type = {
  web_page: 'web_page',
  dynamic_variable: 'dynamic_variable'
} as const

export type qr_code_link_type = (typeof qr_code_link_type)[keyof typeof qr_code_link_type]


export const qr_code_size = {
  Extra_Small: 'Extra_Small',
  Small: 'Small',
  Medium: 'Medium',
  Large: 'Large'
} as const

export type qr_code_size = (typeof qr_code_size)[keyof typeof qr_code_size]


export const rate_provider = {
  SOAP_BOX: 'SOAP_BOX',
  EASYPOST: 'EASYPOST',
  UPS: 'UPS',
  LANDMARK_GLOBAL: 'LANDMARK_GLOBAL',
  REDO_LANDMARK_GLOBAL: 'REDO_LANDMARK_GLOBAL',
  INTERNATIONAL_BRIDGE: 'INTERNATIONAL_BRIDGE',
  ETA_EXPRESS: 'ETA_EXPRESS',
  TEST_CARRIER: 'TEST_CARRIER',
  FEDEX: 'FEDEX',
  USPS: 'USPS',
  DHL_ECOMMERCE: 'DHL_ECOMMERCE',
  GLOBALE: 'GLOBALE',
  TIKTOK: 'TIKTOK',
  CanadaPost: 'CanadaPost'
} as const

export type rate_provider = (typeof rate_provider)[keyof typeof rate_provider]


export const rate_table_carrier = {
  USPS: 'USPS',
  USPSReturns: 'USPSReturns',
  FedEx: 'FedEx',
  UPS: 'UPS',
  UPSSurePost: 'UPSSurePost',
  Amazon: 'Amazon',
  DHLExpress: 'DHLExpress',
  Veho: 'Veho',
  FirstMile: 'FirstMile',
  AustraliaPost: 'AustraliaPost',
  CanadaPost: 'CanadaPost',
  DHL_ECS: 'DHL_ECS',
  APC: 'APC',
  GLS: 'GLS',
  Asendia: 'Asendia',
  RoyalMailV3: 'RoyalMailV3',
  SpeeDee: 'SpeeDee',
  PassportGlobal: 'PassportGlobal',
  LandmarkGlobal: 'LandmarkGlobal',
  OnTracV3: 'OnTracV3',
  UniUni: 'UniUni'
} as const

export type rate_table_carrier = (typeof rate_table_carrier)[keyof typeof rate_table_carrier]


export const rate_table_length_unit = {
  in: 'in',
  cm: 'cm'
} as const

export type rate_table_length_unit = (typeof rate_table_length_unit)[keyof typeof rate_table_length_unit]


export const rate_table_service_level = {
  Ground_Advantage: 'Ground_Advantage',
  Priority: 'Priority',
  Express: 'Express',
  First_Class: 'First_Class',
  First_Class_Mail_International: 'First_Class_Mail_International',
  GroundAdvantageReturn: 'GroundAdvantageReturn',
  GroundReturn: 'GroundReturn',
  PriorityMailReturn: 'PriorityMailReturn',
  FirstClassPkgReturn: 'FirstClassPkgReturn',
  Ground: 'Ground',
  Smart_Post: 'Smart_Post',
  One_Rate_Express_Saver: 'One_Rate_Express_Saver',
  One_Rate_Two_Day: 'One_Rate_Two_Day',
  One_Rate_Two_Day_AM: 'One_Rate_Two_Day_AM',
  One_Rate_Standard_Overnight: 'One_Rate_Standard_Overnight',
  One_Rate_Priority_Overnight: 'One_Rate_Priority_Overnight',
  One_Rate_First_Overnight: 'One_Rate_First_Overnight',
  International_Priority: 'International_Priority',
  International_Priority_Express: 'International_Priority_Express',
  International_Connect_Plus: 'International_Connect_Plus',
  International_First: 'International_First',
  International_Economy: 'International_Economy',
  Europe_First_International_Priority: 'Europe_First_International_Priority',
  International_Economy_Freight: 'International_Economy_Freight',
  International_Priority_Freight: 'International_Priority_Freight',
  NextDayAir: 'NextDayAir',
  DaySelect: 'DaySelect',
  ndDayAirAM: 'ndDayAirAM',
  NextDayAirEarlyAM: 'NextDayAirEarlyAM',
  UPSSaver: 'UPSSaver',
  ExpressPlus: 'ExpressPlus',
  Expedited: 'Expedited',
  NextDayAirSaver: 'NextDayAirSaver',
  UPSStandard: 'UPSStandard',
  ndDayAir: 'ndDayAir',
  SurePostUnder1Lb: 'SurePostUnder1Lb',
  SurePostOver1Lb: 'SurePostOver1Lb',
  ExpressEarly: 'ExpressEarly',
  ExpressSaver: 'ExpressSaver',
  Amazon_Shipping_Ground: 'Amazon_Shipping_Ground',
  BreakBulkEconomy: 'BreakBulkEconomy',
  BreakBulkExpress: 'BreakBulkExpress',
  DomesticEconomySelect: 'DomesticEconomySelect',
  DomesticExpress: 'DomesticExpress',
  DomesticExpress1030: 'DomesticExpress1030',
  DomesticExpress1200: 'DomesticExpress1200',
  EconomySelect: 'EconomySelect',
  EconomySelectNonDoc: 'EconomySelectNonDoc',
  EuroPack: 'EuroPack',
  EuropackNonDoc: 'EuropackNonDoc',
  Express1030: 'Express1030',
  Express1030NonDoc: 'Express1030NonDoc',
  Express1200NonDoc: 'Express1200NonDoc',
  Express1200: 'Express1200',
  Express900: 'Express900',
  Express900NonDoc: 'Express900NonDoc',
  ExpressEasy: 'ExpressEasy',
  ExpressEasyNonDoc: 'ExpressEasyNonDoc',
  ExpressEnvelope: 'ExpressEnvelope',
  ExpressWorldwide: 'ExpressWorldwide',
  ExpressWorldwideB2C: 'ExpressWorldwideB2C',
  ExpressWorldwideB2CNonDoc: 'ExpressWorldwideB2CNonDoc',
  ExpressWorldwideECX: 'ExpressWorldwideECX',
  ExpressWorldwideNonDoc: 'ExpressWorldwideNonDoc',
  FreightWorldwide: 'FreightWorldwide',
  GlobalmailBusiness: 'GlobalmailBusiness',
  JetLine: 'JetLine',
  JumboBox: 'JumboBox',
  LogisticsServices: 'LogisticsServices',
  SameDay: 'SameDay',
  SecureLine: 'SecureLine',
  SprintLine: 'SprintLine',
  MedicalExpressNonDoc: 'MedicalExpressNonDoc',
  nextDay: 'nextDay',
  sameDay: 'sameDay',
  XParcelGround: 'XParcelGround',
  XParcelPriority: 'XParcelPriority',
  XParcelExpedited: 'XParcelExpedited',
  XParcelExpeditedPlus: 'XParcelExpeditedPlus',
  ParcelPost: 'ParcelPost',
  ExpressPost: 'ExpressPost',
  International: 'International',
  Commercial: 'Commercial',
  ParcelPostSignature: 'ParcelPostSignature',
  ExpressPostSignature: 'ExpressPostSignature',
  InternationalSignature: 'InternationalSignature',
  CommercialSignature: 'CommercialSignature',
  EParcel1: 'EParcel1',
  EParcelPostReturns: 'EParcelPostReturns',
  ExpressParcelPostReturns: 'ExpressParcelPostReturns',
  ExpressPostEParcel: 'ExpressPostEParcel',
  InternationalEconomyAirmailParcels: 'InternationalEconomyAirmailParcels',
  InternationalEconomyWSODREGPost: 'InternationalEconomyWSODREGPost',
  InternationalExpressDocSecIDocs: 'InternationalExpressDocSecIDocs',
  InternationalExpressMerchandise: 'InternationalExpressMerchandise',
  InternationalExpressMerchECIMerch: 'InternationalExpressMerchECIMerch',
  InternationalStandardPackTrack: 'InternationalStandardPackTrack',
  ParcelPostExtra: 'ParcelPostExtra',
  ParcelPostWinePlusSignature: 'ParcelPostWinePlusSignature',
  ParcelPostWineSignature: 'ParcelPostWineSignature',
  ExpressEparcelPostReturns: 'ExpressEparcelPostReturns',
  EparcelPostReturns: 'EparcelPostReturns',
  IntlExpressDocs: 'IntlExpressDocs',
  IntlStandardPackTrack: 'IntlStandardPackTrack',
  IntLStandardWithSignature: 'IntLStandardWithSignature',
  IntlExpressMerch: 'IntlExpressMerch',
  RegularParcel: 'RegularParcel',
  ExpeditedParcel: 'ExpeditedParcel',
  Xpresspost: 'Xpresspost',
  ExpeditedParcelUSA: 'ExpeditedParcelUSA',
  SmallPacketUSAAir: 'SmallPacketUSAAir',
  TrackedPacketUSA: 'TrackedPacketUSA',
  TrackedPacketUSALVM: 'TrackedPacketUSALVM',
  XpresspostUSA: 'XpresspostUSA',
  XpresspostInternational: 'XpresspostInternational',
  InternationalParcelAir: 'InternationalParcelAir',
  InternationalParcelSurface: 'InternationalParcelSurface',
  SmallPacketInternationalAir: 'SmallPacketInternationalAir',
  SmallPacketInternationalSurface: 'SmallPacketInternationalSurface',
  TrackedPacketInternational: 'TrackedPacketInternational',
  ExpeditedParcelPlus: 'ExpeditedParcelPlus',
  DHLParcelExpedited: 'DHLParcelExpedited',
  DHLParcelExpeditedMax: 'DHLParcelExpeditedMax',
  DHLParcelGround: 'DHLParcelGround',
  DHLParcelInternationalDirect: 'DHLParcelInternationalDirect',
  DHLParcelInternationalStandard: 'DHLParcelInternationalStandard',
  DHLPacketInternational: 'DHLPacketInternational',
  DHLParcelInternationalDirectPriority: 'DHLParcelInternationalDirectPriority',
  DHLParcelInternationalDirectStandard: 'DHLParcelInternationalDirectStandard',
  DHLParcelInternationalDirectSMB: 'DHLParcelInternationalDirectSMB',
  DHLParcelInternationalStandardSMB: 'DHLParcelInternationalStandardSMB',
  DHLBPMExpedited: 'DHLBPMExpedited',
  DHLBPMGround: 'DHLBPMGround',
  DHLSmartMailParcelReturnGround: 'DHLSmartMailParcelReturnGround',
  DHLSmartMailParcelReturnPlus: 'DHLSmartMailParcelReturnPlus',
  DHLSmartMailParcelReturnLight: 'DHLSmartMailParcelReturnLight',
  parcelConnectBookService: 'parcelConnectBookService',
  parcelConnectExpeditedDDP: 'parcelConnectExpeditedDDP',
  parcelConnectExpeditedDDU: 'parcelConnectExpeditedDDU',
  parcelConnectPriorityDDP: 'parcelConnectPriorityDDP',
  parcelConnectPriorityDDPDelcon: 'parcelConnectPriorityDDPDelcon',
  parcelConnectPriorityDDU: 'parcelConnectPriorityDDU',
  parcelConnectPriorityDDUDelcon: 'parcelConnectPriorityDDUDelcon',
  parcelConnectPriorityDDUPQW: 'parcelConnectPriorityDDUPQW',
  parcelConnectStandardDDU: 'parcelConnectStandardDDU',
  parcelConnectStandardDDUPQW: 'parcelConnectStandardDDUPQW',
  parcelConnectPacketDDU: 'parcelConnectPacketDDU',
  APCePMIDDP: 'APCePMIDDP',
  APCePMEIDDP: 'APCePMEIDDP',
  APCPacketDDP: 'APCPacketDDP',
  APCUSPSInternationalPriorityMailExpress: 'APCUSPSInternationalPriorityMailExpress',
  APCDDU_: 'APCDDU_',
  APCPriorityDDU_: 'APCPriorityDDU_',
  APCPriorityDDU_Delcon: 'APCPriorityDDU_Delcon',
  APCePacketDDU_: 'APCePacketDDU_',
  APCPMIDDU_: 'APCPMIDDU_',
  APCPriorityPQW_: 'APCPriorityPQW_',
  APCUSA: 'APCUSA',
  APCUSAGround: 'APCUSAGround',
  APCUSAExpress: 'APCUSAExpress',
  APCUSA2: 'APCUSA2',
  APCUSA3: 'APCUSA3',
  EarlyPriorityOvernight: 'EarlyPriorityOvernight',
  PriorityOvernight: 'PriorityOvernight',
  CaliforniaParcelService: 'CaliforniaParcelService',
  SaturdayDeliveryService: 'SaturdayDeliveryService',
  EarlySaturdayService: 'EarlySaturdayService',
  NoonPriorityService: 'NoonPriorityService',
  ADS: 'ADS',
  AirFreightInbound: 'AirFreightInbound',
  AirFreightOutbound: 'AirFreightOutbound',
  AsendiaDomesticBoundPrinterMatterExpedited: 'AsendiaDomesticBoundPrinterMatterExpedited',
  AsendiaDomesticBoundPrinterMatterGround: 'AsendiaDomesticBoundPrinterMatterGround',
  AsendiaDomesticFlatsExpedited: 'AsendiaDomesticFlatsExpedited',
  AsendiaDomesticFlatsGround: 'AsendiaDomesticFlatsGround',
  AsendiaDomesticParcelGroundOver1lb: 'AsendiaDomesticParcelGroundOver1lb',
  AsendiaDomesticParcelGroundUnder1lb: 'AsendiaDomesticParcelGroundUnder1lb',
  AsendiaDomesticParcelMAXOver1lb: 'AsendiaDomesticParcelMAXOver1lb',
  AsendiaDomesticParcelMAXUnder1lb: 'AsendiaDomesticParcelMAXUnder1lb',
  AsendiaDomesticParcelOver1lbExpedited: 'AsendiaDomesticParcelOver1lbExpedited',
  AsendiaDomesticParcelUnder1lbExpedited: 'AsendiaDomesticParcelUnder1lbExpedited',
  AsendiaDomesticPromoParcelExpedited: 'AsendiaDomesticPromoParcelExpedited',
  AsendiaDomesticPromoParcelGround: 'AsendiaDomesticPromoParcelGround',
  BulkFreight: 'BulkFreight',
  BusinessMailCanadaLettermail: 'BusinessMailCanadaLettermail',
  BusinessMailCanadaLettermailMachineable: 'BusinessMailCanadaLettermailMachineable',
  BusinessMailEconomy: 'BusinessMailEconomy',
  BusinessMailEconomyLPWholesale: 'BusinessMailEconomyLPWholesale',
  BusinessMailEconomySPWholesale: 'BusinessMailEconomySPWholesale',
  BusinessMailIPA: 'BusinessMailIPA',
  BusinessMailISAL: 'BusinessMailISAL',
  BusinessMailPriority: 'BusinessMailPriority',
  BusinessMailPriorityLPWholesale: 'BusinessMailPriorityLPWholesale',
  BusinessMailPrioritySPWholesale: 'BusinessMailPrioritySPWholesale',
  MarketingMailCanadaPersonalizedLCP: 'MarketingMailCanadaPersonalizedLCP',
  MarketingMailCanadaPersonalizedMachineable: 'MarketingMailCanadaPersonalizedMachineable',
  MarketingMailCanadaPersonalizedNDG: 'MarketingMailCanadaPersonalizedNDG',
  MarketingMailEconomy: 'MarketingMailEconomy',
  MarketingMailIPA: 'MarketingMailIPA',
  MarketingMailISAL: 'MarketingMailISAL',
  MarketingMailPriority: 'MarketingMailPriority',
  PublicationsCanadaLCP: 'PublicationsCanadaLCP',
  PublicationsCanadaNDG: 'PublicationsCanadaNDG',
  PublicationsEconomy: 'PublicationsEconomy',
  PublicationsIPA: 'PublicationsIPA',
  PublicationsISAL: 'PublicationsISAL',
  PublicationsPriority: 'PublicationsPriority',
  ePAQElite: 'ePAQElite',
  ePAQEliteCustom: 'ePAQEliteCustom',
  ePAQEliteDAP: 'ePAQEliteDAP',
  ePAQEliteDDP: 'ePAQEliteDDP',
  ePAQEliteDDPOversized: 'ePAQEliteDDPOversized',
  ePAQEliteDPD: 'ePAQEliteDPD',
  ePAQEliteDirectAccessCanadaDDP: 'ePAQEliteDirectAccessCanadaDDP',
  ePAQEliteOversized: 'ePAQEliteOversized',
  ePAQPlus: 'ePAQPlus',
  ePAQPlusCustom: 'ePAQPlusCustom',
  ePAQPlusCustomsPrepaid: 'ePAQPlusCustomsPrepaid',
  ePAQPlusDAP: 'ePAQPlusDAP',
  ePAQPlusDDP: 'ePAQPlusDDP',
  ePAQPlusEconomy: 'ePAQPlusEconomy',
  ePAQPlusWholesale: 'ePAQPlusWholesale',
  ePAQPlusePacket: 'ePAQPlusePacket',
  ePAQPlusePacketCanadaCustomsPrePaid: 'ePAQPlusePacketCanadaCustomsPrePaid',
  ePAQPlusePacketCanadaDDP: 'ePAQPlusePacketCanadaDDP',
  ePAQReturnsDomestic: 'ePAQReturnsDomestic',
  ePAQReturnsInternational: 'ePAQReturnsInternational',
  ePAQSelect: 'ePAQSelect',
  ePAQSelectCustom: 'ePAQSelectCustom',
  ePAQSelectCustomsPrepaidByShopper: 'ePAQSelectCustomsPrepaidByShopper',
  ePAQSelectDAP: 'ePAQSelectDAP',
  ePAQSelectDDP: 'ePAQSelectDDP',
  ePAQSelectDDPDirectAccess: 'ePAQSelectDDPDirectAccess',
  ePAQSelectDirectAccess: 'ePAQSelectDirectAccess',
  ePAQSelectDirectAccessCanadaDDP: 'ePAQSelectDirectAccessCanadaDDP',
  ePAQSelectEconomy: 'ePAQSelectEconomy',
  ePAQSelectOversized: 'ePAQSelectOversized',
  ePAQSelectOversizedDDP: 'ePAQSelectOversizedDDP',
  ePAQSelectPMEI: 'ePAQSelectPMEI',
  ePAQSelectPMEICanadaCustomsPrePaid: 'ePAQSelectPMEICanadaCustomsPrePaid',
  ePAQSelectPMEIPCPostage: 'ePAQSelectPMEIPCPostage',
  ePAQSelectPMI: 'ePAQSelectPMI',
  ePAQSelectPMICanadaCustomsPrepaid: 'ePAQSelectPMICanadaCustomsPrepaid',
  ePAQSelectPMICanadaDDP: 'ePAQSelectPMICanadaDDP',
  ePAQSelectPMINonPresort: 'ePAQSelectPMINonPresort',
  ePAQSelectPMIPCPostage: 'ePAQSelectPMIPCPostage',
  ePAQStandard: 'ePAQStandard',
  ePAQStandardCustom: 'ePAQStandardCustom',
  ePAQStandardEconomy: 'ePAQStandardEconomy',
  ePAQStandardIPA: 'ePAQStandardIPA',
  ePAQStandardISAL: 'ePAQStandardISAL',
  ePaqSelectPMEINonPresort: 'ePaqSelectPMEINonPresort',
  ePAQSelectDDPDG: 'ePAQSelectDDPDG',
  AsendiaDomesticParcelMaxUnder70lb: 'AsendiaDomesticParcelMaxUnder70lb',
  RoyalMailV3: 'RoyalMailV3',
  DEImportRoyalMail24PlusParcelsWeekendService: 'DEImportRoyalMail24PlusParcelsWeekendService',
  DEImportStandard24LargeLetter: 'DEImportStandard24LargeLetter',
  DEImportStandard24LargeLetterWeekendService: 'DEImportStandard24LargeLetterWeekendService',
  DEImportStandard24Parcel: 'DEImportStandard24Parcel',
  DEImportStandard24ParcelWeekendService: 'DEImportStandard24ParcelWeekendService',
  DEImportStandard48LargeLetter: 'DEImportStandard48LargeLetter',
  DEImportStandard48LargeLetterWeekendService: 'DEImportStandard48LargeLetterWeekendService',
  DEImportTracked24ParcelBoxableHighVolumeWeekendService: 'DEImportTracked24ParcelBoxableHighVolumeWeekendService',
  DEImportTracked24ParcelBoxableWeekendService: 'DEImportTracked24ParcelBoxableWeekendService',
  DEImportTracked24ParcelHighVolumeWeekendService: 'DEImportTracked24ParcelHighVolumeWeekendService',
  DEImportTracked24SignatureParcelHighVolumeWeekendServiceAGE: 'DEImportTracked24SignatureParcelHighVolumeWeekendServiceAGE',
  DEImportTracked48ParcelBoxableHighVolumeWeekendService: 'DEImportTracked48ParcelBoxableHighVolumeWeekendService',
  DEImportTracked48ParcelBoxableWeekendService: 'DEImportTracked48ParcelBoxableWeekendService',
  DEImportTracked48ParcelHighVolumeWeekendService: 'DEImportTracked48ParcelHighVolumeWeekendService',
  DEImportTracked48SignatureParcelHighVolumeAGE: 'DEImportTracked48SignatureParcelHighVolumeAGE',
  DEImportTracked48SignatureParcelHighVolumeWeekendServiceAGE: 'DEImportTracked48SignatureParcelHighVolumeWeekendServiceAGE',
  DEImporttoEUMaxSortLargeLetter: 'DEImporttoEUMaxSortLargeLetter',
  DEImporttoEUMaxSortParcel: 'DEImporttoEUMaxSortParcel',
  DEImporttoEUSignedParcel: 'DEImporttoEUSignedParcel',
  DEImporttoEUTrackedHighVolLargeLetter: 'DEImporttoEUTrackedHighVolLargeLetter',
  DEImporttoEUTrackedParcel: 'DEImporttoEUTrackedParcel',
  DEImporttoEUTrackedSignedLargeLetter: 'DEImporttoEUTrackedSignedLargeLetter',
  DEImporttoEUTrackedSignedParcel: 'DEImporttoEUTrackedSignedParcel',
  HMForcesMail: 'HMForcesMail',
  HMForcesSignedFor: 'HMForcesSignedFor',
  HMForcesSpecialDelivery1000: 'HMForcesSpecialDelivery1000',
  HMForcesSpecialDelivery2500: 'HMForcesSpecialDelivery2500',
  HMForcesSpecialDelivery500: 'HMForcesSpecialDelivery500',
  ImportDETracked24: 'ImportDETracked24',
  ImportDETracked24HighVolume: 'ImportDETracked24HighVolume',
  ImportDETracked24Letterboxable: 'ImportDETracked24Letterboxable',
  ImportDETracked24LetterboxableHighVolume: 'ImportDETracked24LetterboxableHighVolume',
  ImportDETracked24SignatureHighVolumeAGE: 'ImportDETracked24SignatureHighVolumeAGE',
  ImportDETracked24SignatureStandardAGE: 'ImportDETracked24SignatureStandardAGE',
  ImportDETracked48: 'ImportDETracked48',
  ImportDETracked48HighVolume: 'ImportDETracked48HighVolume',
  ImportDETracked48Letterboxable: 'ImportDETracked48Letterboxable',
  ImportDETracked48LetterboxableHighVolume: 'ImportDETracked48LetterboxableHighVolume',
  ImportDETrackedReturns24: 'ImportDETrackedReturns24',
  ImportDETrackedReturns48: 'ImportDETrackedReturns48',
  InternationalBusinessMailLargeLetterCountryPricedPriority: 'InternationalBusinessMailLargeLetterCountryPricedPriority',
  InternationalBusinessMailLargeLetterCountryPricedPriorityETOE: 'InternationalBusinessMailLargeLetterCountryPricedPriorityETOE',
  InternationalBusinessMailLargeLetterCountrySortPriority: 'InternationalBusinessMailLargeLetterCountrySortPriority',
  InternationalBusinessMailLargeLetterMaxSortPriorityService: 'InternationalBusinessMailLargeLetterMaxSortPriorityService',
  InternationalBusinessMailLargeLetterMaxSortResidueStandard: 'InternationalBusinessMailLargeLetterMaxSortResidueStandard',
  InternationalBusinessMailLargeLetterMaxSortStandardService: 'InternationalBusinessMailLargeLetterMaxSortStandardService',
  InternationalBusinessMailLargeLetterSemiTracked: 'InternationalBusinessMailLargeLetterSemiTracked',
  InternationalBusinessMailLargeLetterZeroSortPriority: 'InternationalBusinessMailLargeLetterZeroSortPriority',
  InternationalBusinessMailLargeLetterZeroSortPriorityMachine: 'InternationalBusinessMailLargeLetterZeroSortPriorityMachine',
  InternationalBusinessMailLargeLetterZoneSortPriority: 'InternationalBusinessMailLargeLetterZoneSortPriority',
  InternationalBusinessMailLargeLetterZoneSortPriorityMachine: 'InternationalBusinessMailLargeLetterZoneSortPriorityMachine',
  InternationalBusinessMailLetterMaxSortResidueStandard: 'InternationalBusinessMailLetterMaxSortResidueStandard',
  InternationalBusinessMailLettersMaxSortStandard: 'InternationalBusinessMailLettersMaxSortStandard',
  InternationalBusinessMailLettersZeroSortPriority: 'InternationalBusinessMailLettersZeroSortPriority',
  InternationalBusinessMailLettersZoneSortPriority: 'InternationalBusinessMailLettersZoneSortPriority',
  InternationalBusinessMailSignedCountryPriced: 'InternationalBusinessMailSignedCountryPriced',
  InternationalBusinessMailSignedExtraCompensationCountryPriced: 'InternationalBusinessMailSignedExtraCompensationCountryPriced',
  InternationalBusinessMailSignedHighVolCountryPriced: 'InternationalBusinessMailSignedHighVolCountryPriced',
  InternationalBusinessMailSignedZoneSort: 'InternationalBusinessMailSignedZoneSort',
  InternationalBusinessMailTrackedCountryPriced: 'InternationalBusinessMailTrackedCountryPriced',
  InternationalBusinessMailTrackedHighVolCountryPriced: 'InternationalBusinessMailTrackedHighVolCountryPriced',
  InternationalBusinessMailTrackedHighVolExtraCompCountryPriced: 'InternationalBusinessMailTrackedHighVolExtraCompCountryPriced',
  InternationalBusinessMailTrackedLargeLetterCountryPricedETOE: 'InternationalBusinessMailTrackedLargeLetterCountryPricedETOE',
  InternationalBusinessMailTrackedSignedCountryPriced: 'InternationalBusinessMailTrackedSignedCountryPriced',
  InternationalBusinessMailTrackedSignedHighVolCountryPriced: 'InternationalBusinessMailTrackedSignedHighVolCountryPriced',
  InternationalBusinessMailTrackedSignedHighVolExtraCompCountryPriced: 'InternationalBusinessMailTrackedSignedHighVolExtraCompCountryPriced',
  InternationalBusinessMailTrackedSignedLargeLetterCountryPricedETOE: 'InternationalBusinessMailTrackedSignedLargeLetterCountryPricedETOE',
  InternationalBusinessMailTrackedSignedZoneSort: 'InternationalBusinessMailTrackedSignedZoneSort',
  InternationalBusinessMailTrackedZoneSort: 'InternationalBusinessMailTrackedZoneSort',
  InternationalBusinessPCTrackedSignedLargeLetterHVExtraCompCountryPricedETOE: 'InternationalBusinessPCTrackedSignedLargeLetterHVExtraCompCountryPricedETOE',
  InternationalBusinessParcelPriorityCountryPricedBoxable: 'InternationalBusinessParcelPriorityCountryPricedBoxable',
  InternationalBusinessParcelPriorityCountryPricedBoxableDDP: 'InternationalBusinessParcelPriorityCountryPricedBoxableDDP',
  InternationalBusinessParcelTrackedCountryPriced: 'InternationalBusinessParcelTrackedCountryPriced',
  InternationalBusinessParcelTrackedCountryPricedBoxable: 'InternationalBusinessParcelTrackedCountryPricedBoxable',
  InternationalBusinessParcelTrackedCountryPricedBoxableDDP: 'InternationalBusinessParcelTrackedCountryPricedBoxableDDP',
  InternationalBusinessParcelTrackedCountryPricedBoxableExtraComp: 'InternationalBusinessParcelTrackedCountryPricedBoxableExtraComp',
  InternationalBusinessParcels: 'InternationalBusinessParcels',
  InternationalBusinessParcelsPrintDirectPriority: 'InternationalBusinessParcelsPrintDirectPriority',
  InternationalBusinessParcelsPrintDirectStandard: 'InternationalBusinessParcelsPrintDirectStandard',
  InternationalBusinessParcelsSignedCountryPriced: 'InternationalBusinessParcelsSignedCountryPriced',
  InternationalBusinessParcelsSignedExtraCompensationCountryPriced: 'InternationalBusinessParcelsSignedExtraCompensationCountryPriced',
  InternationalBusinessParcelsSignedExtraCompensationZoneSort: 'InternationalBusinessParcelsSignedExtraCompensationZoneSort',
  InternationalBusinessParcelsSignedZoneSort: 'InternationalBusinessParcelsSignedZoneSort',
  InternationalBusinessParcelsTrackedCountryPriced: 'InternationalBusinessParcelsTrackedCountryPriced',
  InternationalBusinessParcelsTrackedCountryPricedETOE: 'InternationalBusinessParcelsTrackedCountryPricedETOE',
  InternationalBusinessParcelsTrackedDirectIrelandCountry: 'InternationalBusinessParcelsTrackedDirectIrelandCountry',
  InternationalBusinessParcelsTrackedExtraCompCountryPriced: 'InternationalBusinessParcelsTrackedExtraCompCountryPriced',
  InternationalBusinessParcelsTrackedExtraCompZoneSort: 'InternationalBusinessParcelsTrackedExtraCompZoneSort',
  InternationalBusinessParcelsTrackedSignedCountryPriced: 'InternationalBusinessParcelsTrackedSignedCountryPriced',
  InternationalBusinessParcelsTrackedSignedCountryPricedETOE: 'InternationalBusinessParcelsTrackedSignedCountryPricedETOE',
  InternationalBusinessParcelsTrackedSignedDDP: 'InternationalBusinessParcelsTrackedSignedDDP',
  InternationalBusinessParcelsTrackedSignedExtraCompensationCountryPriced: 'InternationalBusinessParcelsTrackedSignedExtraCompensationCountryPriced',
  InternationalBusinessParcelsTrackedSignedExtraCompensationZoneSort: 'InternationalBusinessParcelsTrackedSignedExtraCompensationZoneSort',
  InternationalBusinessParcelsTrackedSignedZoneSort: 'InternationalBusinessParcelsTrackedSignedZoneSort',
  InternationalBusinessParcelsTrackedZoneSort: 'InternationalBusinessParcelsTrackedZoneSort',
  InternationalBusinessParcelsZeroSortPriority: 'InternationalBusinessParcelsZeroSortPriority',
  InternationalBusinessParcelsZeroSortPriorityETOE: 'InternationalBusinessParcelsZeroSortPriorityETOE',
  InternationalBusinessParcelsZoneSortPriorityService: 'InternationalBusinessParcelsZoneSortPriorityService',
  InternationalBusinessPersonalCorrespondenceLargeLetterCountrySortPriorityETOE: 'InternationalBusinessPersonalCorrespondenceLargeLetterCountrySortPriorityETOE',
  InternationalBusinessPersonalCorrespondenceLetterPriorityUntracked: 'InternationalBusinessPersonalCorrespondenceLetterPriorityUntracked',
  InternationalBusinessPersonalCorrespondenceLetterPriorityUntrackedETOE: 'InternationalBusinessPersonalCorrespondenceLetterPriorityUntrackedETOE',
  InternationalBusinessPersonalCorrespondenceLetterTrackedHighVolCountryPricedETOE: 'InternationalBusinessPersonalCorrespondenceLetterTrackedHighVolCountryPricedETOE',
  InternationalBusinessPersonalCorrespondenceLetterTrackedSignedHighVolCountryPricedETOE: 'InternationalBusinessPersonalCorrespondenceLetterTrackedSignedHighVolCountryPricedETOE',
  InternationalBusinessPersonalCorrespondenceMaxSortLetter: 'InternationalBusinessPersonalCorrespondenceMaxSortLetter',
  InternationalBusinessPersonalCorrespondenceMaxSortResidueLargeLetter: 'InternationalBusinessPersonalCorrespondenceMaxSortResidueLargeLetter',
  InternationalBusinessPersonalCorrespondenceMaxSortResidueLetter: 'InternationalBusinessPersonalCorrespondenceMaxSortResidueLetter',
  InternationalBusinessPersonalCorrespondenceSignedLargeLetterExtraCompensationCountryPricedETOE: 'InternationalBusinessPersonalCorrespondenceSignedLargeLetterExtraCompensationCountryPricedETOE',
  InternationalBusinessPersonalCorrespondenceSignedLetterHighVolCountryPricedETOE: 'InternationalBusinessPersonalCorrespondenceSignedLetterHighVolCountryPricedETOE',
  InternationalBusinessPersonalCorrespondenceTrackedLargeLetterHighVolExtraCompCountryPricedETOE: 'InternationalBusinessPersonalCorrespondenceTrackedLargeLetterHighVolExtraCompCountryPricedETOE',
  InternationalBusinessPrintedMatterPacket: 'InternationalBusinessPrintedMatterPacket',
  InternationalBusinessTrackedExpressNPC: 'InternationalBusinessTrackedExpressNPC',
  InternationalEconomyOnAccount: 'InternationalEconomyOnAccount',
  InternationalSignedOnAccount: 'InternationalSignedOnAccount',
  InternationalSignedOnAccountExtraComp: 'InternationalSignedOnAccountExtraComp',
  InternationalStandardOnAccount: 'InternationalStandardOnAccount',
  InternationalTrackedOnAccount: 'InternationalTrackedOnAccount',
  InternationalTrackedOnAccountExtraComp: 'InternationalTrackedOnAccountExtraComp',
  InternationalTrackedParcels30kg: 'InternationalTrackedParcels30kg',
  InternationalTrackedParcels30kgCPrio: 'InternationalTrackedParcels30kgCPrio',
  InternationalTrackedParcels30kgETOEC: 'InternationalTrackedParcels30kgETOEC',
  InternationalTrackedParcels30kgETOEE: 'InternationalTrackedParcels30kgETOEE',
  InternationalTrackedParcels30kgExtraComp: 'InternationalTrackedParcels30kgExtraComp',
  InternationalTrackedParcels30kgExtraCompETOEC: 'InternationalTrackedParcels30kgExtraCompETOEC',
  InternationalTrackedParcels30kgExtraCompETOEE: 'InternationalTrackedParcels30kgExtraCompETOEE',
  InternationalTrackedParcels30kgXCompCPrio: 'InternationalTrackedParcels30kgXCompCPrio',
  InternationalTrackedSignedOnAccount: 'InternationalTrackedSignedOnAccount',
  InternationalTrackedSignedOnAccountExtraComp: 'InternationalTrackedSignedOnAccountExtraComp',
  ParcelpostFlatRateAnnual: 'ParcelpostFlatRateAnnual',
  RM24LargeLetterAnnualFlatRate: 'RM24LargeLetterAnnualFlatRate',
  RM24PresortedLargeLetterAnnualFlatRate: 'RM24PresortedLargeLetterAnnualFlatRate',
  RM24PresortedParcelsAnnualFlatRate: 'RM24PresortedParcelsAnnualFlatRate',
  RM48LargeLetterAnnualFlatRate: 'RM48LargeLetterAnnualFlatRate',
  RM48PresortedLargeLetterAnnualFlatRate: 'RM48PresortedLargeLetterAnnualFlatRate',
  RM48PresortedParcelsAnnualFlatRate: 'RM48PresortedParcelsAnnualFlatRate',
  RoyalMail1stClass: 'RoyalMail1stClass',
  RoyalMail1stClassLettersDailyRateservice: 'RoyalMail1stClassLettersDailyRateservice',
  RoyalMail1stClassSignedFor: 'RoyalMail1stClassSignedFor',
  RoyalMail24LargeLetterDailyRate: 'RoyalMail24LargeLetterDailyRate',
  RoyalMail24LargeLetterFlatRate: 'RoyalMail24LargeLetterFlatRate',
  RoyalMail24LargeLetterFlatRateService: 'RoyalMail24LargeLetterFlatRateService',
  RoyalMail24PacketpostFlatRateService: 'RoyalMail24PacketpostFlatRateService',
  RoyalMail24ParcelDailyRateService: 'RoyalMail24ParcelDailyRateService',
  RoyalMail24ParcelSort8DailyRateService: 'RoyalMail24ParcelSort8DailyRateService',
  RoyalMail24ParcelSort8FlatRateService: 'RoyalMail24ParcelSort8FlatRateService',
  RoyalMail24ParcelsDailyRate: 'RoyalMail24ParcelsDailyRate',
  RoyalMail24ParcelsFlatRate: 'RoyalMail24ParcelsFlatRate',
  RoyalMail24PresortedLargeLetter: 'RoyalMail24PresortedLargeLetter',
  RoyalMail24PresortedParcels: 'RoyalMail24PresortedParcels',
  RoyalMail24SORT8LargeLetterAnnualFlatRate: 'RoyalMail24SORT8LargeLetterAnnualFlatRate',
  RoyalMail24SORT8ParcelsAnnualFlatRate: 'RoyalMail24SORT8ParcelsAnnualFlatRate',
  RoyalMail2ndClass: 'RoyalMail2ndClass',
  RoyalMail2ndClassLettersDailyRateservice: 'RoyalMail2ndClassLettersDailyRateservice',
  RoyalMail2ndClassSignedFor: 'RoyalMail2ndClassSignedFor',
  RoyalMail48LargeLetterDailyRate: 'RoyalMail48LargeLetterDailyRate',
  RoyalMail48LargeLetterFlatRate: 'RoyalMail48LargeLetterFlatRate',
  RoyalMail48LargeLetterFlatRateService: 'RoyalMail48LargeLetterFlatRateService',
  RoyalMail48PacketpostFlatRateService: 'RoyalMail48PacketpostFlatRateService',
  RoyalMail48ParcelDailyRateService: 'RoyalMail48ParcelDailyRateService',
  RoyalMail48ParcelSort8DailyRateService: 'RoyalMail48ParcelSort8DailyRateService',
  RoyalMail48ParcelSort8FlatRateService: 'RoyalMail48ParcelSort8FlatRateService',
  RoyalMail48ParcelsDailyRate: 'RoyalMail48ParcelsDailyRate',
  RoyalMail48ParcelsFlatRate: 'RoyalMail48ParcelsFlatRate',
  RoyalMail48PresortedLargeLetter: 'RoyalMail48PresortedLargeLetter',
  RoyalMail48PresortedParcels: 'RoyalMail48PresortedParcels',
  RoyalMail48SORT8LargeLetterAnnualFlatRate: 'RoyalMail48SORT8LargeLetterAnnualFlatRate',
  RoyalMail48Sort8ParcelsAnnualFlatRate: 'RoyalMail48Sort8ParcelsAnnualFlatRate',
  SpecialDeliveryGuaranteed1000: 'SpecialDeliveryGuaranteed1000',
  SpecialDeliveryGuaranteed2500: 'SpecialDeliveryGuaranteed2500',
  SpecialDeliveryGuaranteed750: 'SpecialDeliveryGuaranteed750',
  SpecialDeliveryGuaranteedAGE1000: 'SpecialDeliveryGuaranteedAGE1000',
  SpecialDeliveryGuaranteedAGE2500: 'SpecialDeliveryGuaranteedAGE2500',
  SpecialDeliveryGuaranteedAGE750: 'SpecialDeliveryGuaranteedAGE750',
  SpecialDeliveryGuaranteedBy1PM1000: 'SpecialDeliveryGuaranteedBy1PM1000',
  SpecialDeliveryGuaranteedBy1PM2500: 'SpecialDeliveryGuaranteedBy1PM2500',
  SpecialDeliveryGuaranteedBy1PM750: 'SpecialDeliveryGuaranteedBy1PM750',
  SpecialDeliveryGuaranteedBy1PMAGE1000: 'SpecialDeliveryGuaranteedBy1PMAGE1000',
  SpecialDeliveryGuaranteedBy1PMAGE2500: 'SpecialDeliveryGuaranteedBy1PMAGE2500',
  SpecialDeliveryGuaranteedBy1PMAGE750: 'SpecialDeliveryGuaranteedBy1PMAGE750',
  SpecialDeliveryGuaranteedBy1PMID1000: 'SpecialDeliveryGuaranteedBy1PMID1000',
  SpecialDeliveryGuaranteedBy1PMID2500: 'SpecialDeliveryGuaranteedBy1PMID2500',
  SpecialDeliveryGuaranteedBy1PMID750: 'SpecialDeliveryGuaranteedBy1PMID750',
  SpecialDeliveryGuaranteedBy9AM1000: 'SpecialDeliveryGuaranteedBy9AM1000',
  SpecialDeliveryGuaranteedBy9AM2500: 'SpecialDeliveryGuaranteedBy9AM2500',
  SpecialDeliveryGuaranteedBy9AM750: 'SpecialDeliveryGuaranteedBy9AM750',
  SpecialDeliveryGuaranteedBy9AMAGE1000: 'SpecialDeliveryGuaranteedBy9AMAGE1000',
  SpecialDeliveryGuaranteedBy9AMAGE2500: 'SpecialDeliveryGuaranteedBy9AMAGE2500',
  SpecialDeliveryGuaranteedBy9AMAGE750: 'SpecialDeliveryGuaranteedBy9AMAGE750',
  SpecialDeliveryGuaranteedBy9AMID1000: 'SpecialDeliveryGuaranteedBy9AMID1000',
  SpecialDeliveryGuaranteedBy9AMID2500: 'SpecialDeliveryGuaranteedBy9AMID2500',
  SpecialDeliveryGuaranteedBy9AMID750: 'SpecialDeliveryGuaranteedBy9AMID750',
  SpecialDeliveryGuaranteedID1000: 'SpecialDeliveryGuaranteedID1000',
  SpecialDeliveryGuaranteedID2500: 'SpecialDeliveryGuaranteedID2500',
  SpecialDeliveryGuaranteedID750: 'SpecialDeliveryGuaranteedID750',
  Tracked24: 'Tracked24',
  Tracked24HighVolume: 'Tracked24HighVolume',
  Tracked24HighVolumeSignatureAGE: 'Tracked24HighVolumeSignatureAGE',
  Tracked24SignatureAGE: 'Tracked24SignatureAGE',
  Tracked48: 'Tracked48',
  Tracked48HighVolume: 'Tracked48HighVolume',
  Tracked48HighVolumeSignatureAGE: 'Tracked48HighVolumeSignatureAGE',
  Tracked48SignatureAGE: 'Tracked48SignatureAGE',
  TrackedLetterBoxable24: 'TrackedLetterBoxable24',
  TrackedLetterBoxable24HighVolume: 'TrackedLetterBoxable24HighVolume',
  TrackedLetterBoxable48: 'TrackedLetterBoxable48',
  TrackedLetterBoxable48HighVolume: 'TrackedLetterBoxable48HighVolume',
  TrackedReturns24: 'TrackedReturns24',
  TrackedReturns48: 'TrackedReturns48',
  SpeeDeeDelivery: 'SpeeDeeDelivery',
  PriorityDdpDelcon: 'PriorityDdpDelcon',
  PriorityDdp: 'PriorityDdp',
  epacketDdp: 'epacketDdp',
  ExpressDdp: 'ExpressDdp',
  PriorityDduDelcon: 'PriorityDduDelcon',
  PriorityDdu: 'PriorityDdu',
  ExpeditedDdpDelcon: 'ExpeditedDdpDelcon',
  ExpressDdpDelcon: 'ExpressDdpDelcon',
  GlobalPlus: 'GlobalPlus',
  Delivery: 'Delivery',
  GRND: 'GRND',
  Default: 'Default'
} as const

export type rate_table_service_level = (typeof rate_table_service_level)[keyof typeof rate_table_service_level]


export const rate_table_type = {
  fixed: 'fixed',
  dynamic: 'dynamic'
} as const

export type rate_table_type = (typeof rate_table_type)[keyof typeof rate_table_type]


export const rate_table_value_mode = {
  Rate: 'Rate',
  Spread: 'Spread',
  Discount: 'Discount'
} as const

export type rate_table_value_mode = (typeof rate_table_value_mode)[keyof typeof rate_table_value_mode]


export const rate_table_weight_unit = {
  OZ: 'OZ',
  LB: 'LB'
} as const

export type rate_table_weight_unit = (typeof rate_table_weight_unit)[keyof typeof rate_table_weight_unit]


export const redemption_method = {
  OUTBOUND_LABELS_BALANCE_CREDIT: 'OUTBOUND_LABELS_BALANCE_CREDIT'
} as const

export type redemption_method = (typeof redemption_method)[keyof typeof redemption_method]


export const redo_cart_status = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED'
} as const

export type redo_cart_status = (typeof redo_cart_status)[keyof typeof redo_cart_status]


export const redo_shopify_country_code = {
  AC: 'AC',
  AD: 'AD',
  AE: 'AE',
  AF: 'AF',
  AG: 'AG',
  AI: 'AI',
  AL: 'AL',
  AM: 'AM',
  AN: 'AN',
  AO: 'AO',
  AR: 'AR',
  AS: 'AS',
  AT: 'AT',
  AU: 'AU',
  AW: 'AW',
  AX: 'AX',
  AZ: 'AZ',
  BA: 'BA',
  BB: 'BB',
  BD: 'BD',
  BE: 'BE',
  BF: 'BF',
  BG: 'BG',
  BH: 'BH',
  BI: 'BI',
  BJ: 'BJ',
  BL: 'BL',
  BM: 'BM',
  BN: 'BN',
  BO: 'BO',
  BQ: 'BQ',
  BR: 'BR',
  BS: 'BS',
  BT: 'BT',
  BV: 'BV',
  BW: 'BW',
  BY: 'BY',
  BZ: 'BZ',
  CA: 'CA',
  CC: 'CC',
  CD: 'CD',
  CF: 'CF',
  CG: 'CG',
  CH: 'CH',
  CI: 'CI',
  CK: 'CK',
  CL: 'CL',
  CM: 'CM',
  CN: 'CN',
  CO: 'CO',
  CR: 'CR',
  CU: 'CU',
  CV: 'CV',
  CW: 'CW',
  CX: 'CX',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DJ: 'DJ',
  DK: 'DK',
  DM: 'DM',
  DO: 'DO',
  DZ: 'DZ',
  EC: 'EC',
  EE: 'EE',
  EG: 'EG',
  EH: 'EH',
  ER: 'ER',
  ES: 'ES',
  ET: 'ET',
  FI: 'FI',
  FJ: 'FJ',
  FK: 'FK',
  FO: 'FO',
  FR: 'FR',
  GA: 'GA',
  GB: 'GB',
  GD: 'GD',
  GE: 'GE',
  GF: 'GF',
  GG: 'GG',
  GH: 'GH',
  GI: 'GI',
  GL: 'GL',
  GM: 'GM',
  GN: 'GN',
  GP: 'GP',
  GQ: 'GQ',
  GR: 'GR',
  GS: 'GS',
  GT: 'GT',
  GU: 'GU',
  GW: 'GW',
  GY: 'GY',
  HK: 'HK',
  HM: 'HM',
  HN: 'HN',
  HR: 'HR',
  HT: 'HT',
  HU: 'HU',
  ID: 'ID',
  IE: 'IE',
  IL: 'IL',
  IM: 'IM',
  IN: 'IN',
  IO: 'IO',
  IQ: 'IQ',
  IR: 'IR',
  IS: 'IS',
  IT: 'IT',
  JE: 'JE',
  JM: 'JM',
  JO: 'JO',
  JP: 'JP',
  KE: 'KE',
  KG: 'KG',
  KH: 'KH',
  KI: 'KI',
  KM: 'KM',
  KN: 'KN',
  KP: 'KP',
  KR: 'KR',
  KW: 'KW',
  KY: 'KY',
  KZ: 'KZ',
  LA: 'LA',
  LB: 'LB',
  LC: 'LC',
  LI: 'LI',
  LK: 'LK',
  LR: 'LR',
  LS: 'LS',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  LY: 'LY',
  MA: 'MA',
  MC: 'MC',
  MD: 'MD',
  ME: 'ME',
  MF: 'MF',
  MG: 'MG',
  MK: 'MK',
  ML: 'ML',
  MM: 'MM',
  MN: 'MN',
  MO: 'MO',
  MQ: 'MQ',
  MR: 'MR',
  MS: 'MS',
  MT: 'MT',
  MU: 'MU',
  MV: 'MV',
  MW: 'MW',
  MX: 'MX',
  MY: 'MY',
  MZ: 'MZ',
  NA: 'NA',
  NC: 'NC',
  NE: 'NE',
  NF: 'NF',
  NG: 'NG',
  NI: 'NI',
  NL: 'NL',
  NO: 'NO',
  NP: 'NP',
  NR: 'NR',
  NU: 'NU',
  NZ: 'NZ',
  OM: 'OM',
  PA: 'PA',
  PE: 'PE',
  PF: 'PF',
  PG: 'PG',
  PH: 'PH',
  PK: 'PK',
  PL: 'PL',
  PM: 'PM',
  PN: 'PN',
  PR: 'PR',
  PS: 'PS',
  PT: 'PT',
  PY: 'PY',
  QA: 'QA',
  RE: 'RE',
  RO: 'RO',
  RS: 'RS',
  RU: 'RU',
  RW: 'RW',
  SA: 'SA',
  SB: 'SB',
  SC: 'SC',
  SD: 'SD',
  SE: 'SE',
  SG: 'SG',
  SH: 'SH',
  SI: 'SI',
  SJ: 'SJ',
  SK: 'SK',
  SL: 'SL',
  SM: 'SM',
  SN: 'SN',
  SO: 'SO',
  SR: 'SR',
  SS: 'SS',
  ST: 'ST',
  SV: 'SV',
  SX: 'SX',
  SY: 'SY',
  SZ: 'SZ',
  TA: 'TA',
  TC: 'TC',
  TD: 'TD',
  TF: 'TF',
  TG: 'TG',
  TH: 'TH',
  TJ: 'TJ',
  TK: 'TK',
  TL: 'TL',
  TM: 'TM',
  TN: 'TN',
  TO: 'TO',
  TR: 'TR',
  TT: 'TT',
  TV: 'TV',
  TW: 'TW',
  TZ: 'TZ',
  UA: 'UA',
  UG: 'UG',
  UM: 'UM',
  US: 'US',
  UY: 'UY',
  UZ: 'UZ',
  VA: 'VA',
  VC: 'VC',
  VE: 'VE',
  VG: 'VG',
  VI: 'VI',
  VN: 'VN',
  VU: 'VU',
  WF: 'WF',
  WS: 'WS',
  XK: 'XK',
  YE: 'YE',
  YT: 'YT',
  ZA: 'ZA',
  ZM: 'ZM',
  ZW: 'ZW',
  ZZ: 'ZZ'
} as const

export type redo_shopify_country_code = (typeof redo_shopify_country_code)[keyof typeof redo_shopify_country_code]


export const redo_shopify_delivery_method_type = {
  LOCAL: 'LOCAL',
  NONE: 'NONE',
  PICKUP_POINT: 'PICKUP_POINT',
  PICK_UP: 'PICK_UP',
  RETAIL: 'RETAIL',
  SHIPPING: 'SHIPPING',
  FREIGHT: 'FREIGHT'
} as const

export type redo_shopify_delivery_method_type = (typeof redo_shopify_delivery_method_type)[keyof typeof redo_shopify_delivery_method_type]


export const redo_shopify_fulfillment_display_status = {
  ATTEMPTED_DELIVERY: 'ATTEMPTED_DELIVERY',
  CANCELED: 'CANCELED',
  CONFIRMED: 'CONFIRMED',
  DELAYED: 'DELAYED',
  DELIVERED: 'DELIVERED',
  FAILURE: 'FAILURE',
  FULFILLED: 'FULFILLED',
  IN_TRANSIT: 'IN_TRANSIT',
  LABEL_PRINTED: 'LABEL_PRINTED',
  LABEL_PURCHASED: 'LABEL_PURCHASED',
  LABEL_VOIDED: 'LABEL_VOIDED',
  MARKED_AS_FULFILLED: 'MARKED_AS_FULFILLED',
  NOT_DELIVERED: 'NOT_DELIVERED',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  PICKED_UP: 'PICKED_UP',
  READY_FOR_PICKUP: 'READY_FOR_PICKUP',
  SUBMITTED: 'SUBMITTED'
} as const

export type redo_shopify_fulfillment_display_status = (typeof redo_shopify_fulfillment_display_status)[keyof typeof redo_shopify_fulfillment_display_status]


export const redo_shopify_fulfillment_order_request_status = {
  ACCEPTED: 'ACCEPTED',
  CANCELLATION_ACCEPTED: 'CANCELLATION_ACCEPTED',
  CANCELLATION_REJECTED: 'CANCELLATION_REJECTED',
  CANCELLATION_REQUESTED: 'CANCELLATION_REQUESTED',
  CLOSED: 'CLOSED',
  REJECTED: 'REJECTED',
  SUBMITTED: 'SUBMITTED',
  UNSUBMITTED: 'UNSUBMITTED'
} as const

export type redo_shopify_fulfillment_order_request_status = (typeof redo_shopify_fulfillment_order_request_status)[keyof typeof redo_shopify_fulfillment_order_request_status]


export const redo_shopify_fulfillment_order_status = {
  CANCELLED: 'CANCELLED',
  CLOSED: 'CLOSED',
  INCOMPLETE: 'INCOMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  ON_HOLD: 'ON_HOLD',
  OPEN: 'OPEN',
  SCHEDULED: 'SCHEDULED',
  NOT_RECEIVED: 'NOT_RECEIVED'
} as const

export type redo_shopify_fulfillment_order_status = (typeof redo_shopify_fulfillment_order_status)[keyof typeof redo_shopify_fulfillment_order_status]


export const redo_shopify_fulfillment_status = {
  CANCELLED: 'CANCELLED',
  ERROR: 'ERROR',
  FAILURE: 'FAILURE',
  OPEN: 'OPEN',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS'
} as const

export type redo_shopify_fulfillment_status = (typeof redo_shopify_fulfillment_status)[keyof typeof redo_shopify_fulfillment_status]


export const reject_types = {
  Return_portal: 'Return_portal',
  Manual_review: 'Manual_review',
  Pre_shipment: 'Pre_shipment',
  Expired: 'Expired',
  Post_shipment: 'Post_shipment'
} as const

export type reject_types = (typeof reject_types)[keyof typeof reject_types]


export const repair_fee_collection_strategy = {
  instant: 'instant',
  deferred: 'deferred'
} as const

export type repair_fee_collection_strategy = (typeof repair_fee_collection_strategy)[keyof typeof repair_fee_collection_strategy]


export const replenishment_request_status = {
  pending: 'pending',
  dismissed: 'dismissed',
  in_progress: 'in_progress',
  completed: 'completed',
  failed: 'failed'
} as const

export type replenishment_request_status = (typeof replenishment_request_status)[keyof typeof replenishment_request_status]


export const report_data_type = {
  returned_products: 'returned_products',
  returns: 'returns',
  warranty_customers: 'warranty_customers',
  purchased_extended_warranty: 'purchased_extended_warranty',
  billing_charges: 'billing_charges'
} as const

export type report_data_type = (typeof report_data_type)[keyof typeof report_data_type]


export const reserved_inventory_bucket_kind = {
  reserved: 'reserved',
  damaged: 'damaged'
} as const

export type reserved_inventory_bucket_kind = (typeof reserved_inventory_bucket_kind)[keyof typeof reserved_inventory_bucket_kind]


export const return_comment_code = {
  missing_refund_amount: 'missing_refund_amount',
  shopify_refund_issued: 'shopify_refund_issued',
  exchange_order_refunded: 'exchange_order_refunded',
  sfcc_unable_to_refund_full_amount: 'sfcc_unable_to_refund_full_amount',
  sfcc_optty_refund_issued: 'sfcc_optty_refund_issued',
  sfcc_failed_to_process_refund_on_order: 'sfcc_failed_to_process_refund_on_order',
  store_credit_timeline_updated: 'store_credit_timeline_updated',
  split_gift_cards: 'split_gift_cards',
  bigcommerce_cant_refund: 'bigcommerce_cant_refund',
  bigcommerce_noop_refund: 'bigcommerce_noop_refund',
  bigcommerce_api_locked: 'bigcommerce_api_locked',
  custom_integration_refund_failed: 'custom_integration_refund_failed',
  custom_integration_refund_success: 'custom_integration_refund_success',
  whiplash_ryder_quantity_mismatch: 'whiplash_ryder_quantity_mismatch',
  whiplash_ryder_rma_cannot_delete_wrong_status: 'whiplash_ryder_rma_cannot_delete_wrong_status',
  whiplash_ryder_rma_not_found: 'whiplash_ryder_rma_not_found',
  shipmonk_quantity_mismatch: 'shipmonk_quantity_mismatch'
} as const

export type return_comment_code = (typeof return_comment_code)[keyof typeof return_comment_code]


export const return_integration_error_code_values = {
  SHIPHERO_ORDER_NOT_FOUND: 'SHIPHERO_ORDER_NOT_FOUND',
  SHIPHERO_SKU_MISSING_ON_ORDER: 'SHIPHERO_SKU_MISSING_ON_ORDER',
  SHIPHERO_ACCOUNT_CANCELED: 'SHIPHERO_ACCOUNT_CANCELED',
  DEPOSCO_NO_INTEGRATION: 'DEPOSCO_NO_INTEGRATION',
  DEPOSCO_NO_ORDER: 'DEPOSCO_NO_ORDER',
  DEPOSCO_NO_FACILITY_MATCH: 'DEPOSCO_NO_FACILITY_MATCH',
  DEPOSCO_API_ERROR: 'DEPOSCO_API_ERROR',
  BRIGHTPEARL_SALES_ORDER_ROW_NOT_FOUND: 'BRIGHTPEARL_SALES_ORDER_ROW_NOT_FOUND',
  BRIGHTPEARL_ORIGINAL_SALES_ORDER_NOT_FOUND: 'BRIGHTPEARL_ORIGINAL_SALES_ORDER_NOT_FOUND',
  FLEXPORT_TRACKING_CODE_NOT_FOUND: 'FLEXPORT_TRACKING_CODE_NOT_FOUND',
  FLEXPORT_CARRIER_NOT_FOUND: 'FLEXPORT_CARRIER_NOT_FOUND',
  FLEXPORT_INVALID_LOCATION: 'FLEXPORT_INVALID_LOCATION',
  FLEXPORT_DUPLICATE_ENTRY: 'FLEXPORT_DUPLICATE_ENTRY',
  FLEXPORT_PRODUCT_NOT_FOUND: 'FLEXPORT_PRODUCT_NOT_FOUND',
  FLEXPORT_BAD_REQUEST: 'FLEXPORT_BAD_REQUEST',
  NETSUITE_SALES_ORDER_NOT_FOUND: 'NETSUITE_SALES_ORDER_NOT_FOUND',
  NETSUITE_RETURN_AUTHORIZATION_CANNOT_BE_INITIALIZED: 'NETSUITE_RETURN_AUTHORIZATION_CANNOT_BE_INITIALIZED',
  NETSUITE_RETURN_AUTHORIZATION_MUST_HAVE_LINE_ITEMS: 'NETSUITE_RETURN_AUTHORIZATION_MUST_HAVE_LINE_ITEMS',
  NETSUITE_END_OF_GROUP_LINE_DELETE_ERROR: 'NETSUITE_END_OF_GROUP_LINE_DELETE_ERROR',
  NETSUITE_THIS_RECORD_ALREADY_EXISTS_ERROR: 'NETSUITE_THIS_RECORD_ALREADY_EXISTS_ERROR',
  NETSUITE_INVALID_FIELD_VALUE_ERROR: 'NETSUITE_INVALID_FIELD_VALUE_ERROR',
  NETSUITE_INVALID_LOGIN_ATTEMPT_ERROR: 'NETSUITE_INVALID_LOGIN_ATTEMPT_ERROR',
  NETSUITE_UNEXPECTED_SUITE_SCRIPT_ERROR: 'NETSUITE_UNEXPECTED_SUITE_SCRIPT_ERROR',
  NETSUITE_SALES_ORDER_MUST_BE_FULFILLED_ERROR: 'NETSUITE_SALES_ORDER_MUST_BE_FULFILLED_ERROR',
  NETSUITE_PERMISSION_VIOLATION_LISTS_TAX: 'NETSUITE_PERMISSION_VIOLATION_LISTS_TAX',
  NETSUITE_INVENTORY_DETAIL_QUANTITY_ERROR: 'NETSUITE_INVENTORY_DETAIL_QUANTITY_ERROR',
  RYDER_NO_INTEGRATION: 'RYDER_NO_INTEGRATION',
  RYDER_MISSING_REFRESH_TOKEN: 'RYDER_MISSING_REFRESH_TOKEN',
  RYDER_NO_ORDERS_FOUND: 'RYDER_NO_ORDERS_FOUND',
  RYDER_NO_WAREHOUSES: 'RYDER_NO_WAREHOUSES',
  RYDER_WAREHOUSE_NOT_MATCHED: 'RYDER_WAREHOUSE_NOT_MATCHED',
  RYDER_NO_RETURN_ID: 'RYDER_NO_RETURN_ID',
  RYDER_DUPLICATE_REFERENCE: 'RYDER_DUPLICATE_REFERENCE',
  RYDER_NO_RETURN_ITEMS: 'RYDER_NO_RETURN_ITEMS',
  SHIPBOB_NO_ORDERS_FOUND_FOR_SHOPIFY_ORDER_ERROR: 'SHIPBOB_NO_ORDERS_FOUND_FOR_SHOPIFY_ORDER_ERROR',
  SHIPBOB_NO_FULFILLMENT_CENTERS: 'SHIPBOB_NO_FULFILLMENT_CENTERS',
  SHIPBOB_NO_REDO_CHANNEL: 'SHIPBOB_NO_REDO_CHANNEL',
  SHIPBOB_NO_REFERENCE_IDS: 'SHIPBOB_NO_REFERENCE_IDS',
  SHIPBOB_DUPLICATE_REFERENCE_ID: 'SHIPBOB_DUPLICATE_REFERENCE_ID',
  SHIPBOB_MISSING_REFRESH_TOKEN: 'SHIPBOB_MISSING_REFRESH_TOKEN',
  SHIPBOB_NO_INTEGRATION: 'SHIPBOB_NO_INTEGRATION',
  SHIPBOB_NO_RETURN_ID: 'SHIPBOB_NO_RETURN_ID',
  SHIPBOB_NO_RETURN_FOUND_BY_REFERENCE_ID: 'SHIPBOB_NO_RETURN_FOUND_BY_REFERENCE_ID',
  SHIPBOB_FULFILLMENT_CENTER_NOT_MATCHED: 'SHIPBOB_FULFILLMENT_CENTER_NOT_MATCHED',
  SHIPMONK_NO_INTEGRATION: 'SHIPMONK_NO_INTEGRATION',
  SHIPMONK_DUPLICATE_ENTRY: 'SHIPMONK_DUPLICATE_ENTRY',
  SHIPMONK_BAD_REQUEST: 'SHIPMONK_BAD_REQUEST',
  SHIPMONK_SKU_NOT_FOUND: 'SHIPMONK_SKU_NOT_FOUND',
  SHIPMONK_WAREHOUSE_NOT_CONFIGURED: 'SHIPMONK_WAREHOUSE_NOT_CONFIGURED',
  SHIPMONK_STORE_NOT_CONFIGURED: 'SHIPMONK_STORE_NOT_CONFIGURED',
  SHIPMONK_AUTHENTICATION_ERROR: 'SHIPMONK_AUTHENTICATION_ERROR',
  SHIPMONK_NO_WAREHOUSES: 'SHIPMONK_NO_WAREHOUSES',
  SHIPMONK_WAREHOUSE_NOT_MATCHED: 'SHIPMONK_WAREHOUSE_NOT_MATCHED',
  SHIPMONK_ORDER_NOT_FOUND: 'SHIPMONK_ORDER_NOT_FOUND',
  SHIPEDGE_DUPLICATE_ENTRY: 'SHIPEDGE_DUPLICATE_ENTRY',
  SHIPEDGE_BAD_REQUEST: 'SHIPEDGE_BAD_REQUEST',
  SHIPEDGE_AUTHENTICATION_ERROR: 'SHIPEDGE_AUTHENTICATION_ERROR',
  SHIPEDGE_ORDER_NOT_FOUND: 'SHIPEDGE_ORDER_NOT_FOUND',
  SFOM_DIDNT_RECEIVE_RMA_ID: 'SFOM_DIDNT_RECEIVE_RMA_ID',
  APPAREL_MAGIC_ORDER_NOT_FOUND: 'APPAREL_MAGIC_ORDER_NOT_FOUND',
  APPAREL_MAGIC_RA_NOT_DEFINED: 'APPAREL_MAGIC_RA_NOT_DEFINED',
  APPAREL_MAGIC_MULTIPLE_ORDERS: 'APPAREL_MAGIC_MULTIPLE_ORDERS',
  APPAREL_MAGIC_NO_ITEMS_TO_RETURN: 'APPAREL_MAGIC_NO_ITEMS_TO_RETURN',
  APPAREL_MAGIC_INSUFFICIENT_QUANTITY: 'APPAREL_MAGIC_INSUFFICIENT_QUANTITY',
  APPAREL_MAGIC_UNAUTHORIZED_ERROR: 'APPAREL_MAGIC_UNAUTHORIZED_ERROR',
  AIMS360_GENERAL_ERROR: 'AIMS360_GENERAL_ERROR',
  AIMS360_NO_INVOICES_FOUND: 'AIMS360_NO_INVOICES_FOUND',
  AIMS360_NO_AVAILABLE_QUANTITY: 'AIMS360_NO_AVAILABLE_QUANTITY',
  CLOUDX_ITEM_MASTER_ERROR: 'CLOUDX_ITEM_MASTER_ERROR',
  CLOUDX_STATE_ERROR: 'CLOUDX_STATE_ERROR',
  CLOUDX_UPC_SKU_NOT_FOUND: 'CLOUDX_UPC_SKU_NOT_FOUND',
  EXTENSIV_AUTHENTICATION_ERROR: 'EXTENSIV_AUTHENTICATION_ERROR',
  EXTENSIV_BAD_REQUEST: 'EXTENSIV_BAD_REQUEST',
  EXTENSIV_DUPLICATE_ENTRY: 'EXTENSIV_DUPLICATE_ENTRY',
  SHIPSTREAM_DELIVERY_ALREADY_EXISTS: 'SHIPSTREAM_DELIVERY_ALREADY_EXISTS',
  SHIPSTREAM_SKU_NOT_FOUND: 'SHIPSTREAM_SKU_NOT_FOUND',
  ORDER_ID_NOT_FOUND_AFTER_CALLING_TRACKSTAR_ORDER_API: 'ORDER_ID_NOT_FOUND_AFTER_CALLING_TRACKSTAR_ORDER_API',
  ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',
  ORDER_ITEM_NOT_FOUND: 'ORDER_ITEM_NOT_FOUND',
  WHIPLASH_RYDER_INVENTORY_ITEM_NOT_FOUND: 'WHIPLASH_RYDER_INVENTORY_ITEM_NOT_FOUND',
  WHIPLASH_RYDER_SKU_NOT_FOUND: 'WHIPLASH_RYDER_SKU_NOT_FOUND',
  RETURN_ALREADY_EXISTS: 'RETURN_ALREADY_EXISTS',
  NO_WAREHOUSE_FOUND_FOR_SHIPMENT: 'NO_WAREHOUSE_FOUND_FOR_SHIPMENT',
  NO_ORDER_ID_FOUND_FOR_RETURN: 'NO_ORDER_ID_FOUND_FOR_RETURN',
  ORDER_NOT_FOUND_FOR_CUSTOMER_NUMBER_OR_PO_NUMBER: 'ORDER_NOT_FOUND_FOR_CUSTOMER_NUMBER_OR_PO_NUMBER',
  RYDER_ORDER_NOT_YET_SHIPPED: 'RYDER_ORDER_NOT_YET_SHIPPED',
  DEPOSCO_DUPLICATE_ENTRY: 'DEPOSCO_DUPLICATE_ENTRY',
  DEPOSCO_ORDER_NOT_FOUND: 'DEPOSCO_ORDER_NOT_FOUND',
  LABEL_REQUIRED: 'LABEL_REQUIRED',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
} as const

export type return_integration_error_code_values = (typeof return_integration_error_code_values)[keyof typeof return_integration_error_code_values]


export const return_product_strategy = {
  store_credit: 'store_credit',
  refund: 'refund',
  none: 'none',
  repair: 'repair'
} as const

export type return_product_strategy = (typeof return_product_strategy)[keyof typeof return_product_strategy]


export const return_status = {
  open: 'open',
  in_transit: 'in_transit',
  delivered: 'delivered',
  needs_review: 'needs_review',
  in_review: 'in_review',
  complete: 'complete',
  rejected: 'rejected',
  flagged: 'flagged',
  pre_shipment: 'pre_shipment',
  deleted: 'deleted'
} as const

export type return_status = (typeof return_status)[keyof typeof return_status]


export const return_tracking_trigger_key = {
  return_created: 'return_created',
  return_pre_transit: 'return_pre_transit',
  return_in_transit: 'return_in_transit',
  return_out_for_delivery: 'return_out_for_delivery',
  return_delivered: 'return_delivered',
  return_available_for_pickup: 'return_available_for_pickup',
  return_stalled: 'return_stalled',
  return_delayed: 'return_delayed',
  return_arriving_early: 'return_arriving_early',
  return_return_to_sender: 'return_return_to_sender',
  return_delivery_attempted: 'return_delivery_attempted',
  return_delivery_failure: 'return_delivery_failure',
  return_shipment_cancelled: 'return_shipment_cancelled',
  return_shipment_error: 'return_shipment_error',
  return_in_review: 'return_in_review',
  return_approved: 'return_approved',
  return_processed: 'return_processed',
  return_rejected: 'return_rejected',
  return_pickup_rescheduled_by_merchant: 'return_pickup_rescheduled_by_merchant',
  return_pickup_reminder: 'return_pickup_reminder',
  return_pickup_success: 'return_pickup_success',
  return_pickup_failure: 'return_pickup_failure',
  return_shipment_reminder: 'return_shipment_reminder',
  return_outstanding_balance: 'return_outstanding_balance',
  return_expired: 'return_expired',
  return_exchange_out_of_stock: 'return_exchange_out_of_stock',
  return_exchange_completed: 'return_exchange_completed',
  store_credit_created: 'store_credit_created',
  boxless_returns_rma_created: 'boxless_returns_rma_created'
} as const

export type return_tracking_trigger_key = (typeof return_tracking_trigger_key)[keyof typeof return_tracking_trigger_key]


export const return_type_enum = {
  claim: 'claim',
  return: 'return',
  warranty: 'warranty',
  recycle: 'recycle'
} as const

export type return_type_enum = (typeof return_type_enum)[keyof typeof return_type_enum]


export const returned_product_status = {
  open: 'open',
  complete: 'complete',
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  pre_shipment: 'pre_shipment',
  in_review: 'in_review'
} as const

export type returned_product_status = (typeof returned_product_status)[keyof typeof returned_product_status]


export const returns_processing_session_type = {
  verification: 'verification',
  grading: 'grading',
  license_plating: 'license_plating'
} as const

export type returns_processing_session_type = (typeof returns_processing_session_type)[keyof typeof returns_processing_session_type]


export const review_field_schema_type = {
  REVIEW_SHORT_ANSWER: 'REVIEW_SHORT_ANSWER',
  REVIEW_PARAGRAPH: 'REVIEW_PARAGRAPH',
  REVIEW_SINGLE_CHOICE: 'REVIEW_SINGLE_CHOICE',
  REVIEW_MEDIA_UPLOAD: 'REVIEW_MEDIA_UPLOAD',
  REVIEW_RATING: 'REVIEW_RATING'
} as const

export type review_field_schema_type = (typeof review_field_schema_type)[keyof typeof review_field_schema_type]


export const review_status = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  MANUAL_REVIEW: 'MANUAL_REVIEW'
} as const

export type review_status = (typeof review_status)[keyof typeof review_status]


export const reviewing_party = {
  redo: 'redo',
  merchant: 'merchant'
} as const

export type reviewing_party = (typeof reviewing_party)[keyof typeof reviewing_party]


export const root_causes = {
  bug: 'bug',
  design_flaw: 'design_flaw',
  missing_feature: 'missing_feature',
  configuration: 'configuration',
  third_party: 'third_party'
} as const

export type root_causes = (typeof root_causes)[keyof typeof root_causes]


export const satisfaction_response_status_types = {
  pending: 'pending',
  sent: 'sent',
  completed: 'completed'
} as const

export type satisfaction_response_status_types = (typeof satisfaction_response_status_types)[keyof typeof satisfaction_response_status_types]


export const saved_email_template_source = {
  forwarded: 'forwarded',
  uploaded: 'uploaded',
  saved: 'saved'
} as const

export type saved_email_template_source = (typeof saved_email_template_source)[keyof typeof saved_email_template_source]


export const scan_type = {
  scan_at_cart: 'scan_at_cart',
  scan_at_wall: 'scan_at_wall'
} as const

export type scan_type = (typeof scan_type)[keyof typeof scan_type]


export const schema_type = {
  order_tracking: 'order_tracking',
  return_tracking: 'return_tracking',
  return_processing_flow: 'return_processing_flow',
  tnpl_tracking: 'tnpl_tracking',
  email_marketing_signup: 'email_marketing_signup',
  sms_marketing_signup: 'sms_marketing_signup',
  marketing_campaign: 'marketing_campaign',
  reviews: 'reviews',
  marketing_email: 'marketing_email',
  marketing_cart_abandonment: 'marketing_cart_abandonment',
  marketing_browse_abandonment: 'marketing_browse_abandonment',
  marketing_checkout_abandonment: 'marketing_checkout_abandonment',
  marketing_commentsold_cart_abandonment: 'marketing_commentsold_cart_abandonment',
  marketing_commentsold_browse_abandonment: 'marketing_commentsold_browse_abandonment',
  marketing_commentsold_checkout_abandonment: 'marketing_commentsold_checkout_abandonment',
  marketing_back_in_stock: 'marketing_back_in_stock',
  marketing_segment_membership_change: 'marketing_segment_membership_change',
  marketing_warranty_registration: 'marketing_warranty_registration',
  marketing_low_inventory: 'marketing_low_inventory',
  marketing_date: 'marketing_date',
  marketing_price_drop: 'marketing_price_drop',
  oms_new_fulfillment_group: 'oms_new_fulfillment_group',
  oms_order_ready_for_pickup: 'oms_order_ready_for_pickup',
  address_verification_failed: 'address_verification_failed',
  checkout_tree: 'checkout_tree',
  rco_checkout_package: 'rco_checkout_package',
  post_purchase_flow: 'post_purchase_flow',
  product_subscription: 'product_subscription',
  extended_warranty: 'extended_warranty',
  tracking_page_flow: 'tracking_page_flow',
  rules: 'rules',
  yotpo_loyalty_expiration_reminder: 'yotpo_loyalty_expiration_reminder',
  yotpo_loyalty_points_reminder: 'yotpo_loyalty_points_reminder',
  yotpo_loyalty_redemption_reminder: 'yotpo_loyalty_redemption_reminder',
  yotpo_loyalty_redemption_created: 'yotpo_loyalty_redemption_created',
  yotpo_loyalty_referral_completed: 'yotpo_loyalty_referral_completed',
  yotpo_loyalty_referral_shared: 'yotpo_loyalty_referral_shared',
  yotpo_loyalty_customer_birthday: 'yotpo_loyalty_customer_birthday',
  yotpo_loyalty_opt_in: 'yotpo_loyalty_opt_in',
  yotpo_loyalty_tier_earned: 'yotpo_loyalty_tier_earned',
  yotpo_loyalty_tier_lost: 'yotpo_loyalty_tier_lost',
  yotpo_loyalty_points_earned: 'yotpo_loyalty_points_earned',
  loyalty_lion_reward_available: 'loyalty_lion_reward_available',
  custom_event: 'custom_event',
  refund_return_submitted: 'refund_return_submitted',
  exchange_processed_with_credit: 'exchange_processed_with_credit',
  loyalty_lion_enrolled: 'loyalty_lion_enrolled',
  marketing_agent: 'marketing_agent',
  work_order: 'work_order'
} as const

export type schema_type = (typeof schema_type)[keyof typeof schema_type]


export const scraped_storefront_info_type = {
  llm_extract: 'llm_extract',
  scrape: 'scrape'
} as const

export type scraped_storefront_info_type = (typeof scraped_storefront_info_type)[keyof typeof scraped_storefront_info_type]


export const scratcher_size = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl'
} as const

export type scratcher_size = (typeof scratcher_size)[keyof typeof scratcher_size]


export const seko_environment = {
  production: 'production',
  sandbox: 'sandbox'
} as const

export type seko_environment = (typeof seko_environment)[keyof typeof seko_environment]


export const selected_shipping_rate_set_by = {
  user: 'user',
  learning: 'learning',
  automations: 'automations',
  default_cheapest: 'default_cheapest',
  checkout_rate_purchased: 'checkout_rate_purchased'
} as const

export type selected_shipping_rate_set_by = (typeof selected_shipping_rate_set_by)[keyof typeof selected_shipping_rate_set_by]


export const send_webhook_auth_type = {
  none: 'none',
  oauth2_client_credentials: 'oauth2_client_credentials'
} as const

export type send_webhook_auth_type = (typeof send_webhook_auth_type)[keyof typeof send_webhook_auth_type]


export const sentiment = {
  positive: 'positive',
  negative: 'negative',
  neutral: 'neutral',
  none: 'none'
} as const

export type sentiment = (typeof sentiment)[keyof typeof sentiment]


export const service_invoice_type = {
  marketing_sms: 'marketing_sms',
  marketing_email: 'marketing_email',
  order_tracking: 'order_tracking',
  support_base: 'support_base',
  support_ai_subscription: 'support_ai_subscription',
  support_ai_usage: 'support_ai_usage',
  support_voice_subscription: 'support_voice_subscription',
  support_voice_usage: 'support_voice_usage',
  checkout_optimization: 'checkout_optimization',
  checkout_optimization_subscription: 'checkout_optimization_subscription',
  return_ai_exchange: 'return_ai_exchange',
  returns: 'returns',
  aeo: 'aeo',
  ims: 'ims',
  ims_forecasting: 'ims_forecasting',
  recover: 'recover',
  disputes: 'disputes'
} as const

export type service_invoice_type = (typeof service_invoice_type)[keyof typeof service_invoice_type]


export const shipment_document = {
  label: 'label',
  commercialInvoice: 'commercialInvoice'
} as const

export type shipment_document = (typeof shipment_document)[keyof typeof shipment_document]


export const shipment_error_code_values = {
  AUSPOST_ADDRESS_VALIDATION_ERROR: 'AUSPOST_ADDRESS_VALIDATION_ERROR',
  CARRIER_DID_NOT_RESPOND: 'CARRIER_DID_NOT_RESPOND',
  CARRIER_REQUEST_TIMEOUT: 'CARRIER_REQUEST_TIMEOUT',
  INVALID_FTR_EXEMPTION_OR_AES_CITATION: 'INVALID_FTR_EXEMPTION_OR_AES_CITATION',
  UPS_PHONE_NUMBER_TOO_SHORT: 'UPS_PHONE_NUMBER_TOO_SHORT',
  UPS_MISSING_SHIP_FROM_NAME: 'UPS_MISSING_SHIP_FROM_NAME',
  USPS_PHONE_NUMBER_INVALID: 'USPS_PHONE_NUMBER_INVALID',
  LABEL_PRICE_TOO_HIGH: 'LABEL_PRICE_TOO_HIGH',
  UNKNOWN_EASYPOST_ERROR: 'UNKNOWN_EASYPOST_ERROR',
  UNKNOWN_SHIPMENT_ERROR: 'UNKNOWN_SHIPMENT_ERROR'
} as const

export type shipment_error_code_values = (typeof shipment_error_code_values)[keyof typeof shipment_error_code_values]


export const shipment_refund_status = {
  submitted: 'submitted',
  refunded: 'refunded',
  rejected: 'rejected',
  not_applicable: 'not_applicable',
  already_shipped: 'already_shipped'
} as const

export type shipment_refund_status = (typeof shipment_refund_status)[keyof typeof shipment_refund_status]


export const shipment_schema_mode = {
  test: 'test',
  production: 'production'
} as const

export type shipment_schema_mode = (typeof shipment_schema_mode)[keyof typeof shipment_schema_mode]


export const shipping_claim_reason = {
  late: 'late',
  damaged: 'damaged',
  lost: 'lost',
  stolen: 'stolen'
} as const

export type shipping_claim_reason = (typeof shipping_claim_reason)[keyof typeof shipping_claim_reason]


export const shipping_claim_requested_by = {
  merchant: 'merchant',
  proactive: 'proactive'
} as const

export type shipping_claim_requested_by = (typeof shipping_claim_requested_by)[keyof typeof shipping_claim_requested_by]


export const shipping_claim_source = {
  merchant: 'merchant',
  redo: 'redo'
} as const

export type shipping_claim_source = (typeof shipping_claim_source)[keyof typeof shipping_claim_source]


export const shipping_claim_status = {
  requested: 'requested',
  submitted: 'submitted',
  carrier_unsubmitted_merchant_approved: 'carrier_unsubmitted_merchant_approved',
  carrier_submitted_merchant_approved: 'carrier_submitted_merchant_approved',
  approved: 'approved',
  rejected: 'rejected',
  pending_docs: 'pending_docs'
} as const

export type shipping_claim_status = (typeof shipping_claim_status)[keyof typeof shipping_claim_status]


export const shopify_basic_discount_customer_eligibility = {
  all: 'all',
  segments: 'segments',
  specific: 'specific'
} as const

export type shopify_basic_discount_customer_eligibility = (typeof shopify_basic_discount_customer_eligibility)[keyof typeof shopify_basic_discount_customer_eligibility]


export const shopify_exchange_order_strategy = {
  order: 'order',
  return: 'return'
} as const

export type shopify_exchange_order_strategy = (typeof shopify_exchange_order_strategy)[keyof typeof shopify_exchange_order_strategy]


export const shopify_exchange_payment_strategy = {
  draft_order: 'draft_order',
  stripe: 'stripe'
} as const

export type shopify_exchange_payment_strategy = (typeof shopify_exchange_payment_strategy)[keyof typeof shopify_exchange_payment_strategy]


export const shopify_extra_scope = {
  read_all_orders: 'read_all_orders'
} as const

export type shopify_extra_scope = (typeof shopify_extra_scope)[keyof typeof shopify_extra_scope]


export const shoppable_products_size = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl'
} as const

export type shoppable_products_size = (typeof shoppable_products_size)[keyof typeof shoppable_products_size]


export const sign_up_form_goal = {
  marketing_subscription: 'marketing_subscription',
  back_in_stock: 'back_in_stock'
} as const

export type sign_up_form_goal = (typeof sign_up_form_goal)[keyof typeof sign_up_form_goal]


export const signup_form_site_type = {
  tracking_page: 'tracking_page',
  marketing: 'marketing',
  customer_account: 'customer_account'
} as const

export type signup_form_site_type = (typeof signup_form_site_type)[keyof typeof signup_form_site_type]


export const size = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  custom: 'custom'
} as const

export type size = (typeof size)[keyof typeof size]


export const size_deprecated = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  custom: 'custom'
} as const

export type size_deprecated = (typeof size_deprecated)[keyof typeof size_deprecated]


export const slip_font_weight = {
  normal: 'normal',
  bold: 'bold'
} as const

export type slip_font_weight = (typeof slip_font_weight)[keyof typeof slip_font_weight]


export const slip_image_object_fit = {
  fill: 'fill',
  fit: 'fit',
  cover: 'cover'
} as const

export type slip_image_object_fit = (typeof slip_image_object_fit)[keyof typeof slip_image_object_fit]


export const slip_offer_text_type = {
  ai: 'ai',
  static: 'static'
} as const

export type slip_offer_text_type = (typeof slip_offer_text_type)[keyof typeof slip_offer_text_type]


export const slip_product_recommendation_layout = {
  adjacent: 'adjacent',
  overlay: 'overlay',
  image_only: 'image_only'
} as const

export type slip_product_recommendation_layout = (typeof slip_product_recommendation_layout)[keyof typeof slip_product_recommendation_layout]


export const slip_product_selection_mode = {
  ai: 'ai',
  static: 'static'
} as const

export type slip_product_selection_mode = (typeof slip_product_selection_mode)[keyof typeof slip_product_selection_mode]


export const slip_qr_code_position = {
  left: 'left',
  right: 'right'
} as const

export type slip_qr_code_position = (typeof slip_qr_code_position)[keyof typeof slip_qr_code_position]


export const slip_text_alignment = {
  left: 'left',
  center: 'center',
  right: 'right'
} as const

export type slip_text_alignment = (typeof slip_text_alignment)[keyof typeof slip_text_alignment]


export const slip_text_block_type = {
  static: 'static',
  title: 'title',
  subtitle: 'subtitle',
  custom: 'custom'
} as const

export type slip_text_block_type = (typeof slip_text_block_type)[keyof typeof slip_text_block_type]


export const slip_text_placement = {
  top: 'top',
  left: 'left',
  right: 'right',
  bottom: 'bottom'
} as const

export type slip_text_placement = (typeof slip_text_placement)[keyof typeof slip_text_placement]


export const slip_vertical_alignment = {
  top: 'top',
  center: 'center',
  bottom: 'bottom'
} as const

export type slip_vertical_alignment = (typeof slip_vertical_alignment)[keyof typeof slip_vertical_alignment]


export const snooze_duration = {
  one_hour: 'one_hour',
  same_day: 'same_day',
  one_day: 'one_day',
  two_days: 'two_days',
  saturday: 'saturday',
  monday: 'monday'
} as const

export type snooze_duration = (typeof snooze_duration)[keyof typeof snooze_duration]


export const social_icon_color = {
  black: 'black',
  white: 'white',
  gray: 'gray'
} as const

export type social_icon_color = (typeof social_icon_color)[keyof typeof social_icon_color]


export const sort_direction = {
  asc: 'asc',
  desc: 'desc'
} as const

export type sort_direction = (typeof sort_direction)[keyof typeof sort_direction]


export const special_rate_eligibility = {
  USPS_MEDIAMAIL: 'USPS_MEDIAMAIL',
  USPS_LIBRARYMAIL: 'USPS_LIBRARYMAIL',
  USPS_MEDIAMAIL_USPS_LIBRARYMAIL: 'USPS_MEDIAMAIL_USPS_LIBRARYMAIL',
  DHL_BPM: 'DHL_BPM'
} as const

export type special_rate_eligibility = (typeof special_rate_eligibility)[keyof typeof special_rate_eligibility]


export const spotlight_trigger_type = {
  exitIntent: 'exitIntent',
  timeOnPage: 'timeOnPage',
  checkoutProbability: 'checkoutProbability',
  shopperIndecision: 'shopperIndecision',
  backInStock: 'backInStock'
} as const

export type spotlight_trigger_type = (typeof spotlight_trigger_type)[keyof typeof spotlight_trigger_type]


export const stagecoach_model_status = {
  provisioning: 'provisioning',
  active: 'active',
  training: 'training',
  failed: 'failed'
} as const

export type stagecoach_model_status = (typeof stagecoach_model_status)[keyof typeof stagecoach_model_status]


export const stagecoach_pp_type = {
  normal: 'normal',
  plus: 'plus'
} as const

export type stagecoach_pp_type = (typeof stagecoach_pp_type)[keyof typeof stagecoach_pp_type]


export const step_type = {
  trigger: 'trigger',
  condition: 'condition',
  wait: 'wait',
  wait_for_event: 'wait_for_event',
  do_nothing: 'do_nothing',
  send_email: 'send_email',
  send_sms: 'send_sms',
  send_webhook: 'send_webhook',
  ab_test: 'ab_test',
  manage_customer_tags: 'manage_customer_tags',
  manage_static_segment: 'manage_static_segment',
  recover: 'recover',
  upsell: 'upsell',
  downsell: 'downsell',
  upsell_condition: 'upsell_condition',
  oms_action: 'oms_action',
  oms_condition: 'oms_condition',
  rco_split: 'rco_split',
  checkout_experience: 'checkout_experience',
  rco_segment: 'rco_segment',
  block_checkout: 'block_checkout',
  rco_checkout_package: 'rco_checkout_package',
  rco_checkout_package_condition: 'rco_checkout_package_condition',
  post_purchase_page: 'post_purchase_page',
  post_purchase_segment: 'post_purchase_segment',
  post_purchase_split: 'post_purchase_split',
  tracking_page: 'tracking_page',
  rule_conditions: 'rule_conditions',
  rule_actions: 'rule_actions',
  work_order_work_step: 'work_order_work_step',
  work_order_condition: 'work_order_condition',
  process_return: 'process_return'
} as const

export type step_type = (typeof step_type)[keyof typeof step_type]


export const StorageLocationAdjustmentKind = {
  Manual: 'Manual',
  Pick: 'Pick',
  Putaway: 'Putaway',
  Receiving: 'Receiving',
  Transfer: 'Transfer',
  replenish: 'replenish',
  bin_count: 'bin_count'
} as const

export type StorageLocationAdjustmentKind = (typeof StorageLocationAdjustmentKind)[keyof typeof StorageLocationAdjustmentKind]


export const StorageLocationSource = {
  Manual: 'Manual',
  WarehouseMapper: 'WarehouseMapper',
  System: 'System'
} as const

export type StorageLocationSource = (typeof StorageLocationSource)[keyof typeof StorageLocationSource]


export const StorageLocationType = {
  Bin: 'Bin',
  Tote: 'Tote',
  Storage: 'Storage',
  Receiving: 'Receiving',
  External: 'External',
  lost: 'lost',
  Transit: 'Transit',
  unmapped: 'unmapped',
  default: 'default',
  waste: 'waste'
} as const

export type StorageLocationType = (typeof StorageLocationType)[keyof typeof StorageLocationType]


export const stored_credit_source = {
  client: 'client',
  exchange: 'exchange',
  exchange_stock: 'exchange_stock'
} as const

export type stored_credit_source = (typeof stored_credit_source)[keyof typeof stored_credit_source]


export const submit_return_error_code = {
  DRAFT_RETURN_NOT_FOUND: 'DRAFT_RETURN_NOT_FOUND',
  ORDERS_NOT_FOUND: 'ORDERS_NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  PROVISION_TYPE_REQUIRED: 'PROVISION_TYPE_REQUIRED',
  PROVISION_TYPE_NOT_ALLOWED: 'PROVISION_TYPE_NOT_ALLOWED',
  MISSING_CUSTOMER_SHIPPING_ADDRESS: 'MISSING_CUSTOMER_SHIPPING_ADDRESS',
  MISSING_COMPENSATION_METHOD: 'MISSING_COMPENSATION_METHOD',
  UNABLE_TO_GET_RETURN_TOTALS: 'UNABLE_TO_GET_RETURN_TOTALS',
  MUST_RETURN_ONE_ITEM: 'MUST_RETURN_ONE_ITEM',
  RETURN_ALREADY_EXISTS: 'RETURN_ALREADY_EXISTS',
  ITEM_ALREADY_RETURNED: 'ITEM_ALREADY_RETURNED',
  INVALID_COLLECTION_HOLD_AMOUNT: 'INVALID_COLLECTION_HOLD_AMOUNT',
  INVALID_PAYMENT_TOKEN: 'INVALID_PAYMENT_TOKEN',
  NO_PAYMENT_TOKEN: 'NO_PAYMENT_TOKEN',
  UPSELL_CHARGE_FAILED: 'UPSELL_CHARGE_FAILED',
  ON_HOLD_CHARGE_FAILED: 'ON_HOLD_CHARGE_FAILED',
  SHIPPING_CHARGE_FAILED: 'SHIPPING_CHARGE_FAILED',
  REPAIR_CHARGE_FAILED: 'REPAIR_CHARGE_FAILED',
  ADJUSTMENT_CHARGE_FAILED: 'ADJUSTMENT_CHARGE_FAILED',
  RETURNABLE_ITEM_NOT_FOUND: 'RETURNABLE_ITEM_NOT_FOUND',
  RETURN_NOT_FOUND: 'RETURN_NOT_FOUND',
  LABEL_PRICE_TOO_HIGH: 'LABEL_PRICE_TOO_HIGH',
  NOTIFYING_FAILED_NOT_RETRYING_FIX_ME: 'NOTIFYING_FAILED_NOT_RETRYING_FIX_ME',
  NO_CUSTOMER_FOUND: 'NO_CUSTOMER_FOUND',
  LABEL_PAYER_REQUIRED: 'LABEL_PAYER_REQUIRED',
  NO_CHARGES: 'NO_CHARGES',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  ALL_SHIPMENTS_MUST_HAVE_PENDING_ITEM: 'ALL_SHIPMENTS_MUST_HAVE_PENDING_ITEM',
  CARD_SETUP_FAILED: 'CARD_SETUP_FAILED',
  CASH_REFUND_NOT_ALLOWED: 'CASH_REFUND_NOT_ALLOWED'
} as const

export type submit_return_error_code = (typeof submit_return_error_code)[keyof typeof submit_return_error_code]


export const supported_wait_for_event_type = {
  MARKETING_CONFIRMED: 'MARKETING_CONFIRMED'
} as const

export type supported_wait_for_event_type = (typeof supported_wait_for_event_type)[keyof typeof supported_wait_for_event_type]


export const surcharge_dispute_status = {
  open: 'open',
  submitted_to_carrier: 'submitted_to_carrier',
  accepted: 'accepted',
  rejected: 'rejected'
} as const

export type surcharge_dispute_status = (typeof surcharge_dispute_status)[keyof typeof surcharge_dispute_status]


export const surcharge_source = {
  easypost: 'easypost',
  amazon: 'amazon',
  fedex: 'fedex',
  ups: 'ups',
  ups_direct: 'ups_direct',
  international_bridge: 'international_bridge',
  first_mile: 'first_mile',
  usps: 'usps'
} as const

export type surcharge_source = (typeof surcharge_source)[keyof typeof surcharge_source]


export const tag_filter_operator = {
  is: 'is',
  is_not: 'is_not'
} as const

export type tag_filter_operator = (typeof tag_filter_operator)[keyof typeof tag_filter_operator]


export const tag_kind = {
  fulfillment_group: 'fulfillment_group',
  conversation: 'conversation',
  customer: 'customer',
  return: 'return'
} as const

export type tag_kind = (typeof tag_kind)[keyof typeof tag_kind]


export const targeting_type = {
  all_visitors: 'all_visitors',
  exclude_existing_contacts: 'exclude_existing_contacts',
  only_existing_contacts: 'only_existing_contacts'
} as const

export type targeting_type = (typeof targeting_type)[keyof typeof targeting_type]


export const task_assignee_type = {
  user: 'user',
  role: 'role'
} as const

export type task_assignee_type = (typeof task_assignee_type)[keyof typeof task_assignee_type]


export const task_assignment_status = {
  active: 'active',
  dismissed: 'dismissed',
  resolved: 'resolved'
} as const

export type task_assignment_status = (typeof task_assignment_status)[keyof typeof task_assignment_status]


export const task_domain = {
  warehouse: 'warehouse'
} as const

export type task_domain = (typeof task_domain)[keyof typeof task_domain]


export const task_priority = {
  low: 'low',
  medium: 'medium',
  high: 'high',
  urgent: 'urgent'
} as const

export type task_priority = (typeof task_priority)[keyof typeof task_priority]


export const task_status = {
  open: 'open',
  claimed: 'claimed',
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled'
} as const

export type task_status = (typeof task_status)[keyof typeof task_status]


export const task_subtype = {
  replenishment: 'replenishment',
  count: 'count'
} as const

export type task_subtype = (typeof task_subtype)[keyof typeof task_subtype]


export const task_user_event_type = {
  assignment_seen: 'assignment_seen',
  task_claimed: 'task_claimed',
  task_unclaimed: 'task_unclaimed',
  task_dismissed: 'task_dismissed',
  notification_sent: 'notification_sent'
} as const

export type task_user_event_type = (typeof task_user_event_type)[keyof typeof task_user_event_type]


export const tax_id_entity = {
  SENDER: 'SENDER',
  RECEIVER: 'RECEIVER'
} as const

export type tax_id_entity = (typeof tax_id_entity)[keyof typeof tax_id_entity]


export const tax_id_type = {
  EIN: 'EIN',
  EORI: 'EORI',
  IOSS: 'IOSS',
  PAN: 'PAN',
  SSN: 'SSN',
  TIN: 'TIN',
  UKIMS: 'UKIMS',
  VAT: 'VAT',
  VOEC: 'VOEC',
  PVA: 'PVA'
} as const

export type tax_id_type = (typeof tax_id_type)[keyof typeof tax_id_type]


export const team_billing_failure_option = {
  allow: 'allow',
  restrict: 'restrict'
} as const

export type team_billing_failure_option = (typeof team_billing_failure_option)[keyof typeof team_billing_failure_option]


export const team_billing_method = {
  stripe: 'stripe',
  fake: 'fake'
} as const

export type team_billing_method = (typeof team_billing_method)[keyof typeof team_billing_method]


export const team_type = {
  store: 'store',
  PL: 'PL'
} as const

export type team_type = (typeof team_type)[keyof typeof team_type]


export const teaser_visibility = {
  before_displaying: 'before_displaying',
  after_closing: 'after_closing'
} as const

export type teaser_visibility = (typeof teaser_visibility)[keyof typeof teaser_visibility]


export const template_type = {
  transactional: 'transactional',
  marketing: 'marketing',
  default: 'default',
  recover: 'recover'
} as const

export type template_type = (typeof template_type)[keyof typeof template_type]


export const texas_segment_removal_document_type = {
  campaign: 'campaign',
  automation: 'automation'
} as const

export type texas_segment_removal_document_type = (typeof texas_segment_removal_document_type)[keyof typeof texas_segment_removal_document_type]


export const text_appearance = {
  critical: 'critical',
  warning: 'warning',
  success: 'success'
} as const

export type text_appearance = (typeof text_appearance)[keyof typeof text_appearance]


export const text_messaging_verification_status = {
  unverified: 'unverified',
  pending: 'pending',
  verified: 'verified'
} as const

export type text_messaging_verification_status = (typeof text_messaging_verification_status)[keyof typeof text_messaging_verification_status]


export const text_size = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge'
} as const

export type text_size = (typeof text_size)[keyof typeof text_size]


export const third_party_refund_provider = {
  refundid: 'refundid'
} as const

export type third_party_refund_provider = (typeof third_party_refund_provider)[keyof typeof third_party_refund_provider]


export const time_granularity = {
  day: 'day'
} as const

export type time_granularity = (typeof time_granularity)[keyof typeof time_granularity]


export const time_unit = {
  year: 'year',
  month: 'month',
  week: 'week',
  day: 'day',
  hour: 'hour',
  minute: 'minute',
  second: 'second',
  millisecond: 'millisecond'
} as const

export type time_unit = (typeof time_unit)[keyof typeof time_unit]


export const timeline_actor_type = {
  SYSTEM: 'SYSTEM',
  RULE: 'RULE',
  USER: 'USER',
  CUSTOMER: 'CUSTOMER',
  AI: 'AI',
  EXTERNAL_USER: 'EXTERNAL_USER'
} as const

export type timeline_actor_type = (typeof timeline_actor_type)[keyof typeof timeline_actor_type]


export const tnpl_acceptable_risk_level = {
  none: 'none',
  low: 'low',
  medium: 'medium',
  high: 'high',
  any: 'any'
} as const

export type tnpl_acceptable_risk_level = (typeof tnpl_acceptable_risk_level)[keyof typeof tnpl_acceptable_risk_level]


export const tnpl_cancellation_type = {
  initial_payment_failed: 'initial_payment_failed',
  ineligible_for_trial: 'ineligible_for_trial'
} as const

export type tnpl_cancellation_type = (typeof tnpl_cancellation_type)[keyof typeof tnpl_cancellation_type]


export const tnpl_charge_status = {
  pending: 'pending',
  succeeded: 'succeeded',
  failed: 'failed',
  api_failure: 'api_failure'
} as const

export type tnpl_charge_status = (typeof tnpl_charge_status)[keyof typeof tnpl_charge_status]


export const tnpl_charge_type = {
  authorization: 'authorization',
  capture_previous_authorization: 'capture_previous_authorization',
  authorize_and_capture: 'authorize_and_capture'
} as const

export type tnpl_charge_type = (typeof tnpl_charge_type)[keyof typeof tnpl_charge_type]


export const tnpl_contract_status = {
  trial_active: 'trial_active',
  cancelled: 'cancelled',
  complete_paid_by_customer: 'complete_paid_by_customer',
  complete_returned: 'complete_returned'
} as const

export type tnpl_contract_status = (typeof tnpl_contract_status)[keyof typeof tnpl_contract_status]


export const trackable_billing_status = {
  billed: 'billed',
  free: 'free'
} as const

export type trackable_billing_status = (typeof trackable_billing_status)[keyof typeof trackable_billing_status]


export const tracking_page_event_type = {
  ad: 'ad',
  upsell: 'upsell',
  promotion: 'promotion',
  subscription: 'subscription'
} as const

export type tracking_page_event_type = (typeof tracking_page_event_type)[keyof typeof tracking_page_event_type]


export const transfer_order_status = {
  DRAFT: 'DRAFT',
  UNFULFILLED: 'UNFULFILLED',
  PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED',
  FULFILLED: 'FULFILLED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  COMPLETE: 'COMPLETE'
} as const

export type transfer_order_status = (typeof transfer_order_status)[keyof typeof transfer_order_status]


export const transfer_side = {
  source: 'source',
  destination: 'destination'
} as const

export type transfer_side = (typeof transfer_side)[keyof typeof transfer_side]


export const transfer_type = {
  pick: 'pick',
  putaway: 'putaway',
  transfer: 'transfer',
  replenish: 'replenish',
  receiving: 'receiving',
  manual_pick: 'manual_pick',
  void: 'void',
  work_order: 'work_order'
} as const

export type transfer_type = (typeof transfer_type)[keyof typeof transfer_type]


export const treatment_type = {
  Treatment: 'Treatment',
  ConciergeTreatment: 'ConciergeTreatment',
  CheckoutOptimization: 'CheckoutOptimization',
  ExpandedWarranty: 'ExpandedWarranty',
  SignupForm: 'SignupForm',
  RescuePanel: 'RescuePanel',
  SupportAgent: 'SupportAgent',
  PricingTest: 'PricingTest',
  MarketingAgent: 'MarketingAgent',
  Spotlight: 'Spotlight',
  AutomationOutreach: 'AutomationOutreach',
  PostPurchase: 'PostPurchase'
} as const

export type treatment_type = (typeof treatment_type)[keyof typeof treatment_type]


export const unique_product_filter_type = {
  price: 'price',
  inventory: 'inventory',
  collection: 'collection',
  metafield: 'metafield',
  tag: 'tag',
  exclude_purchased_products: 'exclude_purchased_products'
} as const

export type unique_product_filter_type = (typeof unique_product_filter_type)[keyof typeof unique_product_filter_type]


export const upsell_analytics_record_billing_kind = {
  ONE_CLICK_UPSELL: 'ONE_CLICK_UPSELL',
  CONVERSION_CLOUD: 'CONVERSION_CLOUD'
} as const

export type upsell_analytics_record_billing_kind = (typeof upsell_analytics_record_billing_kind)[keyof typeof upsell_analytics_record_billing_kind]


export const upsell_analytics_record_billing_status = {
  FREE: 'FREE',
  BILLED: 'BILLED',
  BILLING_FAILED: 'BILLING_FAILED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  PENDING: 'PENDING'
} as const

export type upsell_analytics_record_billing_status = (typeof upsell_analytics_record_billing_status)[keyof typeof upsell_analytics_record_billing_status]


export const upsell_billing_trigger = {
  exchange_order_created: 'exchange_order_created',
  return_created: 'return_created'
} as const

export type upsell_billing_trigger = (typeof upsell_billing_trigger)[keyof typeof upsell_billing_trigger]


export const upsell_page_element_type = {
  banner: 'banner',
  timer: 'timer',
  upsell_product: 'upsell_product'
} as const

export type upsell_page_element_type = (typeof upsell_page_element_type)[keyof typeof upsell_page_element_type]


export const upsell_page_layout_type = {
  one_product_upsell: 'one_product_upsell',
  two_product_upsell: 'two_product_upsell',
  three_product_upsell: 'three_product_upsell',
  two_product_upsell_vertical: 'two_product_upsell_vertical',
  four_product_upsell_vertical: 'four_product_upsell_vertical'
} as const

export type upsell_page_layout_type = (typeof upsell_page_layout_type)[keyof typeof upsell_page_layout_type]


export const upsell_page_product_source = {
  Redo_AI: 'Redo_AI',
  Manual_selection: 'Manual_selection',
  Collection: 'Collection',
  Shopify_recommendation: 'Shopify_recommendation'
} as const

export type upsell_page_product_source = (typeof upsell_page_product_source)[keyof typeof upsell_page_product_source]


export const urlmatching_type = {
  exact: 'exact',
  contains: 'contains'
} as const

export type urlmatching_type = (typeof urlmatching_type)[keyof typeof urlmatching_type]


export const urlvisibility_type = {
  inclusive: 'inclusive',
  exclusive: 'exclusive'
} as const

export type urlvisibility_type = (typeof urlvisibility_type)[keyof typeof urlvisibility_type]


export const uscustoms_ruling_type = {
  HQ: 'HQ',
  NY: 'NY'
} as const

export type uscustoms_ruling_type = (typeof uscustoms_ruling_type)[keyof typeof uscustoms_ruling_type]


export const user_call_availability = {
  available: 'available',
  in_call: 'in_call',
  unavailable: 'unavailable'
} as const

export type user_call_availability = (typeof user_call_availability)[keyof typeof user_call_availability]


export const user_creation_source = {
  unknown: 'unknown',
  redo_admin: 'redo_admin',
  shopify_login: 'shopify_login',
  added_by_merchant: 'added_by_merchant',
  bigcommerce_login: 'bigcommerce_login',
  integration_user: 'integration_user',
  pos_user: 'pos_user'
} as const

export type user_creation_source = (typeof user_creation_source)[keyof typeof user_creation_source]


export const user_role = {
  admin: 'admin',
  managed_claims_admin: 'managed_claims_admin',
  support: 'support',
  user: 'user',
  reply_only: 'reply_only',
  view_only: 'view_only',
  audien_support: 'audien_support'
} as const

export type user_role = (typeof user_role)[keyof typeof user_role]


export const user_session_platform = {
  shopify: 'shopify'
} as const

export type user_session_platform = (typeof user_session_platform)[keyof typeof user_session_platform]


export const usps_adjustment_pricing_characteristic = {
  WEIGHT: 'WEIGHT',
  DIM_WEIGHT: 'DIM_WEIGHT',
  LENGTH: 'LENGTH',
  WIDTH: 'WIDTH',
  HEIGHT: 'HEIGHT',
  ORIGIN_ZIP_CODE: 'ORIGIN_ZIP_CODE',
  DESTINATION_ZIP_CODE: 'DESTINATION_ZIP_CODE',
  ZONE: 'ZONE',
  DESTINATION_ENTRY_FACILITY_TYPE: 'DESTINATION_ENTRY_FACILITY_TYPE',
  RATE_INDICATOR: 'RATE_INDICATOR',
  MAIL_CLASS: 'MAIL_CLASS'
} as const

export type usps_adjustment_pricing_characteristic = (typeof usps_adjustment_pricing_characteristic)[keyof typeof usps_adjustment_pricing_characteristic]


export const usps_adjustment_root_cause = {
  WEIGHT: 'WEIGHT',
  DIMENSIONS: 'DIMENSIONS',
  DIMENSIONAL: 'DIMENSIONAL',
  PACKAGING: 'PACKAGING',
  ZONE: 'ZONE',
  MIS_SHIPPED: 'MIS_SHIPPED',
  UNMANIFESTED: 'UNMANIFESTED',
  DUPLICATE: 'DUPLICATE',
  CENSUS: 'CENSUS',
  UNUSED_LABEL: 'UNUSED_LABEL'
} as const

export type usps_adjustment_root_cause = (typeof usps_adjustment_root_cause)[keyof typeof usps_adjustment_root_cause]


export const usps_adjustment_status = {
  PENDING: 'PENDING',
  CHARGED: 'CHARGED',
  REMOVED: 'REMOVED'
} as const

export type usps_adjustment_status = (typeof usps_adjustment_status)[keyof typeof usps_adjustment_status]


export const usps_direct_rate_type = {
  redo_rates: 'redo_rates',
  merchant_rates: 'merchant_rates'
} as const

export type usps_direct_rate_type = (typeof usps_direct_rate_type)[keyof typeof usps_direct_rate_type]


export const uspsexemption_code = {
  NOEEI_30_36: 'NOEEI_30_36',
  NOEEI_30_37_a_: 'NOEEI_30_37_a_',
  NOEEI_30_37_b_: 'NOEEI_30_37_b_',
  NOEEI_30_37_c_: 'NOEEI_30_37_c_',
  NOEEI_30_37_d_: 'NOEEI_30_37_d_',
  NOEEI_30_37_f_: 'NOEEI_30_37_f_',
  NOEEI_30_37_g_: 'NOEEI_30_37_g_',
  NOEEI_30_37_h_: 'NOEEI_30_37_h_',
  NOEEI_30_37_i_: 'NOEEI_30_37_i_',
  NOEEI_30_37_j_: 'NOEEI_30_37_j_',
  NOEEI_30_37_k_: 'NOEEI_30_37_k_',
  NOEEI_30_37_l_: 'NOEEI_30_37_l_',
  NOEEI_30_37_m_: 'NOEEI_30_37_m_',
  NOEEI_30_37_n_: 'NOEEI_30_37_n_',
  NOEEI_30_37_o_: 'NOEEI_30_37_o_',
  NOEEI_30_37_p_: 'NOEEI_30_37_p_',
  NOEEI_30_37_s_: 'NOEEI_30_37_s_',
  NOEEI_30_37_t_: 'NOEEI_30_37_t_',
  NOEEI_30_37_u_: 'NOEEI_30_37_u_',
  NOEEI_30_37_v_: 'NOEEI_30_37_v_',
  NOEEI_30_37_w_: 'NOEEI_30_37_w_',
  NOEEI_30_37_x_: 'NOEEI_30_37_x_',
  NOEEI_30_37_y_: 'NOEEI_30_37_y_'
} as const

export type uspsexemption_code = (typeof uspsexemption_code)[keyof typeof uspsexemption_code]


export const variant_exchange_guidance_level = {
  collection: 'collection',
  tag: 'tag',
  team: 'team',
  product: 'product'
} as const

export type variant_exchange_guidance_level = (typeof variant_exchange_guidance_level)[keyof typeof variant_exchange_guidance_level]


export const vertical_alignment = {
  top: 'top',
  center: 'center',
  bottom: 'bottom'
} as const

export type vertical_alignment = (typeof vertical_alignment)[keyof typeof vertical_alignment]


export const view_export_scope = {
  all: 'all',
  selected: 'selected'
} as const

export type view_export_scope = (typeof view_export_scope)[keyof typeof view_export_scope]


export const view_export_status = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed'
} as const

export type view_export_status = (typeof view_export_status)[keyof typeof view_export_status]


export const view_export_type = {
  standard: 'standard',
  expanded: 'expanded'
} as const

export type view_export_type = (typeof view_export_type)[keyof typeof view_export_type]


export const wait_time_unit = {
  Days: 'Days',
  Hours: 'Hours',
  Minutes: 'Minutes'
} as const

export type wait_time_unit = (typeof wait_time_unit)[keyof typeof wait_time_unit]


export const warranty_registration_response_type = {
  images: 'images',
  text_area: 'text_area',
  videos: 'videos',
  multiple_choice: 'multiple_choice'
} as const

export type warranty_registration_response_type = (typeof warranty_registration_response_type)[keyof typeof warranty_registration_response_type]


export const webhook_event_status = {
  success: 'success',
  failed: 'failed',
  pending: 'pending'
} as const

export type webhook_event_status = (typeof webhook_event_status)[keyof typeof webhook_event_status]


export const webhook_event_type = {
  RETURN_EVENT_DROPPED_OFF: 'RETURN_EVENT_DROPPED_OFF',
  RETURN_EVENT_DESPATCHED_FROM_PUDO: 'RETURN_EVENT_DESPATCHED_FROM_PUDO',
  RETURN_EVENT_ARRIVED_AT_DESTINATION: 'RETURN_EVENT_ARRIVED_AT_DESTINATION'
} as const

export type webhook_event_type = (typeof webhook_event_type)[keyof typeof webhook_event_type]


export const webhook_kind = {
  loop: 'loop',
  redo: 'redo'
} as const

export type webhook_kind = (typeof webhook_kind)[keyof typeof webhook_kind]


export const webhook_status = {
  active: 'active',
  disabled: 'disabled'
} as const

export type webhook_status = (typeof webhook_status)[keyof typeof webhook_status]


export const webhook_topic = {
  return: 'return',
  label: 'label'
} as const

export type webhook_topic = (typeof webhook_topic)[keyof typeof webhook_topic]


export const work_order_pick_line_status = {
  pending: 'pending',
  committed: 'committed',
  picked: 'picked',
  short_picked: 'short_picked'
} as const

export type work_order_pick_line_status = (typeof work_order_pick_line_status)[keyof typeof work_order_pick_line_status]


export const work_order_status = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled',
  cancellation_pending: 'cancellation_pending',
  wasted: 'wasted'
} as const

export type work_order_status = (typeof work_order_status)[keyof typeof work_order_status]


export const work_order_trigger_kind = {
  order: 'order',
  replenishment: 'replenishment',
  manual: 'manual',
  priority_bom: 'priority_bom'
} as const

export type work_order_trigger_kind = (typeof work_order_trigger_kind)[keyof typeof work_order_trigger_kind]


export const work_order_waste_reason = {
  damaged: 'damaged',
  qa_fail: 'qa_fail',
  other: 'other'
} as const

export type work_order_waste_reason = (typeof work_order_waste_reason)[keyof typeof work_order_waste_reason]


export const ReturnsProcessingEventType = {
  session_started: 'session_started',
  session_completed: 'session_completed',
  session_timeout: 'session_timeout',
  session_abandoned: 'session_abandoned',
  session_item_started: 'session_item_started',
  session_item_completed: 'session_item_completed',
  session_item_timeout: 'session_item_timeout',
  processing_step_started: 'processing_step_started',
  processing_step_completed: 'processing_step_completed',
  evidence_added: 'evidence_added'
} as const

export type ReturnsProcessingEventType = (typeof ReturnsProcessingEventType)[keyof typeof ReturnsProcessingEventType]


export const CheckoutSessionStatus = {
  NotReadyForPayment: 'NotReadyForPayment',
  ReadyForPayment: 'ReadyForPayment',
  Completed: 'Completed',
  Cancelled: 'Cancelled'
} as const

export type CheckoutSessionStatus = (typeof CheckoutSessionStatus)[keyof typeof CheckoutSessionStatus]


export const FulfillmentGroupType = {
  Shipping: 'Shipping',
  Pickup: 'Pickup',
  Digital: 'Digital'
} as const

export type FulfillmentGroupType = (typeof FulfillmentGroupType)[keyof typeof FulfillmentGroupType]


export const PaymentInstrumentType = {
  Card: 'Card',
  BankAccount: 'BankAccount',
  PayPal: 'PayPal',
  Affirm: 'Affirm'
} as const

export type PaymentInstrumentType = (typeof PaymentInstrumentType)[keyof typeof PaymentInstrumentType]


export const GshopListingStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  DISAPPROVED: 'DISAPPROVED',
  PENDING: 'PENDING'
} as const

export type GshopListingStatus = (typeof GshopListingStatus)[keyof typeof GshopListingStatus]


export const GshopProductFieldType = {
  title: 'title',
  description: 'description',
  brand: 'brand',
  google_product_category: 'google_product_category',
  product_type: 'product_type',
  link: 'link',
  custom_label_0: 'custom_label_0',
  custom_label_1: 'custom_label_1',
  custom_label_2: 'custom_label_2',
  custom_label_3: 'custom_label_3',
  custom_label_4: 'custom_label_4'
} as const

export type GshopProductFieldType = (typeof GshopProductFieldType)[keyof typeof GshopProductFieldType]


export const GshopVariantFieldType = {
  offer_id: 'offer_id',
  price: 'price',
  sale_price: 'sale_price',
  availability: 'availability',
  condition: 'condition',
  gtin: 'gtin',
  mpn: 'mpn',
  shipping_weight: 'shipping_weight',
  shipping_length: 'shipping_length',
  shipping_width: 'shipping_width',
  shipping_height: 'shipping_height',
  color: 'color',
  size: 'size',
  material: 'material',
  pattern: 'pattern',
  age_group: 'age_group',
  gender: 'gender'
} as const

export type GshopVariantFieldType = (typeof GshopVariantFieldType)[keyof typeof GshopVariantFieldType]


export const InventoryItemKind = {
  PRODUCT: 'PRODUCT',
  RETURN: 'RETURN',
  UNDECLARED: 'UNDECLARED',
  UNKNOWN: 'UNKNOWN'
} as const

export type InventoryItemKind = (typeof InventoryItemKind)[keyof typeof InventoryItemKind]


export const InventoryItemGrade = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E'
} as const

export type InventoryItemGrade = (typeof InventoryItemGrade)[keyof typeof InventoryItemGrade]


export const InventoryItemDisposition = {
  restock: 'restock',
  liquidate: 'liquidate',
  donate: 'donate',
  dispose: 'dispose',
  return_to_vendor: 'return_to_vendor'
} as const

export type InventoryItemDisposition = (typeof InventoryItemDisposition)[keyof typeof InventoryItemDisposition]


export const InventoryItemEventType = {
  restocked: 'restocked',
  picked: 'picked',
  shipped: 'shipped',
  committed: 'committed',
  released: 'released'
} as const

export type InventoryItemEventType = (typeof InventoryItemEventType)[keyof typeof InventoryItemEventType]


export const AttributeType = {
  short_text: 'short_text',
  list_short_text: 'list_short_text',
  long_text: 'long_text',
  rich_text: 'rich_text',
  json: 'json',
  date: 'date',
  datetime: 'datetime',
  integer: 'integer',
  float: 'float',
  boolean: 'boolean',
  enum: 'enum',
  product_category: 'product_category',
  hs_code: 'hs_code',
  weight: 'weight',
  money: 'money',
  dimension: 'dimension',
  volume: 'volume',
  link: 'link',
  color: 'color'
} as const

export type AttributeType = (typeof AttributeType)[keyof typeof AttributeType]


export const OwnerType = {
  product_family: 'product_family',
  product: 'product'
} as const

export type OwnerType = (typeof OwnerType)[keyof typeof OwnerType]


export const InventoryAdjustmentKind = {
  ReturnRestock: 'ReturnRestock',
  FulfillmentCreated: 'FulfillmentCreated',
  FulfillmentCancelled: 'FulfillmentCancelled',
  PurchaseOrderReceived: 'PurchaseOrderReceived',
  Manual: 'Manual',
  FulfillmentOrderCreated: 'FulfillmentOrderCreated',
  FulfillmentOrderCancelled: 'FulfillmentOrderCancelled',
  FulfillmentOrderEdited: 'FulfillmentOrderEdited',
  SotInitialization: 'SotInitialization',
  Unknown: 'Unknown',
  count: 'count',
  WmsTransfer: 'WmsTransfer'
} as const

export type InventoryAdjustmentKind = (typeof InventoryAdjustmentKind)[keyof typeof InventoryAdjustmentKind]


export const ProductSource = {
  Shopify: 'Shopify',
  BigCommerce: 'BigCommerce',
  CommentSold: 'CommentSold',
  CommerceCloud: 'CommerceCloud',
  Cin7Omni: 'Cin7Omni',
  Cin7Core: 'Cin7Core',
  Amazon: 'Amazon',
  ebay: 'ebay'
} as const

export type ProductSource = (typeof ProductSource)[keyof typeof ProductSource]


export const WeightUnit = {
  Gram: 'Gram',
  Kilogram: 'Kilogram',
  Ounce: 'Ounce',
  Pound: 'Pound',
  Tonne: 'Tonne'
} as const

export type WeightUnit = (typeof WeightUnit)[keyof typeof WeightUnit]


export const AdjustmentSessionKind = {
  Receive: 'Receive',
  Count: 'Count',
  Transfer: 'Transfer'
} as const

export type AdjustmentSessionKind = (typeof AdjustmentSessionKind)[keyof typeof AdjustmentSessionKind]


export const ExternalProductIdentifierType = {
  LPN: 'LPN'
} as const

export type ExternalProductIdentifierType = (typeof ExternalProductIdentifierType)[keyof typeof ExternalProductIdentifierType]


export const PurchaseOrderStatus = {
  DRAFT: 'DRAFT',
  ORDERED: 'ORDERED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED'
} as const

export type PurchaseOrderStatus = (typeof PurchaseOrderStatus)[keyof typeof PurchaseOrderStatus]


export const ShopifyProductFieldType = {
  category_id: 'category_id',
  title: 'title',
  description: 'description',
  vendor: 'vendor',
  product_type: 'product_type',
  handle: 'handle',
  seo_title: 'seo_title',
  seo_description: 'seo_description',
  metafield: 'metafield'
} as const

export type ShopifyProductFieldType = (typeof ShopifyProductFieldType)[keyof typeof ShopifyProductFieldType]


export const ShopifyVariantFieldType = {
  sku: 'sku',
  requires_shipping: 'requires_shipping',
  country_of_origin: 'country_of_origin',
  hs_code: 'hs_code',
  weight: 'weight',
  barcode: 'barcode',
  price: 'price',
  cost: 'cost',
  compare_at_price: 'compare_at_price',
  display_name: 'display_name',
  title: 'title',
  taxable: 'taxable',
  inventory_policy: 'inventory_policy',
  show_unit_price: 'show_unit_price',
  upm_measured_type: 'upm_measured_type',
  upm_quantity_unit: 'upm_quantity_unit',
  upm_quantity_value: 'upm_quantity_value',
  upm_reference_unit: 'upm_reference_unit',
  upm_reference_value: 'upm_reference_value',
  metafield: 'metafield',
  inventory_tracked: 'inventory_tracked'
} as const

export type ShopifyVariantFieldType = (typeof ShopifyVariantFieldType)[keyof typeof ShopifyVariantFieldType]


export const AmazonFulfillmentChannel = {
  AFN: 'AFN',
  MFN: 'MFN'
} as const

export type AmazonFulfillmentChannel = (typeof AmazonFulfillmentChannel)[keyof typeof AmazonFulfillmentChannel]


export const AmazonListingStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  INCOMPLETE: 'INCOMPLETE'
} as const

export type AmazonListingStatus = (typeof AmazonListingStatus)[keyof typeof AmazonListingStatus]


export const MarketplaceCartStatus = {
  active: 'active',
  pending: 'pending',
  submitted: 'submitted',
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  SUBMITTED: 'SUBMITTED'
} as const

export type MarketplaceCartStatus = (typeof MarketplaceCartStatus)[keyof typeof MarketplaceCartStatus]


export const EbayListingStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED'
} as const

export type EbayListingStatus = (typeof EbayListingStatus)[keyof typeof EbayListingStatus]


export const EbayProductFieldType = {
  title: 'title',
  description: 'description',
  condition: 'condition',
  price: 'price',
  brand: 'brand',
  category: 'category',
  aspect: 'aspect'
} as const

export type EbayProductFieldType = (typeof EbayProductFieldType)[keyof typeof EbayProductFieldType]


export const EbayVariantFieldType = {
  sku: 'sku',
  price: 'price',
  aspect: 'aspect'
} as const

export type EbayVariantFieldType = (typeof EbayVariantFieldType)[keyof typeof EbayVariantFieldType]


export const ListingDurationEnum = {
  GTC: 'GTC',
  DAYS_1: 'DAYS_1',
  DAYS_3: 'DAYS_3',
  DAYS_5: 'DAYS_5',
  DAYS_7: 'DAYS_7',
  DAYS_10: 'DAYS_10',
  DAYS_21: 'DAYS_21',
  DAYS_30: 'DAYS_30'
} as const

export type ListingDurationEnum = (typeof ListingDurationEnum)[keyof typeof ListingDurationEnum]


export const FormatEnum = {
  FIXED_PRICE: 'FIXED_PRICE',
  AUCTION: 'AUCTION'
} as const

export type FormatEnum = (typeof FormatEnum)[keyof typeof FormatEnum]


export const ConditionEnum = {
  NEW: 'NEW',
  USED: 'USED',
  REFURBISHED: 'REFURBISHED'
} as const

export type ConditionEnum = (typeof ConditionEnum)[keyof typeof ConditionEnum]


export const PoshmarkVariantTypeEnum = {
  PARENT: 'PARENT',
  CHILD: 'CHILD'
} as const

export type PoshmarkVariantTypeEnum = (typeof PoshmarkVariantTypeEnum)[keyof typeof PoshmarkVariantTypeEnum]


export const PoshmarkConditionEnum = {
  NWT: 'NWT'
} as const

export type PoshmarkConditionEnum = (typeof PoshmarkConditionEnum)[keyof typeof PoshmarkConditionEnum]


export const PoshmarkAvailabilityEnum = {
  FOR_SALE: 'FOR_SALE',
  NOT_FOR_SALE: 'NOT_FOR_SALE',
  DRAFT: 'DRAFT',
  DROPS: 'DROPS'
} as const

export type PoshmarkAvailabilityEnum = (typeof PoshmarkAvailabilityEnum)[keyof typeof PoshmarkAvailabilityEnum]


export const SyncSourceEnum = {
  SHOPIFY: 'SHOPIFY',
  POSHMARK: 'POSHMARK',
  EBAY: 'EBAY'
} as const

export type SyncSourceEnum = (typeof SyncSourceEnum)[keyof typeof SyncSourceEnum]


export const PoshmarkProductFieldType = {
  title: 'title',
  description: 'description',
  department: 'department',
  category: 'category',
  brand: 'brand',
  condition: 'condition',
  color1: 'color1',
  color2: 'color2',
  style_tags: 'style_tags'
} as const

export type PoshmarkProductFieldType = (typeof PoshmarkProductFieldType)[keyof typeof PoshmarkProductFieldType]


export const PoshmarkVariantFieldType = {
  sku: 'sku',
  size: 'size',
  upc: 'upc',
  original_price: 'original_price',
  listing_price: 'listing_price',
  availability: 'availability',
  variant_group_id: 'variant_group_id',
  variant_type: 'variant_type',
  variant_attribute: 'variant_attribute'
} as const

export type PoshmarkVariantFieldType = (typeof PoshmarkVariantFieldType)[keyof typeof PoshmarkVariantFieldType]


export const VendorAccessLevel = {
  CAMPAIGN: 'CAMPAIGN',
  MARKETPLACE: 'MARKETPLACE'
} as const

export type VendorAccessLevel = (typeof VendorAccessLevel)[keyof typeof VendorAccessLevel]


export const RedoMarketplaceProductFieldType = {
  title: 'title',
  description: 'description',
  vendor: 'vendor',
  price: 'price'
} as const

export type RedoMarketplaceProductFieldType = (typeof RedoMarketplaceProductFieldType)[keyof typeof RedoMarketplaceProductFieldType]


export const RedoMarketplaceVariantFieldType = {
  sku: 'sku',
  price: 'price',
  title: 'title',
  compare_at_price: 'compare_at_price'
} as const

export type RedoMarketplaceVariantFieldType = (typeof RedoMarketplaceVariantFieldType)[keyof typeof RedoMarketplaceVariantFieldType]


export const SellerAgreementStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  EXPIRED: 'EXPIRED',
  TERMINATED: 'TERMINATED'
} as const

export type SellerAgreementStatus = (typeof SellerAgreementStatus)[keyof typeof SellerAgreementStatus]


export const SellerAgreementChannel = {
  REDO: 'REDO',
  EBAY: 'EBAY',
  POSHMARK: 'POSHMARK'
} as const

export type SellerAgreementChannel = (typeof SellerAgreementChannel)[keyof typeof SellerAgreementChannel]


export const CatalogSource = {
  Shopify: 'Shopify',
  Ebay: 'Ebay',
  Poshmark: 'Poshmark'
} as const

export type CatalogSource = (typeof CatalogSource)[keyof typeof CatalogSource]


export const ShopifyListingStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED',
  UNLISTED: 'UNLISTED'
} as const

export type ShopifyListingStatus = (typeof ShopifyListingStatus)[keyof typeof ShopifyListingStatus]


export const ShopifyMediaType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  EXTERNAL_VIDEO: 'EXTERNAL_VIDEO',
  MODEL_3D: 'MODEL_3D'
} as const

export type ShopifyMediaType = (typeof ShopifyMediaType)[keyof typeof ShopifyMediaType]


export const ReturnIntegrationProvider = {
  aims360: 'aims360',
  apparelmagic: 'apparelmagic',
  blueyonder: 'blueyonder',
  brightpearl: 'brightpearl',
  cloudx: 'cloudx',
  flexport: 'flexport',
  inmar: 'inmar',
  netsuite: 'netsuite',
  returnbear: 'returnbear',
  sfom: 'sfom',
  shipbob: 'shipbob',
  shiphero: 'shiphero',
  trackstar: 'trackstar'
} as const

export type ReturnIntegrationProvider = (typeof ReturnIntegrationProvider)[keyof typeof ReturnIntegrationProvider]


export const ReturnsProcessingItemStatus = {
  pending: 'pending',
  received: 'received',
  missing: 'missing',
  processed: 'processed'
} as const

export type ReturnsProcessingItemStatus = (typeof ReturnsProcessingItemStatus)[keyof typeof ReturnsProcessingItemStatus]


export const conversation_status = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  SNOOZED: 'SNOOZED',
  IN_PROGRESS: 'IN_PROGRESS',
  HIDDEN: 'HIDDEN',
  ARCHIVED: 'ARCHIVED',
  DELETED: 'DELETED'
} as const

export type conversation_status = (typeof conversation_status)[keyof typeof conversation_status]


export const conversation_priority = {
  URGENT: 'URGENT'
} as const

export type conversation_priority = (typeof conversation_priority)[keyof typeof conversation_priority]


export const conversation_mode = {
  DEMO: 'DEMO',
  LOCAL: 'LOCAL',
  PROD: 'PROD'
} as const

export type conversation_mode = (typeof conversation_mode)[keyof typeof conversation_mode]


export const conversation_customer_sentiment = {
  POSITIVE: 'POSITIVE',
  NEUTRAL: 'NEUTRAL',
  NEGATIVE: 'NEGATIVE'
} as const

export type conversation_customer_sentiment = (typeof conversation_customer_sentiment)[keyof typeof conversation_customer_sentiment]


export const conversation_assignee_summary = {
  AI_AGENT_HANDLED: 'AI_AGENT_HANDLED',
  MERCHANT_HANDLED: 'MERCHANT_HANDLED',
  AI_AGENT_HANDOFF_TO_HUMAN: 'AI_AGENT_HANDOFF_TO_HUMAN',
  AI_AGENT_HANDOFF_TO_IGNORED: 'AI_AGENT_HANDOFF_TO_IGNORED',
  MERCHANT_IGNORED: 'MERCHANT_IGNORED'
} as const

export type conversation_assignee_summary = (typeof conversation_assignee_summary)[keyof typeof conversation_assignee_summary]


export const conversation_billing_type = {
  AI_BUCKETED: 'AI_BUCKETED',
  BASE_BUCKETED: 'BASE_BUCKETED',
  AI_FIXED: 'AI_FIXED',
  BASE_FIXED: 'BASE_FIXED'
} as const

export type conversation_billing_type = (typeof conversation_billing_type)[keyof typeof conversation_billing_type]


export const message_channel = {
  gmail: 'gmail',
  outlook: 'outlook',
  redoChat: 'redoChat',
  facebook: 'facebook',
  facebookComments: 'facebookComments',
  instagram: 'instagram',
  instagramComments: 'instagramComments',
  sms: 'sms',
  voice: 'voice',
  attentive: 'attentive',
  postscript: 'postscript',
  tiktok: 'tiktok',
  contactForm: 'contactForm',
  internalNote: 'internalNote'
} as const

export type message_channel = (typeof message_channel)[keyof typeof message_channel]


export const message_origin = {
  external: 'external',
  internal: 'internal'
} as const

export type message_origin = (typeof message_origin)[keyof typeof message_origin]


export const message_email_address_type = {
  from: 'from',
  to: 'to',
  cc: 'cc',
  bcc: 'bcc'
} as const

export type message_email_address_type = (typeof message_email_address_type)[keyof typeof message_email_address_type]


export const message_instagram_comment_state = {
  normal: 'normal',
  deleted: 'deleted',
  hidden: 'hidden',
  edited: 'edited'
} as const

export type message_instagram_comment_state = (typeof message_instagram_comment_state)[keyof typeof message_instagram_comment_state]


export const message_redo_chat_confirmation_state = {
  pending: 'pending',
  confirmed: 'confirmed',
  rejected: 'rejected'
} as const

export type message_redo_chat_confirmation_state = (typeof message_redo_chat_confirmation_state)[keyof typeof message_redo_chat_confirmation_state]


export const message_sms_kind = {
  number: 'number',
  attentive: 'attentive',
  postscript: 'postscript',
  imessage_gateway: 'imessage_gateway'
} as const

export type message_sms_kind = (typeof message_sms_kind)[keyof typeof message_sms_kind]


export const message_sms_service = {
  SMS: 'SMS',
  MMS: 'MMS',
  RCS: 'RCS',
  iMessage: 'iMessage'
} as const

export type message_sms_service = (typeof message_sms_service)[keyof typeof message_sms_service]


export const shopper_ai_integration_type = {
  gmail: 'gmail',
  outlook: 'outlook',
  instagram: 'instagram',
  facebook: 'facebook',
  tiktok: 'tiktok',
  attentive: 'attentive',
  postscript: 'postscript',
  redoChatAi: 'redoChatAi',
  redoChatFlow: 'redoChatFlow',
  redoChatLive: 'redoChatLive'
} as const

export type shopper_ai_integration_type = (typeof shopper_ai_integration_type)[keyof typeof shopper_ai_integration_type]


export const conversation_thread_analytics_handoff_source = {
  tool_call: 'tool_call',
  handoff_detection: 'handoff_detection'
} as const

export type conversation_thread_analytics_handoff_source = (typeof conversation_thread_analytics_handoff_source)[keyof typeof conversation_thread_analytics_handoff_source]


export const message_instagram_comment_attribute = {
  has_been_replied_to: 'has_been_replied_to',
  liked: 'liked'
} as const

export type message_instagram_comment_attribute = (typeof message_instagram_comment_attribute)[keyof typeof message_instagram_comment_attribute]


export const message_meta_comment_attribute = {
  has_been_replied_to: 'has_been_replied_to',
  liked: 'liked'
} as const

export type message_meta_comment_attribute = (typeof message_meta_comment_attribute)[keyof typeof message_meta_comment_attribute]


export const message_meta_comment_state = {
  normal: 'normal',
  deleted: 'deleted',
  hidden: 'hidden',
  edited: 'edited'
} as const

export type message_meta_comment_state = (typeof message_meta_comment_state)[keyof typeof message_meta_comment_state]


export const message_meta_comment_type = {
  facebook: 'facebook',
  instagram: 'instagram'
} as const

export type message_meta_comment_type = (typeof message_meta_comment_type)[keyof typeof message_meta_comment_type]


export const thread_product_analytics_type = {
  PDP_INTERACTION: 'PDP_INTERACTION',
  SUGGESTED_PRODUCT: 'SUGGESTED_PRODUCT',
  ADDED_TO_CART: 'ADDED_TO_CART',
  BACK_IN_STOCK_SUBSCRIPTION: 'BACK_IN_STOCK_SUBSCRIPTION'
} as const

export type thread_product_analytics_type = (typeof thread_product_analytics_type)[keyof typeof thread_product_analytics_type]


export const time_based_integration_sync_direction = {
  forward: 'forward',
  backward: 'backward'
} as const

export type time_based_integration_sync_direction = (typeof time_based_integration_sync_direction)[keyof typeof time_based_integration_sync_direction]
